<template>
    <div :class="containerClass">
        <!-- ALERT OR BELL RINGING ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'alert' || icon === 'bell-ringing'"
        >
            <path
                d="M15.2495 7.49377L14.4173 7.53539L15.2495 7.49377ZM4.75017 7.49377L5.58246 7.53539L4.75017 7.49377ZM3.40437 13.191L4.14972 13.5637L3.40437 13.191ZM15.3991 10.484L16.2314 10.4424L15.3991 10.484ZM4.60066 10.484L3.76836 10.4424L4.60066 10.484ZM4.42678 11.1462L3.68142 10.7735L4.42678 11.1462ZM0.63701 5.86426C0.538857 6.31391 0.823801 6.75799 1.27345 6.85614C1.7231 6.95429 2.16718 6.66935 2.26533 6.2197L0.63701 5.86426ZM3.93654 2.82623C4.23266 2.47391 4.18711 1.94824 3.8348 1.65211C3.48248 1.35599 2.95681 1.40154 2.66068 1.75385L3.93654 2.82623ZM17.3391 1.75385C17.0429 1.40154 16.5173 1.35599 16.165 1.65211C15.8126 1.94824 15.7671 2.47391 16.0632 2.82623L17.3391 1.75385ZM17.7344 6.2197C17.8326 6.66935 18.2766 6.95429 18.7263 6.85614C19.1759 6.75799 19.4609 6.31391 19.3627 5.86426L17.7344 6.2197ZM12.4999 14.1667C12.4999 15.5474 11.3806 16.6667 9.99986 16.6667V18.3333C12.301 18.3333 14.1665 16.4679 14.1665 14.1667H12.4999ZM9.99986 16.6667C8.61915 16.6667 7.49986 15.5474 7.49986 14.1667H5.83319C5.83319 16.4679 7.69867 18.3333 9.99986 18.3333V16.6667ZM4.00737 15H15.9923V13.3333H4.00737V15ZM17.3407 12.8183L16.3183 10.7735L14.8276 11.5188L15.85 13.5637L17.3407 12.8183ZM16.2314 10.4424L16.0818 7.45216L14.4173 7.53539L14.5668 10.5257L16.2314 10.4424ZM3.91788 7.45216L3.76836 10.4424L5.43295 10.5257L5.58246 7.53539L3.91788 7.45216ZM3.68142 10.7735L2.65901 12.8183L4.14972 13.5637L5.17214 11.5188L3.68142 10.7735ZM9.99986 1.66668C6.75488 1.66668 4.07992 4.21123 3.91788 7.45216L5.58246 7.53539C5.70016 5.18147 7.643 3.33335 9.99986 3.33335V1.66668ZM16.0818 7.45216C15.9198 4.21123 13.2448 1.66668 9.99986 1.66668V3.33335C12.3567 3.33335 14.2996 5.18147 14.4173 7.53539L16.0818 7.45216ZM2.65901 12.8183C2.55435 13.0276 2.49986 13.2585 2.49986 13.4925H4.16652C4.16652 13.5172 4.16077 13.5416 4.14972 13.5637L2.65901 12.8183ZM16.3183 10.7735C16.2667 10.6703 16.2371 10.5576 16.2314 10.4424L14.5668 10.5257C14.584 10.8712 14.6729 11.2094 14.8276 11.5188L16.3183 10.7735ZM17.4999 13.4925C17.4999 13.2585 17.4454 13.0276 17.3407 12.8183L15.85 13.5637C15.8389 13.5416 15.8332 13.5172 15.8332 13.4925H17.4999ZM3.76836 10.4424C3.7626 10.5576 3.733 10.6703 3.68142 10.7735L5.17214 11.5188C5.32686 11.2094 5.41567 10.8712 5.43295 10.5257L3.76836 10.4424ZM15.9923 15C16.8249 15 17.4999 14.3251 17.4999 13.4925H15.8332C15.8332 13.4046 15.9044 13.3333 15.9923 13.3333V15ZM4.00737 13.3333C4.09527 13.3333 4.16652 13.4046 4.16652 13.4925H2.49986C2.49986 14.3251 3.17479 15 4.00737 15V13.3333ZM2.26533 6.2197C2.54293 4.94801 3.12663 3.78981 3.93654 2.82623L2.66068 1.75385C1.68139 2.91896 0.973706 4.32182 0.63701 5.86426L2.26533 6.2197ZM16.0632 2.82623C16.8731 3.78981 17.4568 4.94801 17.7344 6.2197L19.3627 5.86426C19.026 4.32182 18.3184 2.91896 17.3391 1.75385L16.0632 2.82623Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- SPEECH BUBBLE / CHAT ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            v-if="icon === 'speech-bubble' || icon === 'chat'"
        >
            <path
                d="M6.66667 15H4.16667C3.24619 15 2.5 14.2538 2.5 13.3333V5C2.5 4.07953 3.24619 3.33333 4.16667 3.33333H15.8333C16.7538 3.33333 17.5 4.07953 17.5 5V13.3333C17.5 14.2538 16.7538 15 15.8333 15H10.8333L6.66667 18.3333V15Z"
                stroke="currentColor"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- SEARCH OR MAGNIFYING GLASS ICON -->
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'search' || icon === 'magnifying-glass'"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.16569 4.16667C6.40427 4.16667 4.16569 6.40524 4.16569 9.16667C4.16569 11.9281 6.40427 14.1667 9.16569 14.1667C11.9271 14.1667 14.1657 11.9281 14.1657 9.16667C14.1657 6.40524 11.9271 4.16667 9.16569 4.16667ZM2.49902 9.16667C2.49902 5.48477 5.48379 2.5 9.16569 2.5C12.8476 2.5 15.8324 5.48477 15.8324 9.16667C15.8324 10.7073 15.3098 12.1258 14.4322 13.2547L17.2549 16.0774C17.5804 16.4028 17.5804 16.9305 17.2549 17.2559C16.9295 17.5813 16.4019 17.5813 16.0764 17.2559L13.2537 14.4332C12.1248 15.3108 10.7063 15.8333 9.16569 15.8333C5.48379 15.8333 2.49902 12.8486 2.49902 9.16667Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- BELL or BELL OUTLINE ICON -->
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'bell' || icon === 'bell-outline'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.70162 8.93989C4.89608 5.05077 8.10602 1.99731 12 1.99731C15.894 1.99731 19.1039 5.05077 19.2984 8.93989L19.4778 12.5282C19.4847 12.6664 19.5202 12.8017 19.5821 12.9255L20.809 15.3793C20.9346 15.6305 21 15.9075 21 16.1883C21 17.1874 20.1901 17.9973 19.191 17.9973H16.9C16.4367 20.2796 14.419 21.9973 12 21.9973C9.58104 21.9973 7.56329 20.2796 7.10002 17.9973H4.80902C3.80992 17.9973 3 17.1874 3 16.1883C3 15.9075 3.06539 15.6305 3.19098 15.3793L4.41788 12.9255C4.47977 12.8017 4.5153 12.6664 4.52221 12.5282L4.70162 8.93989ZM9.17071 17.9973C9.58254 19.1625 10.6938 19.9973 12 19.9973C13.3062 19.9973 14.4175 19.1625 14.8293 17.9973H9.17071ZM12 3.99731C9.17177 3.99731 6.84036 6.21507 6.69913 9.03977L6.51971 12.6281C6.49898 13.0427 6.39241 13.4486 6.20674 13.8199L5.11803 15.9973H18.882L17.7933 13.8199C17.6076 13.4486 17.501 13.0427 17.4803 12.6281L17.3009 9.03977C17.1596 6.21507 14.8282 3.99731 12 3.99731Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- CLOCK ICON -->

        <svg
            v-if="icon === 'clock'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0003 3.33464C6.31843 3.33464 3.33366 6.3194 3.33366 10.0013C3.33366 13.6832 6.31843 16.668 10.0003 16.668C13.6822 16.668 16.667 13.6832 16.667 10.0013C16.667 6.3194 13.6822 3.33464 10.0003 3.33464ZM1.66699 10.0013C1.66699 5.39893 5.39795 1.66797 10.0003 1.66797C14.6027 1.66797 18.3337 5.39893 18.3337 10.0013C18.3337 14.6037 14.6027 18.3346 10.0003 18.3346C5.39795 18.3346 1.66699 14.6037 1.66699 10.0013ZM10.0003 5.83464C10.4606 5.83464 10.8337 6.20773 10.8337 6.66797V9.65612L12.6729 11.4954C12.9984 11.8208 12.9984 12.3485 12.6729 12.6739C12.3475 12.9993 11.8198 12.9993 11.4944 12.6739L9.41107 10.5906C9.25479 10.4343 9.16699 10.2223 9.16699 10.0013V6.66797C9.16699 6.20773 9.54009 5.83464 10.0003 5.83464Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- CLOSE or X ICON -->
        <svg
            v-if="icon === 'close' || icon === 'x'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.1665 4.16663L15.8332 15.8333M15.8332 4.16663L4.1665 15.8333"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                :class="pathClass"
            />
        </svg>

        <!-- FILTERS ICON -->
        <svg
            v-if="icon === 'filters'"
            :class="svgClass"
            :width="width || 20"
            :height="height || 20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.9383 4.99976C11.3081 3.56177 12.6129 2.49976 14.1667 2.49976C16.0082 2.49976 17.5 3.9916 17.5 5.83309C17.5 7.67458 16.0082 9.16642 14.1667 9.16642C12.6129 9.16642 11.3081 8.10441 10.9383 6.66642H3.33333C2.8731 6.66642 2.5 6.29333 2.5 5.83309C2.5 5.37285 2.8731 4.99976 3.33333 4.99976H10.9383ZM14.1667 4.16642C13.2457 4.16642 12.5 4.91208 12.5 5.83309C12.5 6.7541 13.2457 7.49976 14.1667 7.49976C15.0877 7.49976 15.8333 6.7541 15.8333 5.83309C15.8333 4.91208 15.0877 4.16642 14.1667 4.16642ZM4.2716 13.3331C4.64147 11.8951 5.94628 10.8331 7.5 10.8331C9.05372 10.8331 10.3585 11.8951 10.7284 13.3331H16.6667C17.1269 13.3331 17.5 13.7062 17.5 14.1664C17.5 14.6267 17.1269 14.9998 16.6667 14.9998H10.7284C10.3585 16.4377 9.05372 17.4998 7.5 17.4998C5.94628 17.4998 4.64147 16.4377 4.2716 14.9998H3.33333C2.8731 14.9998 2.5 14.6267 2.5 14.1664C2.5 13.7062 2.8731 13.3331 3.33333 13.3331H4.2716ZM7.5 12.4998C6.57899 12.4998 5.83333 13.2454 5.83333 14.1664C5.83333 15.0874 6.57899 15.8331 7.5 15.8331C8.42101 15.8331 9.16667 15.0874 9.16667 14.1664C9.16667 13.2454 8.42101 12.4998 7.5 12.4998Z"
                fill="#currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- HEART OR FAVORITE ICON -->
        <svg
            v-if="icon === 'heart' || icon === 'favorite'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                d="M12 6.26835C18.1619 0.0181631 28.7252 11.6257 12 21C-4.72523 11.6257 5.83803 0.0181617 12 6.26835Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>

        <!-- HOLLOW/UNFAVORITED HEART ICON -->
        <svg
            v-if="icon === 'heart-hollow' || icon === 'unfavorited'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.9445 4.65977C12.9127 4.42972 11.688 4.69848 10.593 5.80916C10.4364 5.96801 10.2226 6.05744 9.99954 6.05744C9.77647 6.05744 9.56272 5.96801 9.40611 5.80916C8.31111 4.69848 7.08633 4.42972 6.05459 4.65977C5.00214 4.89443 4.07204 5.66456 3.62075 6.78983C2.77435 8.9003 3.54344 12.7836 9.99958 16.5409C16.4557 12.7836 17.2247 8.90029 16.3783 6.78983C15.927 5.66455 14.9969 4.89443 13.9445 4.65977ZM17.9252 6.16944C19.262 9.5027 17.5136 14.2442 10.407 18.2274C10.1539 18.3693 9.84524 18.3693 9.59214 18.2274C2.48552 14.2443 0.737055 9.50272 2.07385 6.16945C2.72289 4.55106 4.08517 3.3913 5.69188 3.03305C7.10648 2.71764 8.65236 3.03551 9.99954 4.10493C11.3467 3.03551 12.8926 2.71764 14.3072 3.03305C15.9139 3.39129 17.2762 4.55105 17.9252 6.16944Z"
                fill="currentColor"
            />
        </svg>

        <!-- HOTEL or BUILDING ICON -->
        <svg
            v-if="icon === 'building' || icon === 'hotel'"
            :width="height"
            :height="height"
            viewBox="0 0 20 20"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.16667 16.6693V5.0026C4.16667 4.08213 4.91286 3.33594 5.83333 3.33594H14.1667C15.0871 3.33594 15.8333 4.08213 15.8333 5.0026V16.6693M4.16667 16.6693H15.8333M4.16667 16.6693H2.5M15.8333 16.6693H17.5M7.5 6.66927H8.33333M11.6667 6.66927H12.5M7.5 10.0026H8.33333M11.6667 10.0026H12.5M7.5 13.3359H8.33333M11.6667 13.3359H12.5"
                class="stroke-current"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- CALENDAR ICON -->
        <svg
            v-if="icon === 'calendar'"
            :width="width"
            :height="width"
            viewBox="0 0 20 20"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.9987 4.16732H14.9987V2.50065H4.9987V4.16732ZM15.832 5.00065V6.66732H17.4987V5.00065H15.832ZM15.832 6.66732V15.0007H17.4987V6.66732H15.832ZM14.9987 15.834H4.9987V17.5007H14.9987V15.834ZM4.16536 15.0007V6.66732H2.4987V15.0007H4.16536ZM4.16536 6.66732V5.00065H2.4987V6.66732H4.16536ZM3.33203 7.50065H16.6654V5.83398H3.33203V7.50065ZM6.04037 10.0007C6.04037 9.65551 6.32019 9.37569 6.66537 9.37569V11.0424C7.24066 11.0424 7.70703 10.576 7.70703 10.0007H6.04037ZM6.66537 9.37569C7.01055 9.37569 7.29037 9.65551 7.29037 10.0007H5.6237C5.6237 10.576 6.09007 11.0424 6.66537 11.0424V9.37569ZM7.29037 10.0007C7.29037 10.3459 7.01055 10.6257 6.66537 10.6257V8.95902C6.09007 8.95902 5.6237 9.42539 5.6237 10.0007H7.29037ZM6.66537 10.6257C6.32019 10.6257 6.04037 10.3459 6.04037 10.0007H7.70703C7.70703 9.42539 7.24066 8.95902 6.66537 8.95902V10.6257ZM5.83203 9.79235V10.209H7.4987V9.79235H5.83203ZM6.8737 9.16735H6.45703V10.834H6.8737V9.16735ZM6.12413 10.3132C5.95155 10.0143 6.05396 9.63201 6.3529 9.45942L7.18623 10.9028C7.68446 10.6151 7.85516 9.97807 7.56751 9.47985L6.12413 10.3132ZM6.3529 9.45942C6.65183 9.28683 7.03408 9.38925 7.20667 9.68819L5.76329 10.5215C6.05094 11.0197 6.68801 11.1904 7.18623 10.9028L6.3529 9.45942ZM7.20667 9.68819C7.37925 9.98712 7.27683 10.3694 6.9779 10.542L6.14457 9.09858C5.64635 9.38622 5.47564 10.0233 5.76329 10.5215L7.20667 9.68819ZM6.9779 10.542C6.67897 10.7145 6.29672 10.6121 6.12413 10.3132L7.56751 9.47985C7.27986 8.98163 6.64279 8.81093 6.14457 9.09858L6.9779 10.542ZM5.83955 10.2369L6.04788 10.5978L7.49125 9.76444L7.28292 9.4036L5.83955 10.2369ZM6.42915 9.17483L6.06831 9.38317L6.90164 10.8265L7.26249 10.6182L6.42915 9.17483ZM6.35293 10.542C6.054 10.3694 5.95158 9.98713 6.12417 9.6882L7.56754 10.5215C7.85519 10.0233 7.68449 9.38624 7.18626 9.09859L6.35293 10.542ZM6.12417 9.6882C6.29675 9.38927 6.67899 9.28684 6.97793 9.45943L6.1446 10.9028C6.64282 11.1905 7.27989 11.0197 7.56754 10.5215L6.12417 9.6882ZM6.97793 9.45943C7.27686 9.63202 7.37929 10.0143 7.2067 10.3132L5.76332 9.47987C5.47567 9.97809 5.64638 10.6152 6.1446 10.9028L6.97793 9.45943ZM7.2067 10.3132C7.03411 10.6121 6.65186 10.7146 6.35293 10.542L7.18626 9.09859C6.68804 8.81094 6.05097 8.98164 5.76332 9.47987L7.2067 10.3132ZM6.06834 10.6182L6.42919 10.8266L7.26252 9.38318L6.90168 9.17484L6.06834 10.6182ZM6.04791 9.40361L5.83958 9.76445L7.28295 10.5978L7.49129 10.2369L6.04791 9.40361ZM6.04037 13.334C6.04037 12.9888 6.32019 12.709 6.66537 12.709V14.3757C7.24066 14.3757 7.70703 13.9093 7.70703 13.334H6.04037ZM6.66537 12.709C7.01055 12.709 7.29037 12.9888 7.29037 13.334H5.6237C5.6237 13.9093 6.09007 14.3757 6.66537 14.3757V12.709ZM7.29037 13.334C7.29037 13.6792 7.01055 13.959 6.66537 13.959V12.2924C6.09007 12.2924 5.6237 12.7587 5.6237 13.334H7.29037ZM6.66537 13.959C6.32019 13.959 6.04037 13.6792 6.04037 13.334H7.70703C7.70703 12.7587 7.24066 12.2924 6.66537 12.2924V13.959ZM5.83203 13.1257V13.5424H7.4987V13.1257H5.83203ZM6.8737 12.5007H6.45703V14.1674H6.8737V12.5007ZM6.12413 13.6465C5.95155 13.3476 6.05397 12.9653 6.3529 12.7928L7.18623 14.2361C7.68446 13.9485 7.85516 13.3114 7.56751 12.8132L6.12413 13.6465ZM6.3529 12.7928C6.65183 12.6202 7.03408 12.7226 7.20667 13.0215L5.76329 13.8549C6.05094 14.3531 6.68801 14.5238 7.18623 14.2361L6.3529 12.7928ZM7.20667 13.0215C7.37925 13.3205 7.27683 13.7027 6.9779 13.8753L6.14457 12.4319C5.64634 12.7196 5.47564 13.3566 5.76329 13.8549L7.20667 13.0215ZM6.9779 13.8753C6.67896 14.0479 6.29672 13.9454 6.12413 13.6465L7.56751 12.8132C7.27986 12.315 6.64279 12.1443 6.14457 12.4319L6.9779 13.8753ZM5.83954 13.5703L6.04788 13.9311L7.49125 13.0978L7.28292 12.7369L5.83954 13.5703ZM6.42915 12.5082L6.06831 12.7165L6.90164 14.1599L7.26249 13.9515L6.42915 12.5082ZM6.35293 13.8753C6.054 13.7027 5.95158 13.3205 6.12417 13.0215L7.56754 13.8549C7.85519 13.3566 7.68449 12.7196 7.18626 12.4319L6.35293 13.8753ZM6.12417 13.0215C6.29675 12.7226 6.67899 12.6202 6.97793 12.7928L6.1446 14.2361C6.64282 14.5238 7.27989 14.3531 7.56754 13.8549L6.12417 13.0215ZM6.97793 12.7928C7.27686 12.9654 7.37929 13.3476 7.2067 13.6465L5.76332 12.8132C5.47567 13.3114 5.64638 13.9485 6.1446 14.2361L6.97793 12.7928ZM7.2067 13.6465C7.03411 13.9455 6.65186 14.0479 6.35293 13.8753L7.18626 12.4319C6.68805 12.1443 6.05097 12.315 5.76332 12.8132L7.2067 13.6465ZM6.06834 13.9516L6.42919 14.1599L7.26252 12.7165L6.90168 12.5082L6.06834 13.9516ZM6.04791 12.7369L5.83958 13.0978L7.28295 13.9311L7.49129 13.5703L6.04791 12.7369ZM9.3737 13.334C9.3737 12.9888 9.65352 12.709 9.9987 12.709V14.3757C10.574 14.3757 11.0404 13.9093 11.0404 13.334H9.3737ZM9.9987 12.709C10.3439 12.709 10.6237 12.9888 10.6237 13.334H8.95703C8.95703 13.9093 9.4234 14.3757 9.9987 14.3757V12.709ZM10.6237 13.334C10.6237 13.6792 10.3439 13.959 9.9987 13.959V12.2924C9.4234 12.2924 8.95703 12.7587 8.95703 13.334H10.6237ZM9.9987 13.959C9.65352 13.959 9.3737 13.6792 9.3737 13.334H11.0404C11.0404 12.7587 10.574 12.2924 9.9987 12.2924V13.959ZM9.16537 13.1257V13.5424H10.832V13.1257H9.16537ZM10.207 12.5007H9.79037V14.1674H10.207V12.5007ZM9.45747 13.6465C9.28488 13.3476 9.3873 12.9653 9.68623 12.7928L10.5196 14.2361C11.0178 13.9485 11.1885 13.3114 10.9008 12.8132L9.45747 13.6465ZM9.68623 12.7928C9.98516 12.6202 10.3674 12.7226 10.54 13.0215L9.09662 13.8549C9.38427 14.3531 10.0213 14.5238 10.5196 14.2361L9.68623 12.7928ZM10.54 13.0215C10.7126 13.3205 10.6102 13.7027 10.3112 13.8753L9.4779 12.4319C8.97968 12.7196 8.80897 13.3566 9.09662 13.8549L10.54 13.0215ZM10.3112 13.8753C10.0123 14.0479 9.63005 13.9454 9.45747 13.6465L10.9008 12.8132C10.6132 12.315 9.97612 12.1443 9.4779 12.4319L10.3112 13.8753ZM9.17288 13.5703L9.38121 13.9311L10.8246 13.0978L10.6163 12.7369L9.17288 13.5703ZM9.76249 12.5082L9.40164 12.7165L10.235 14.1599L10.5958 13.9515L9.76249 12.5082ZM9.68626 13.8753C9.38733 13.7027 9.28491 13.3205 9.4575 13.0215L10.9009 13.8549C11.1885 13.3566 11.0178 12.7196 10.5196 12.4319L9.68626 13.8753ZM9.4575 13.0215C9.63009 12.7226 10.0123 12.6202 10.3113 12.7928L9.47793 14.2361C9.97616 14.5238 10.6132 14.3531 10.9009 13.8549L9.4575 13.0215ZM10.3113 12.7928C10.6102 12.9654 10.7126 13.3476 10.54 13.6465L9.09665 12.8132C8.80901 13.3114 8.97971 13.9485 9.47793 14.2361L10.3113 12.7928ZM10.54 13.6465C10.3674 13.9455 9.9852 14.0479 9.68626 13.8753L10.5196 12.4319C10.0214 12.1443 9.3843 12.315 9.09665 12.8132L10.54 13.6465ZM9.40168 13.9516L9.76252 14.1599L10.5959 12.7165L10.235 12.5082L9.40168 13.9516ZM9.38124 12.7369L9.17291 13.0978L10.6163 13.9311L10.8246 13.5703L9.38124 12.7369ZM9.3737 10.0007C9.3737 9.65551 9.65352 9.37569 9.9987 9.37569V11.0424C10.574 11.0424 11.0404 10.576 11.0404 10.0007H9.3737ZM9.9987 9.37569C10.3439 9.37569 10.6237 9.65551 10.6237 10.0007H8.95703C8.95703 10.576 9.4234 11.0424 9.9987 11.0424V9.37569ZM10.6237 10.0007C10.6237 10.3459 10.3439 10.6257 9.9987 10.6257V8.95902C9.4234 8.95902 8.95703 9.42539 8.95703 10.0007H10.6237ZM9.9987 10.6257C9.65352 10.6257 9.3737 10.3459 9.3737 10.0007H11.0404C11.0404 9.42539 10.574 8.95902 9.9987 8.95902V10.6257ZM9.16537 9.79235V10.209H10.832V9.79235H9.16537ZM10.207 9.16735H9.79037V10.834H10.207V9.16735ZM9.45747 10.3132C9.28488 10.0143 9.3873 9.63201 9.68623 9.45942L10.5196 10.9028C11.0178 10.6151 11.1885 9.97807 10.9008 9.47985L9.45747 10.3132ZM9.68623 9.45942C9.98516 9.28683 10.3674 9.38925 10.54 9.68819L9.09662 10.5215C9.38427 11.0197 10.0213 11.1904 10.5196 10.9028L9.68623 9.45942ZM10.54 9.68819C10.7126 9.98712 10.6102 10.3694 10.3112 10.542L9.4779 9.09858C8.97968 9.38622 8.80897 10.0233 9.09662 10.5215L10.54 9.68819ZM10.3112 10.542C10.0123 10.7145 9.63006 10.6121 9.45747 10.3132L10.9008 9.47985C10.6132 8.98163 9.97612 8.81093 9.4779 9.09858L10.3112 10.542ZM9.17288 10.2369L9.38121 10.5978L10.8246 9.76444L10.6163 9.4036L9.17288 10.2369ZM9.76249 9.17483L9.40164 9.38317L10.235 10.8265L10.5958 10.6182L9.76249 9.17483ZM9.68626 10.542C9.38733 10.3694 9.28491 9.98713 9.4575 9.6882L10.9009 10.5215C11.1885 10.0233 11.0178 9.38624 10.5196 9.09859L9.68626 10.542ZM9.4575 9.6882C9.63009 9.38927 10.0123 9.28684 10.3113 9.45943L9.47793 10.9028C9.97616 11.1905 10.6132 11.0197 10.9009 10.5215L9.4575 9.6882ZM10.3113 9.45943C10.6102 9.63202 10.7126 10.0143 10.54 10.3132L9.09665 9.47987C8.80901 9.97809 8.97971 10.6152 9.47793 10.9028L10.3113 9.45943ZM10.54 10.3132C10.3674 10.6121 9.9852 10.7146 9.68626 10.542L10.5196 9.09859C10.0214 8.81094 9.3843 8.98164 9.09665 9.47987L10.54 10.3132ZM9.40168 10.6182L9.76252 10.8266L10.5959 9.38318L10.235 9.17484L9.40168 10.6182ZM9.38124 9.40361L9.17291 9.76445L10.6163 10.5978L10.8246 10.2369L9.38124 9.40361ZM12.707 10.0007C12.707 9.65551 12.9869 9.37569 13.332 9.37569V11.0424C13.9073 11.0424 14.3737 10.576 14.3737 10.0007H12.707ZM13.332 9.37569C13.6772 9.37569 13.957 9.65551 13.957 10.0007H12.2904C12.2904 10.576 12.7567 11.0424 13.332 11.0424V9.37569ZM13.957 10.0007C13.957 10.3459 13.6772 10.6257 13.332 10.6257V8.95902C12.7567 8.95902 12.2904 9.42539 12.2904 10.0007H13.957ZM13.332 10.6257C12.9869 10.6257 12.707 10.3459 12.707 10.0007H14.3737C14.3737 9.42539 13.9073 8.95902 13.332 8.95902V10.6257ZM12.4987 9.79235V10.209H14.1654V9.79235H12.4987ZM13.5404 9.16735H13.1237V10.834H13.5404V9.16735ZM12.7908 10.3132C12.6182 10.0143 12.7206 9.63201 13.0196 9.45942L13.8529 10.9028C14.3511 10.6151 14.5218 9.97807 14.2342 9.47985L12.7908 10.3132ZM13.0196 9.45942C13.3185 9.28683 13.7007 9.38925 13.8733 9.68819L12.43 10.5215C12.7176 11.0197 13.3547 11.1904 13.8529 10.9028L13.0196 9.45942ZM13.8733 9.68819C14.0459 9.98712 13.9435 10.3694 13.6446 10.542L12.8112 9.09858C12.313 9.38622 12.1423 10.0233 12.43 10.5215L13.8733 9.68819ZM13.6446 10.542C13.3456 10.7145 12.9634 10.6121 12.7908 10.3132L14.2342 9.47985C13.9465 8.98163 13.3095 8.81093 12.8112 9.09858L13.6446 10.542ZM12.5062 10.2369L12.7145 10.5978L14.1579 9.76444L13.9496 9.4036L12.5062 10.2369ZM13.0958 9.17483L12.735 9.38316L13.5683 10.8265L13.9292 10.6182L13.0958 9.17483ZM13.0196 10.542C12.7207 10.3694 12.6182 9.98713 12.7908 9.6882L14.2342 10.5215C14.5219 10.0233 14.3512 9.38624 13.8529 9.09859L13.0196 10.542ZM12.7908 9.6882C12.9634 9.38927 13.3457 9.28684 13.6446 9.45943L12.8113 10.9028C13.3095 11.1905 13.9466 11.0197 14.2342 10.5215L12.7908 9.6882ZM13.6446 9.45943C13.9435 9.63202 14.046 10.0143 13.8734 10.3132L12.43 9.47987C12.1423 9.97809 12.313 10.6152 12.8113 10.9028L13.6446 9.45943ZM13.8734 10.3132C13.7008 10.6121 13.3185 10.7146 13.0196 10.542L13.8529 9.09859C13.3547 8.81094 12.7176 8.98164 12.43 9.47987L13.8734 10.3132ZM12.735 10.6182L13.0959 10.8266L13.9292 9.38318L13.5683 9.17484L12.735 10.6182ZM12.7146 9.40361L12.5062 9.76445L13.9496 10.5978L14.158 10.2369L12.7146 9.40361ZM4.9987 15.834C4.53846 15.834 4.16536 15.4609 4.16536 15.0007H2.4987C2.4987 16.3814 3.61799 17.5007 4.9987 17.5007V15.834ZM15.832 15.0007C15.832 15.4609 15.4589 15.834 14.9987 15.834V17.5007C16.3794 17.5007 17.4987 16.3814 17.4987 15.0007H15.832ZM14.9987 4.16732C15.4589 4.16732 15.832 4.54041 15.832 5.00065H17.4987C17.4987 3.61994 16.3794 2.50065 14.9987 2.50065V4.16732ZM4.9987 2.50065C3.61799 2.50065 2.4987 3.61994 2.4987 5.00065H4.16536C4.16536 4.54041 4.53846 4.16732 4.9987 4.16732V2.50065Z"
                :class="pathClass"
                fill="currentColor"
            />
        </svg>

        <!-- GLOBE | EARTH -->
        <svg
            v-if="icon === 'globe'"
            :width="width"
            :height="height"
            :class="svgClass"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.38621 9.16602H5.85403C5.94 7.32932 6.30795 5.65094 6.88277 4.3576C6.93299 4.24461 6.98517 4.1337 7.03931 4.02518C5.08034 4.9983 3.66796 6.9066 3.38621 9.16602ZM10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602ZM10.0013 3.33268C9.81222 3.33268 9.56934 3.41543 9.27831 3.6924C8.98298 3.97345 8.67911 4.41953 8.40579 5.0345C7.93791 6.08723 7.60743 7.52724 7.52269 9.16602H12.4799C12.3952 7.52724 12.0647 6.08723 11.5968 5.0345C11.3235 4.41953 11.0196 3.97345 10.7243 3.6924C10.4333 3.41543 10.1904 3.33268 10.0013 3.33268ZM14.1486 9.16602C14.0626 7.32932 13.6947 5.65094 13.1198 4.3576C13.0696 4.24461 13.0174 4.1337 12.9633 4.02518C14.9223 4.9983 16.3346 6.9066 16.6164 9.16602H14.1486ZM12.4799 10.8327H7.52269C7.60743 12.4715 7.93791 13.9115 8.40579 14.9642C8.67911 15.5792 8.98298 16.0252 9.27831 16.3063C9.56934 16.5833 9.81222 16.666 10.0013 16.666C10.1904 16.666 10.4333 16.5833 10.7243 16.3063C11.0196 16.0252 11.3235 15.5792 11.5968 14.9642C12.0647 13.9115 12.3952 12.4715 12.4799 10.8327ZM12.9633 15.9735C13.0174 15.865 13.0696 15.7541 13.1198 15.6411C13.6947 14.3478 14.0626 12.6694 14.1486 10.8327H16.6164C16.3346 13.0921 14.9223 15.0004 12.9633 15.9735ZM7.03931 15.9735C6.98517 15.865 6.93299 15.7541 6.88277 15.6411C6.30795 14.3478 5.94 12.6694 5.85403 10.8327H3.38621C3.66796 13.0921 5.08034 15.0004 7.03931 15.9735Z"
                fill="currentColor"
            />
        </svg>

        <!-- globe dashed -->
        <svg
            v-if="icon === 'globe-dashed'"
            :width
            :height
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.00007 12L9.00007 13L7.00007 13V12H9.00007ZM7.33711 8.28296C7.44006 7.74035 7.96338 7.38394 8.50599 7.48689C9.04859 7.58984 9.405 8.11316 9.30205 8.65577L7.33711 8.28296ZM9.30205 8.65577C9.1086 9.67541 9.00007 10.8062 9.00007 12H7.00007C7.00007 10.6873 7.11921 9.43141 7.33711 8.28296L9.30205 8.65577Z"
                fill="currentColor"
            />
            <path
                d="M9 12V11H7V12H9ZM5.86468 6.86567L6.50691 6.09915L4.97388 4.8147L4.33165 5.58122L5.86468 6.86567ZM16.5108 16.4344L16.7399 15.4609L14.793 15.0028L14.564 15.9762L16.5108 16.4344ZM18.4037 19.681L19.1714 19.0403L17.89 17.5047L17.1222 18.1454L18.4037 19.681ZM11.8 13.0007C12.3523 13.0008 12.8 12.5531 12.8 12.0008C12.8 11.4485 12.3523 11.0008 11.8 11.0007L11.8 13.0007ZM19.4789 14.8469C19.2823 15.363 19.5413 15.9408 20.0574 16.1374C20.5736 16.334 21.1513 16.0749 21.3479 15.5588L19.4789 14.8469ZM9.78814 4.5L9.11261 5.23734C9.32772 5.43441 9.61816 5.52772 9.90779 5.49282C10.1974 5.45791 10.4574 5.29826 10.6195 5.05573L9.78814 4.5ZM8.79291 3.5882L8.43648 2.65388C8.11249 2.77748 7.87566 3.06009 7.81064 3.4007C7.74563 3.74131 7.8617 4.0913 8.11738 4.32554L8.79291 3.5882ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM12 20C11.7731 20 11.4816 19.9007 11.1324 19.5683C10.778 19.2311 10.4134 18.6958 10.0854 17.9578C9.43054 16.4844 9 14.3789 9 12H7C7 14.5917 7.46489 16.9861 8.25776 18.7701C8.65364 19.6608 9.15092 20.4435 9.75363 21.0171C10.3615 21.5956 11.1223 22 12 22V20ZM4 12C4 10.0447 4.70022 8.2555 5.86468 6.86567L4.33165 5.58122C2.87679 7.31765 2 9.55774 2 12H4ZM14.564 15.9762C14.2474 17.3214 13.7889 18.3847 13.2818 19.0863C12.7641 19.8026 12.3101 20 12 20V22C13.2239 22 14.2031 21.2259 14.9028 20.2579C15.6131 19.275 16.1563 17.941 16.5108 16.4344L14.564 15.9762ZM17.1222 18.1454C15.7341 19.3038 13.9497 20 12 20V22C14.4352 22 16.6694 21.1283 18.4037 19.681L17.1222 18.1454ZM11.8 11.0007C9.76403 11.0007 7.56405 11.0005 5.87307 11.0003C5.02758 11.0002 4.30935 11.0002 3.80248 11.0001C3.54905 11.0001 3.34846 11 3.21123 11C3.14261 11 3.08984 11 3.05422 11C3.0364 11 3.02288 11 3.01381 11C3.00928 11 3.00586 11 3.00357 11C3.00243 11 3.00156 11 3.00099 11C3.0007 11 3.00049 11 3.00034 11C3.00027 11 3.00022 11 3.00018 11C3.00015 11 3.00013 11 3 12C2.99987 13 2.99989 13 2.99993 13C2.99996 13 3.00002 13 3.00009 13C3.00023 13 3.00045 13 3.00074 13C3.00131 13 3.00217 13 3.00332 13C3.0056 13 3.00903 13 3.01356 13C3.02263 13 3.03615 13 3.05397 13C3.08959 13 3.14237 13 3.21098 13C3.34822 13 3.54881 13.0001 3.80225 13.0001C4.30912 13.0002 5.02737 13.0002 5.87287 13.0003C7.56388 13.0005 9.7639 13.0007 11.8 13.0007L11.8 11.0007ZM12 4C12.3885 4 13.0027 4.32591 13.6368 5.47946C14.2411 6.57884 14.7135 8.18972 14.9062 10.1026L16.8961 9.90217C16.6849 7.80587 16.1588 5.91556 15.3895 4.51604C14.65 3.17069 13.5155 2 12 2V4ZM18 13H21V11H18V13ZM20 12C20 13.0046 19.8153 13.9638 19.4789 14.8469L21.3479 15.5588C21.7696 14.4518 22 13.2517 22 12H20ZM10.6195 5.05573C11.1727 4.22809 11.6691 4 12 4V2C10.6952 2 9.67061 2.87637 8.95677 3.94427L10.6195 5.05573ZM9.14934 4.52253C10.0335 4.18522 10.994 4 12 4V2C10.7466 2 9.54476 2.23109 8.43648 2.65388L9.14934 4.52253ZM10.4637 3.76266L9.46843 2.85087L8.11738 4.32554L9.11261 5.23734L10.4637 3.76266ZM14.9062 10.1026C15.0618 11.6477 16.3194 13 18 13V11C17.4715 11 16.9618 10.555 16.8961 9.90217L14.9062 10.1026Z"
                fill="currentColor"
            />
            <path
                d="M3 3L21 21"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
            />
            <path
                opacity="0.5"
                d="M5.08032 2.53491L23.0803 20.5349"
                stroke="none"
                stroke-width="1.8"
                stroke-linecap="round"
            />
        </svg>

        <!-- CAUTION -->
        <svg
            v-if="icon === 'caution'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 6.01278V8.00895M8 10H8.00667M6.85097 2.66024L2.18321 10.6654C1.6659 11.5525 2.30558 12.6667 3.33224 12.6667H12.6678C13.6944 12.6667 14.3341 11.5525 13.8168 10.6654L9.14903 2.66024C8.63572 1.77992 7.36428 1.77992 6.85097 2.66024ZM8.16667 10C8.16667 10.092 8.09205 10.1667 8 10.1667C7.90795 10.1667 7.83333 10.092 7.83333 10C7.83333 9.90795 7.90795 9.83333 8 9.83333C8.09205 9.83333 8.16667 9.90795 8.16667 10Z"
                stroke="#FF5449"
                stroke-width="1.33333"
                stroke-linecap="round"
            />
        </svg>
        <!-- ARROWS REPEAT / CYCLE ICON -->
        <svg
            v-if="icon === 'arrows-repeat' || icon === 'arrows-cycle'"
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            fill="none"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                fill="currentColor"
                fill-rule="evenodd"
                d="M7.365.862c.26-.26.682-.26.942 0l2 2c.26.26.26.683 0 .943l-2 2a.667.667 0 1 1-.942-.943L8.226 4H7.17a4 4 0 0 0-2.857 6.8.667.667 0 0 1-.952.933 5.333 5.333 0 0 1 3.81-9.066h1.056l-.861-.862a.667.667 0 0 1 0-.943Zm5.338 3.396a.667.667 0 0 1 .942.01 5.333 5.333 0 0 1-3.81 9.066H8.78l.862.862a.667.667 0 1 1-.943.942l-2-2a.667.667 0 0 1 0-.942l2-2a.667.667 0 1 1 .943.942L8.779 12h1.057a4 4 0 0 0 2.857-6.8.667.667 0 0 1 .01-.942Z"
                clip-rule="evenodd"
            />
        </svg>
        <!-- EXPAND OR ENLARGE ARROWS ICON -->
        <svg
            v-if="icon === 'enlarge-arrows' || icon === 'expand-arrows'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.6654 3.33301H16.6654V8.33301M11.6654 8.33301L16.0404 3.95801M8.33203 11.6663L3.95703 16.0413M3.33203 11.6663V16.6663H8.33203"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>
        <!-- HAMBURGER -->
        <svg
            v-if="icon === 'hamburger'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                d="M3 12H21M3 6H21M3 18H21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- CHECKMARK -->
        <svg
            v-if="icon === 'checkmark'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.41 16.58L4.83 12L3.41 13.41L9.41 19.41L20.41 8.41L19 7L9.41 16.58Z"
                fill="currentColor"
            />
        </svg>
        <!-- CIRCLE-CHECK -->
        <svg
            v-if="icon === 'circle-check'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M12.7969 7.91667L9.04687 12.5L7.38021 10.8333M17.7969 10C17.7969 14.1421 14.439 17.5 10.2969 17.5C6.15474 17.5 2.79688 14.1421 2.79688 10C2.79688 5.85786 6.15474 2.5 10.2969 2.5C14.439 2.5 17.7969 5.85786 17.7969 10Z"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- CIRCLE-X -->
        <svg
            v-if="icon === 'circle-x' || icon === 'error'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="circle-x, close, checkbox, remove">
                <path
                    d="M12.5 7.5L7.5 12.5M12.5 12.5L7.5 7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                    stroke="currentColor"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    :class="pathClass"
                />
            </g>
        </svg>
        <svg
            v-if="icon === 'arrow-up'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 3C12.5523 3 13 3.44772 13 4L13 17.5858L17.2929 13.2929C17.6834 12.9024 18.3166 12.9024 18.7071 13.2929C19.0976 13.6834 19.0976 14.3166 18.7071 14.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L5.29289 14.7071C4.90237 14.3166 4.90237 13.6834 5.29289 13.2929C5.68342 12.9024 6.31658 12.9024 6.70711 13.2929L11 17.5858L11 4C11 3.44772 11.4477 3 12 3Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'arrow-up-right'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.49512 5.83317C7.03488 5.83317 6.66178 5.46007 6.66178 4.99984C6.66178 4.5396 7.03488 4.1665 7.49512 4.1665H14.9951C15.4554 4.1665 15.8284 4.5396 15.8284 4.99984V12.4998C15.8284 12.9601 15.4554 13.3332 14.9951 13.3332C14.5349 13.3332 14.1618 12.9601 14.1618 12.4998V7.01168L5.79271 15.3808C5.46727 15.7062 4.93963 15.7062 4.61419 15.3808C4.28876 15.0553 4.28876 14.5277 4.61419 14.2022L12.9833 5.83317H7.49512Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'arrow-down'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M12 4L12 20M12 20L18 14M12 20L6 14"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>

        <!-- SINGLE ARROW-RIGHT ICON -->
        <svg
            v-if="icon === 'arrow-right'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M11.6615 5L16.6615 9.99998L11.6615 15M15.8281 9.99998H3.32812"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            v-if="icon === 'arrow-right-alt'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                d="M11.6615 5L16.6615 9.99998L11.6615 15M15.8281 9.99998H3.32812"
                stroke="currentColor"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- PLUS ICON -->
        <svg
            v-if="icon === 'plus'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M10.0026 5.83398V10.0007M10.0026 10.0007V14.1673M10.0026 10.0007H5.83594M10.0026 10.0007H14.1693"
                stroke="currentColor"
                stroke-width="1.67"
                stroke-linecap="round"
                :class="pathClass"
            />
        </svg>

        <!-- MINUS ICON -->
        <svg
            v-if="icon === 'minus'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M5.83594 10.0007H14.1693"
                stroke="currentColor"
                stroke-width="1.67"
                stroke-linecap="round"
                :class="pathClass"
            />
        </svg>

        <!-- CHEVRON UP | TOP -->
        <svg
            v-if="icon === 'chevron-up' || icon === 'chevron-top'"
            :width
            :height
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M4 14.9997L10.5858 8.41391C11.3668 7.63286 12.6331 7.63286 13.4142 8.41391L20 14.9997"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- CHEVRON DOWN | BOTTOM -->
        <svg
            v-if="icon === 'chevron-down' || icon === 'chevron-bottom'"
            :width="width"
            :height="width"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 9L13.4142 15.5858C12.6332 16.3668 11.3669 16.3668 10.5858 15.5858L4 9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- CHEVRON RIGHT | NEXT -->
        <svg
            v-if="icon === 'chevron-right' || icon === 'chevron-next'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L16.2929 9.87866C17.4645 11.0502 17.4645 12.9497 16.2929 14.1213L9.70711 20.7071C9.31658 21.0976 8.68342 21.0976 8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L14.8787 12.7071C15.2692 12.3166 15.2692 11.6834 14.8787 11.2929L8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            v-if="icon === 'chevron-left' || icon === 'chevron-prev'"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="rotate-180"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L16.2929 9.87866C17.4645 11.0502 17.4645 12.9497 16.2929 14.1213L9.70711 20.7071C9.31658 21.0976 8.68342 21.0976 8.29289 20.7071C7.90237 20.3166 7.90237 19.6834 8.29289 19.2929L14.8787 12.7071C15.2692 12.3166 15.2692 11.6834 14.8787 11.2929L8.29289 4.70711C7.90237 4.31658 7.90237 3.68342 8.29289 3.29289Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- CHEVRON LEFT | LAST -->
        <!-- <svg
            v-if="icon === 'chevron-last'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <g id="chevron-left-small">
                <path
                    id="vector"
                    d="M11.3241 6.79818L8.58001 9.54226C8.25458 9.86769 8.25458 10.3953 8.58002 10.7208L11.3241 13.4648"
                    stroke="currentColor"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    :class="pathClass"
                />
            </g>
        </svg> -->

        <!-- LOUNGE ICON -->
        <svg
            v-if="icon === 'lounge'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                d="M5 21C4.71667 21 4.47933 20.904 4.288 20.712C4.09667 20.52 4.00067 20.2827 4 20V19C3.16667 19 2.45833 18.7083 1.875 18.125C1.29167 17.5417 1 16.8333 1 16V11C1 10.1667 1.29167 9.45833 1.875 8.875C2.45833 8.29167 3.16667 8 4 8V6C4 5.16667 4.29167 4.45833 4.875 3.875C5.45833 3.29167 6.16667 3 7 3H17C17.8333 3 18.5417 3.29167 19.125 3.875C19.7083 4.45833 20 5.16667 20 6V8C20.8333 8 21.5417 8.29167 22.125 8.875C22.7083 9.45833 23 10.1667 23 11V16C23 16.8333 22.7083 17.5417 22.125 18.125C21.5417 18.7083 20.8333 19 20 19V20C20 20.2833 19.904 20.521 19.712 20.713C19.52 20.905 19.2827 21.0007 19 21C18.7173 20.9993 18.48 20.9033 18.288 20.712C18.096 20.5207 18 20.2833 18 20V19H6V20C6 20.2833 5.904 20.521 5.712 20.713C5.52 20.905 5.28267 21.0007 5 21ZM4 17H20C20.2833 17 20.521 16.904 20.713 16.712C20.905 16.52 21.0007 16.2827 21 16V11C21 10.7167 20.904 10.4793 20.712 10.288C20.52 10.0967 20.2827 10.0007 20 10C19.7173 9.99933 19.48 10.0953 19.288 10.288C19.096 10.4807 19 10.718 19 11V15H5V11C5 10.7167 4.904 10.4793 4.712 10.288C4.52 10.0967 4.28267 10.0007 4 10C3.71733 9.99933 3.48 10.0953 3.288 10.288C3.096 10.4807 3 10.718 3 11V16C3 16.2833 3.096 16.521 3.288 16.713C3.48 16.905 3.71733 17.0007 4 17ZM7 13H17V11C17 10.55 17.0917 10.1417 17.275 9.775C17.4583 9.40833 17.7 9.08333 18 8.8V6C18 5.71667 17.904 5.47933 17.712 5.288C17.52 5.09667 17.2827 5.00067 17 5H7C6.71667 5 6.47933 5.096 6.288 5.288C6.09667 5.48 6.00067 5.71733 6 6V8.8C6.3 9.08333 6.54167 9.40833 6.725 9.775C6.90833 10.1417 7 10.55 7 11V13Z"
                fill="currentColor"
            />
        </svg>

        <!-- CALENDAR AVAILABILITY -->
        <svg
            v-if="icon === 'calendar-availability'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.16683 16.6667H5.00016C4.07969 16.6667 3.3335 15.9205 3.3335 15V7.5M3.3335 7.5V5.83333C3.3335 4.91286 4.07969 4.16667 5.00016 4.16667H15.0002C15.9206 4.16667 16.6668 4.91286 16.6668 5.83333V7.5M3.3335 7.5H16.6668M16.6668 7.5V9.16667M6.66683 4.16667V2.5M13.3335 4.16667V2.5"
                stroke="url(#paint0_radial_4147_9140)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.7893 12.412C15.6357 12.1049 15.1975 12.1049 15.0439 12.412L14.2287 14.0424C14.1884 14.123 14.123 14.1884 14.0424 14.2287L12.412 15.0439C12.1049 15.1975 12.1049 15.6357 12.412 15.7893L14.0424 16.6045C14.123 16.6448 14.1884 16.7102 14.2287 16.7908L15.0439 18.4213C15.1975 18.7284 15.6357 18.7284 15.7893 18.4213L16.6045 16.7908C16.6448 16.7102 16.7102 16.6448 16.7908 16.6045L18.4213 15.7893C18.7284 15.6357 18.7284 15.1975 18.4213 15.0439L16.7908 14.2287C16.7102 14.1884 16.6448 14.123 16.6045 14.0424L15.7893 12.412Z"
                fill="url(#paint1_radial_4147_9140)"
            />

            <defs>
                <radialGradient
                    id="paint0_radial_4147_9140"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(10.0001 8.73347) rotate(90) scale(9.775 9.2)"
                >
                    <stop stop-color="#FD421D" />
                    <stop offset="1" stop-color="#FAB34A" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_4147_9140"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(15.4166 15.0285) rotate(90) scale(4.46426)"
                >
                    <stop stop-color="#FD421D" />
                    <stop offset="1" stop-color="#FAB34A" />
                </radialGradient>
            </defs>
        </svg>
        <!-- STOPWATCH -->
        <svg
            v-if="icon === 'stopwatch'"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="stopwatch, track">
                <path
                    id="vector"
                    d="M10.0052 11.0456L12.5052 8.54557M11.6719 1.87891H8.33854M4.17188 7.71224H1.67188M1.67188 11.0456H3.33854C3.33854 14.7275 6.32331 17.7122 10.0052 17.7122C13.6871 17.7122 16.6719 14.7275 16.6719 11.0456C16.6719 7.36367 13.6871 4.37891 10.0052 4.37891H1.67188"
                    stroke="currentColor"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>

        <!-- RADAR -->
        <svg
            v-if="icon === 'radar'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                d="M5 3L8 8L11 3M9.71524 5.14128C10.6847 5.72422 11.3333 6.78637 11.3333 8.00002C11.3333 9.84097 9.84095 11.3334 8 11.3334C6.15905 11.3334 4.66667 9.84097 4.66667 8.00002C4.66667 6.78637 5.31527 5.72422 6.28476 5.14128M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14ZM8 8.66667C7.63181 8.66667 7.33333 8.36819 7.33333 8C7.33333 7.63181 7.63181 7.33333 8 7.33333C8.36819 7.33333 8.66667 7.63181 8.66667 8C8.66667 8.36819 8.36819 8.66667 8 8.66667Z"
                stroke="#1E293B"
                stroke-width="1.33333"
            />
        </svg>

        <!-- BED -->
        <svg
            v-if="icon === 'bed'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.50033 2.91602C2.96056 2.91602 3.33366 3.28911 3.33366 3.74935V6.66602H15.0009C15.8299 6.66602 16.6429 6.99667 17.2518 7.51602C17.8622 8.03665 18.3337 8.80843 18.3337 9.72157V16.2493C18.3337 16.7096 17.9606 17.0827 17.5003 17.0827C17.0401 17.0827 16.667 16.7096 16.667 16.2493V14.166H3.33366V16.2493C3.33366 16.7096 2.96056 17.0827 2.50033 17.0827C2.04009 17.0827 1.66699 16.7096 1.66699 16.2493V3.74935C1.66699 3.28911 2.04009 2.91602 2.50033 2.91602ZM3.33366 12.4993H5.83366V8.33268H3.33366V12.4993ZM7.50033 8.33268V12.4993H16.667V9.72157C16.667 9.40694 16.5026 9.0676 16.1702 8.78406C15.8363 8.49925 15.3997 8.33268 15.0009 8.33268H7.50033Z"
                fill="black"
            />
        </svg>

        <!-- DASHBOARD -->
        <svg
            v-if="icon === 'dashboard'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 10L5.75 5.75M12 5V3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 10.9481 3.18046 9.93834 3.51212 9M14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- TRASH / DELETE  -->
        <svg
            v-if="icon === 'trash' || icon === 'delete'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.41639 5H3C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H4.06445L4.87775 19.1996C4.98281 20.7754 6.29171 22 7.87111 22H16.1289C17.7083 22 19.0172 20.7754 19.1222 19.1996L19.9356 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H16.5837C15.8122 3.23448 14.0512 2 12 2C9.94879 2 8.18785 3.23448 7.41639 5ZM9.7637 5H14.2363C13.6867 4.38612 12.8879 4 12 4C11.1121 4 10.3133 4.38612 9.7637 5ZM15.8514 7H6.06889L6.87332 19.0665C6.90834 19.5918 7.34464 20 7.87111 20H16.1289C16.6554 20 17.0917 19.5918 17.1267 19.0665L17.9311 7H15.8952C15.8806 7.00032 15.866 7.00032 15.8514 7ZM10 10C10.5523 10 11 10.4477 11 11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11C9 10.4477 9.44772 10 10 10ZM14 10C14.5523 10 15 10.4477 15 11V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V11C13 10.4477 13.4477 10 14 10Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- WALLET -->
        <svg
            v-if="icon === 'wallet'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 6.5V17C4 18.6569 5.34315 20 7 20H18C19.1046 20 20 19.1046 20 18V11C20 9.89543 19.1046 9 18 9H16M4 6.5C4 7.88071 5.11929 9 6.5 9H16M4 6.5C4 5.11929 5.11929 4 6.5 4H14.5882C15.3679 4 16 4.63207 16 5.41176V9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="square"
                stroke-linejoin="round"
            />
            <path
                d="M15.5 15.375C15.9832 15.375 16.375 14.9832 16.375 14.5C16.375 14.0168 15.9832 13.625 15.5 13.625C15.0168 13.625 14.625 14.0168 14.625 14.5C14.625 14.9832 15.0168 15.375 15.5 15.375Z"
                stroke="currentColor"
                stroke-width="0.75"
            />
        </svg>

        <!-- POINTS -->
        <svg
            v-if="icon === 'points'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 5.5C19 6.88071 15.866 8 12 8C8.13401 8 5 6.88071 5 5.5M19 5.5C19 4.11929 15.866 3 12 3C8.13401 3 5 4.11929 5 5.5M19 5.5V18.5C19 19.8807 15.866 21 12 21C8.13401 21 5 19.8807 5 18.5V5.5M19 9.75C19 11.1307 15.866 12.25 12 12.25C8.13401 12.25 5 11.1307 5 9.75M19 14C19 15.3807 15.866 16.5 12 16.5C8.13401 16.5 5 15.3807 5 14"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- LOCK / PADLOCK -->
        <svg
            v-if="icon === 'lock'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M14.9997 10.0001C14.9997 9.53984 14.6266 9.16675 14.1663 9.16675H5.83301C5.37277 9.16675 4.99967 9.53984 4.99967 10.0001V15.8334C4.99967 16.2937 5.37277 16.6667 5.83301 16.6667H14.1663C14.6266 16.6667 14.9997 16.2937 14.9997 15.8334V10.0001ZM9.16634 14.1667V11.6667C9.16634 11.2065 9.53944 10.8334 9.99967 10.8334C10.4599 10.8334 10.833 11.2065 10.833 11.6667V14.1667C10.833 14.627 10.4599 15.0001 9.99967 15.0001C9.53944 15.0001 9.16634 14.627 9.16634 14.1667ZM12.4997 5.83341C12.4997 4.4527 11.3804 3.33341 9.99967 3.33341C8.61896 3.33342 7.49967 4.4527 7.49967 5.83341V7.50008H12.4997V5.83341ZM14.1663 7.50008C15.5471 7.50008 16.6663 8.61937 16.6663 10.0001V15.8334C16.6663 17.2141 15.5471 18.3334 14.1663 18.3334H5.83301C4.4523 18.3334 3.33301 17.2141 3.33301 15.8334V10.0001C3.33301 8.61937 4.4523 7.50008 5.83301 7.50008V5.83341C5.83301 3.53223 7.69849 1.66675 9.99967 1.66675C12.3009 1.66675 14.1663 3.53223 14.1663 5.83341V7.50008Z"
                fill="currentColor"
            />
        </svg>

        <!-- UPGRADE -->
        <svg
            v-if="icon === 'upgrade'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M10 13.5072V6.84049M10 6.84049L7.5 9.34049M10 6.84049L12.5 9.34049M10 2.67383C14.1421 2.67383 17.5 6.03169 17.5 10.1738C17.5 14.316 14.1421 17.6738 10 17.6738C5.85786 17.6738 2.5 14.316 2.5 10.1738C2.5 6.03169 5.85786 2.67383 10 2.67383Z"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- CREDIT LIMIT -->
        <svg
            v-if="icon === 'credit-limit'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                d="M16.668 6.00732C16.668 5.54722 16.295 5.17399 15.8346 5.17399H4.16797C3.70773 5.17399 3.33464 5.54709 3.33464 6.00732V7.67399H16.668V6.00732ZM18.3346 8.50732C18.3346 8.96756 17.9615 9.34066 17.5013 9.34066H3.33464V14.3407C3.33464 14.801 3.70782 15.174 4.16797 15.174H14.168L14.2534 15.1781C14.6735 15.2208 15.0013 15.5759 15.0013 16.0073C15.0013 16.4387 14.6735 16.7938 14.2534 16.8366L14.168 16.8407H4.16797C2.78717 16.8407 1.66797 15.7213 1.66797 14.3407V6.00732C1.66797 4.62661 2.78726 3.50732 4.16797 3.50732H15.8346C17.2152 3.50733 18.3346 4.62648 18.3346 6.00732V8.50732Z"
                fill="#64748B"
            />
            <path
                d="M17.603 14.5758C18.1107 14.6275 18.5072 15.0563 18.5072 15.5776C18.507 16.1336 18.0557 16.5843 17.4997 16.5843C16.9784 16.5842 16.5494 16.1879 16.4979 15.6802L16.493 15.5776L16.4979 15.4743C16.5495 14.9666 16.9785 14.5703 17.4997 14.5702L17.603 14.5758ZM16.6663 13.5033V11.424C16.6663 10.9638 17.0396 10.5908 17.4997 10.5907C17.9599 10.5907 18.333 10.9638 18.333 11.424V13.5033C18.333 13.9635 17.9599 14.3366 17.4997 14.3366C17.0396 14.3364 16.6663 13.9634 16.6663 13.5033Z"
                fill="#64748B"
            />
        </svg>
        <!-- CREDIT CARD -->
        <svg
            v-if="icon === 'credit-card'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 10V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V10M3 10V7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89518 21 6.99975V10M3 10H21M7 14H10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- CREDIT CARDS -->
        <svg
            v-if="icon === 'credit-cards'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H15C16.6569 4 18 5.34315 18 7V8H19C20.6569 8 22 9.34315 22 11V17C22 18.6569 20.6569 20 19 20H9C7.34315 20 6 18.6569 6 17V16H5C3.34315 16 2 14.6569 2 13V7ZM8 16V17C8 17.5523 8.44772 18 9 18H19C19.5523 18 20 17.5523 20 17V11C20 10.4477 19.5523 10 19 10H18V13C18 14.6569 16.6569 16 15 16H8ZM16 13C16 13.5523 15.5523 14 15 14H5C4.44772 14 4 13.5523 4 13V7C4 6.44772 4.44772 6 5 6H15C15.5523 6 16 6.44772 16 7V13ZM6 9C6 8.44772 6.44772 8 7 8H8C8.55228 8 9 8.44772 9 9C9 9.55228 8.55228 10 8 10H7C6.44772 10 6 9.55228 6 9Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <svg
            v-if="icon === 'unmatched-card' || icon === 'unknown-card'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.99951 6C4.44723 6 3.99951 6.44772 3.99951 7V9H19.9995V6.99975C19.9995 6.44763 19.552 6 18.9995 6H4.99951ZM19.9995 11H3.99951V17C3.99951 17.5523 4.44723 18 4.99951 18H18.9995C19.5518 18 19.9995 17.5523 19.9995 17V11ZM1.99951 7C1.99951 5.34315 3.34266 4 4.99951 4H18.9995C20.6562 4 21.9995 5.34274 21.9995 6.99975V17C21.9995 18.6569 20.6564 20 18.9995 20H4.99951C3.34266 20 1.99951 18.6569 1.99951 17V7ZM5.99951 14C5.99951 13.4477 6.44723 13 6.99951 13H9.99951C10.5518 13 10.9995 13.4477 10.9995 14C10.9995 14.5523 10.5518 15 9.99951 15H6.99951C6.44723 15 5.99951 14.5523 5.99951 14Z"
                fill="#64748B"
            />
            <path
                d="M18.4824 12C20.5535 12 22.2324 13.6789 22.2324 15.75C22.2324 16.5656 22.0108 17.2809 21.5576 17.8701C21.1505 18.3994 20.6386 18.7049 20.3906 18.8555C20.3187 18.8992 20.2627 18.9341 20.2178 18.9619C20.1515 19.5102 19.8326 19.9786 19.3799 20.25C19.89 20.5558 20.2324 21.112 20.2324 21.75V21.7598C20.2324 22.7263 19.4489 23.5098 18.4824 23.5098C17.516 23.5097 16.7324 22.7262 16.7324 21.7598V21.75C16.7324 21.1124 17.0744 20.5559 17.584 20.25C17.0744 19.9441 16.7324 19.3876 16.7324 18.75C16.7324 17.9246 17.0072 17.2298 17.498 16.6875C17.8607 16.2868 18.3074 16.0234 18.5146 15.8994L18.5391 15.8848L18.541 15.8828C18.5529 15.8757 18.5643 15.8703 18.5742 15.8643C18.6455 15.821 18.695 15.7862 18.7314 15.7617C18.7315 15.758 18.7324 15.7541 18.7324 15.75C18.7324 15.6119 18.6205 15.5 18.4824 15.5C18.391 15.5001 18.3099 15.5479 18.2646 15.626C17.7807 16.4626 16.7106 16.7486 15.874 16.2646C15.0375 15.7807 14.7516 14.7106 15.2354 13.874C15.8809 12.7581 17.0919 12.0001 18.4824 12Z"
                fill="#64748B"
                stroke="#F1F5F9"
                stroke-width="1.5"
                stroke-linecap="round"
            />
            <path
                d="M18.4826 14.75C18.1137 14.75 17.7902 14.9492 17.6158 15.2507C17.3392 15.7288 16.7275 15.8921 16.2494 15.6156C15.7714 15.3391 15.608 14.7273 15.8846 14.2493C16.4018 13.3552 17.3709 12.75 18.4826 12.75C20.1395 12.75 21.4826 14.0931 21.4826 15.75C21.4826 16.4233 21.302 16.9719 20.9627 17.413C20.6493 17.8204 20.2493 18.0641 20.0016 18.2145C19.7018 18.3966 19.6036 18.4584 19.5365 18.5324L19.5334 18.5357C19.5173 18.5526 19.4826 18.5889 19.4826 18.75C19.4826 19.3023 19.0349 19.75 18.4826 19.75C17.9303 19.75 17.4826 19.3023 17.4826 18.75C17.4826 18.1026 17.6929 17.589 18.0537 17.1903C18.3317 16.8832 18.6862 16.6711 18.8998 16.5433L18.8998 16.5433C18.9228 16.5296 18.9441 16.5168 18.9636 16.505C19.2159 16.3518 19.3159 16.2736 19.3775 16.1935C19.4132 16.1471 19.4826 16.0426 19.4826 15.75C19.4826 15.1977 19.0349 14.75 18.4826 14.75Z"
                fill="#64748B"
            />
            <path
                d="M18.4826 20.75C19.0349 20.75 19.4826 21.1977 19.4826 21.75V21.76C19.4826 22.3123 19.0349 22.76 18.4826 22.76C17.9303 22.76 17.4826 22.3123 17.4826 21.76V21.75C17.4826 21.1977 17.9303 20.75 18.4826 20.75Z"
                fill="#64748B"
            />
        </svg>

        <!-- CARD WITH CHECK / CARD-CHECK / CARD STATUS -->
        <svg
            v-if="icon === 'card-check' || icon === 'card-status'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            :width="width || 21"
            :height="height || 21"
            viewBox="0 0 21 21"
            fill="none"
        >
            <path
                d="M16.6914 6.3125C16.6914 5.8524 16.3184 5.47917 15.8581 5.47917H4.19141C3.73117 5.47917 3.35807 5.85226 3.35807 6.3125V7.97917H16.6914V6.3125ZM18.3581 8.8125C18.3581 9.27274 17.985 9.64583 17.5247 9.64583H3.35807V14.6458C3.35807 15.1062 3.73126 15.4792 4.19141 15.4792H9.19141C9.65164 15.4792 10.0247 15.8523 10.0247 16.3125C10.0247 16.7727 9.65164 17.1458 9.19141 17.1458H4.19141C2.81061 17.1458 1.69141 16.0265 1.69141 14.6458V6.3125C1.69141 4.93179 2.81069 3.8125 4.19141 3.8125H15.8581C17.2387 3.8125 18.3581 4.93165 18.3581 6.3125V8.8125Z"
                fill="currentColor"
            />
            <path
                d="M17.8324 12.333C18.1597 12.066 18.6422 12.0849 18.9473 12.39C19.2524 12.6951 19.2712 13.1776 19.0042 13.5049L18.9473 13.5684L15.1973 17.3184C14.8922 17.6235 14.4097 17.6423 14.0824 17.3753L14.0189 17.3184L12.1439 15.4434L12.0869 15.3799C11.82 15.0526 11.8388 14.5701 12.1439 14.265C12.449 13.9599 12.9315 13.941 13.2588 14.208L13.3223 14.265L14.6081 15.5508L17.7689 12.39L17.8324 12.333Z"
                fill="currentColor"
            />
        </svg>

        <!-- CREDIT SCORE -->
        <svg
            v-if="icon === 'credit-score'"
            :width="width || 24"
            :height="height || 24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 16L15 10M12 16H3.93552M12 16H20.0645M3.93552 16C5.40822 18.9634 8.46628 21 12 21C15.5337 21 18.5918 18.9634 20.0645 16M3.93552 16C3.33671 14.795 3 13.4368 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.4368 20.6633 14.795 20.0645 16"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- TICKET -->
        <svg
            v-if="icon === 'ticket'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V9.17071C22 9.59452 21.7328 9.97231 21.3332 10.1135C20.5551 10.3886 20 11.1307 20 12C20 12.8693 20.5551 13.6114 21.3332 13.8865C21.7328 14.0277 22 14.4055 22 14.8293V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V14.8293C2 14.4055 2.26716 14.0277 2.66675 13.8865C3.4449 13.6114 4 12.8693 4 12C4 11.1307 3.4449 10.3886 2.66675 10.1135C2.26716 9.97231 2 9.59452 2 9.17071V7ZM5 6C4.44772 6 4 6.44772 4 7V8.53543C5.1948 9.22657 6 10.5183 6 12C6 13.4817 5.1948 14.7734 4 15.4646V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V15.4646C18.8052 14.7734 18 13.4817 18 12C18 10.5183 18.8052 9.22657 20 8.53543V7C20 6.44771 19.5523 6 19 6H5Z"
                fill="currentColor"
            />
            <path
                d="M14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8Z"
                fill="currentColor"
            />
            <path
                d="M14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12Z"
                fill="currentColor"
            />
            <path
                d="M14 16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16Z"
                fill="currentColor"
            />
        </svg>

        <!-- SUPPORT -->
        <svg
            v-if="icon === 'support'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.3544 3.29919 14.639 3.83508 15.7911C3.93688 16.01 3.96848 16.2564 3.91125 16.4909L3.1326 19.682C2.95662 20.4032 3.60019 21.058 4.32437 20.8945L7.65314 20.1428C7.8775 20.0921 8.11161 20.1223 8.32149 20.2164C9.44452 20.7199 10.6895 21 12 21Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M6.625 12C6.625 12.4832 7.01675 12.875 7.5 12.875C7.98325 12.875 8.375 12.4832 8.375 12C8.375 11.5168 7.98325 11.125 7.5 11.125C7.01675 11.125 6.625 11.5168 6.625 12ZM11.125 12C11.125 12.4832 11.5168 12.875 12 12.875C12.4832 12.875 12.875 12.4832 12.875 12C12.875 11.5168 12.4832 11.125 12 11.125C11.5168 11.125 11.125 11.5168 11.125 12ZM15.625 12C15.625 12.4832 16.0168 12.875 16.5 12.875C16.9832 12.875 17.375 12.4832 17.375 12C17.375 11.5168 16.9832 11.125 16.5 11.125C16.0168 11.125 15.625 11.5168 15.625 12Z"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="0.75"
                stroke-linecap="square"
            />
        </svg>
        <!-- FAQ -->
        <svg
            v-if="icon === 'faq'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 16V16.01M12 13C12 11.3608 14 11.9319 14 10C14 8.89543 13.1046 8 12 8C11.2597 8 10.6134 8.4022 10.2676 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- CARD-RECOMMENDED -->
        <svg
            v-if="icon === 'card-recommended'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill="currentColor"
                d="M20 7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2h16zm2 3a1 1 0 0 1-1 1H4v6a1 1 0 0 0 1 1h7a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3z"
            />
            <path
                fill="currentColor"
                d="M10 13a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zM19.946 13.894a.5.5 0 0 0-.894 0l-.978 1.957a.5.5 0 0 1-.224.223l-1.956.979a.5.5 0 0 0 0 .894l1.956.979a.5.5 0 0 1 .224.223l.978 1.957a.5.5 0 0 0 .894 0l.979-1.957a.5.5 0 0 1 .223-.224l1.957-.978a.5.5 0 0 0 0-.894l-1.957-.979a.5.5 0 0 1-.223-.223z"
            />
        </svg>
        <!-- NO-IMAGE -->
        <svg
            v-if="icon === 'no-image'"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                d="M20.6106 17.309L20.3501 18.7863L17.3957 18.2653L17.6562 16.7881L20.6106 17.309ZM32.546 33.1218C31.7302 32.978 31.1855 32.2 31.3293 31.3842C31.4732 30.5683 32.2512 30.0236 33.067 30.1674L32.546 33.1218ZM40.6528 10.1811L24.8959 7.40269L25.4169 4.44826L41.1738 7.22663L40.6528 10.1811ZM21.9998 9.43058L20.6106 17.309L17.6562 16.7881L19.0453 8.90964L21.9998 9.43058ZM45.6352 13.5981L42.8568 29.3551L39.9024 28.8341L42.6807 13.0772L45.6352 13.5981ZM37.0062 30.862C38.366 31.1018 39.6626 30.1939 39.9024 28.8341L42.8568 29.3551C42.3293 32.3465 39.4767 34.3439 36.4853 33.8164L37.0062 30.862ZM24.8959 7.40269C23.5362 7.16293 22.2395 8.07085 21.9998 9.43058L19.0453 8.90964C19.5728 5.91822 22.4254 3.92079 25.4169 4.44826L24.8959 7.40269ZM41.1738 7.22663C44.1652 7.7541 46.1626 10.6067 45.6352 13.5981L42.6807 13.0772C42.9205 11.7175 42.0126 10.4208 40.6528 10.1811L41.1738 7.22663ZM36.4853 33.8164L32.546 33.1218L33.067 30.1674L37.0062 30.862L36.4853 33.8164Z"
                fill="currentColor"
            />
            <path
                id="vector_2"
                d="M24.7272 23.5304L24.7075 23.5339M24.2348 23.6172C24.2828 23.8892 24.5421 24.0708 24.8141 24.0228C25.086 23.9749 25.2676 23.7155 25.2196 23.4436C25.1717 23.1716 24.9124 22.99 24.6404 23.038C24.3685 23.0859 24.1869 23.3453 24.2348 23.6172Z"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="vector_3"
                d="M9.12567 37.7265L13.1323 32.0045C13.6074 31.3259 14.5427 31.161 15.2214 31.6362L20.1242 35.0692C20.5766 35.386 21.2002 35.276 21.5169 34.8236L22.5165 33.3961C22.9916 32.7175 23.927 32.5526 24.6056 33.0278L32.0653 38.2511M13.122 43.1144L30.8485 39.9888C32.4802 39.7011 33.5697 38.1451 33.282 36.5134L30.1563 18.7869C29.8686 17.1552 28.3126 16.0657 26.681 16.3534L8.95442 19.4791C7.32274 19.7668 6.23323 21.3227 6.52094 22.9544L9.64661 40.681C9.93432 42.3126 11.4903 43.4022 13.122 43.1144Z"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
            />
        </svg>

        <!-- Reset icon -->
        <svg
            v-if="icon === 'reset'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.16667 10C4.16667 6.77834 6.77834 4.16667 10 4.16667C10.7751 4.16667 11.5129 4.3174 12.1873 4.59038C12.6139 4.76307 13.0998 4.55722 13.2724 4.13061C13.4451 3.704 13.2393 3.21817 12.8127 3.04548C11.943 2.69345 10.9931 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 12.357 3.58729 14.459 5.28577 15.8333H3.33333C2.8731 15.8333 2.5 16.2064 2.5 16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H7.5C7.96024 17.5 8.33333 17.1269 8.33333 16.6667V12.5C8.33333 12.0398 7.96024 11.6667 7.5 11.6667C7.03976 11.6667 6.66667 12.0398 6.66667 12.5V14.7879C5.15438 13.7331 4.16667 11.9813 4.16667 10ZM14.6341 6.36082C14.8642 6.75939 15.3739 6.89596 15.7725 6.66584C16.171 6.43572 16.3076 5.92606 16.0775 5.52748C15.8474 5.12891 15.3377 4.99234 14.9391 5.22246C14.5405 5.45258 14.404 5.96224 14.6341 6.36082ZM17.5 9.16584C17.5 8.7056 17.1269 8.33251 16.6667 8.33251C16.2064 8.33251 15.8333 8.7056 15.8333 9.16584C15.8333 9.62608 16.2064 9.99917 16.6667 9.99917C17.1269 9.99917 17.5 9.62608 17.5 9.16584ZM10.8333 17.4992C11.2936 17.4992 11.6667 17.1261 11.6667 16.6658C11.6667 16.2056 11.2936 15.8325 10.8333 15.8325C10.3731 15.8325 10 16.2056 10 16.6658C10 17.1261 10.3731 17.4992 10.8333 17.4992ZM16.9129 13.0275C17.143 12.6289 17.0065 12.1193 16.6079 11.8891C16.2093 11.659 15.6996 11.7956 15.4695 12.1942C15.2394 12.5927 15.376 13.1024 15.7746 13.3325C16.1731 13.5626 16.6828 13.4261 16.9129 13.0275ZM14.473 16.0777C14.8716 15.8476 15.0081 15.3379 14.778 14.9393C14.5479 14.5407 14.0382 14.4042 13.6397 14.6343C13.2411 14.8644 13.1045 15.3741 13.3347 15.7727C13.5648 16.1712 14.0744 16.3078 14.473 16.0777Z"
                fill="currentColor"
            />
        </svg>

        <!-- COURSES-->
        <svg
            v-if="icon === 'courses'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5528 3.10557C11.8343 2.96481 12.1657 2.96481 12.4472 3.10557L22.4472 8.10557C22.786 8.27496 23 8.62123 23 9V16C23 16.5523 22.5523 17 22 17C21.4477 17 21 16.5523 21 16V10.618L19 11.618V15.7639C19 16.9002 18.358 17.939 17.3416 18.4472L13.3416 20.4472C12.4971 20.8695 11.5029 20.8695 10.6584 20.4472L6.65836 18.4472C5.64201 17.939 5 16.9002 5 15.7639V11.618L1.55279 9.89443C1.214 9.72504 1 9.37877 1 9C1 8.62123 1.214 8.27496 1.55279 8.10557L11.5528 3.10557ZM7 12.618V15.7639C7 16.1427 7.214 16.489 7.55279 16.6584L11.5528 18.6584C11.8343 18.7991 12.1657 18.7991 12.4472 18.6584L16.4472 16.6584C16.786 16.489 17 16.1427 17 15.7639V12.618L12.4472 14.8944C12.1657 15.0352 11.8343 15.0352 11.5528 14.8944L7 12.618ZM19.7639 9L12 12.882L4.23607 9L12 5.11803L19.7639 9Z"
                fill="currentColor"
            />
        </svg>
        <svg
            :width="height"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'check'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.6339 7.76172C17.0613 8.11144 17.1243 8.74147 16.7746 9.16891L10.7746 16.5022C10.5957 16.7209 10.3326 16.8537 10.0505 16.8678C9.76829 16.8818 9.49332 16.7759 9.29354 16.5761L6.62688 13.9094C6.23635 13.5189 6.23635 12.8858 6.62688 12.4952C7.0174 12.1047 7.65057 12.1047 8.04109 12.4952L9.92641 14.3806L15.2267 7.90244C15.5764 7.47499 16.2064 7.41199 16.6339 7.76172Z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'list'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.5 5.00016C2.5 4.07969 3.24619 3.3335 4.16667 3.3335C5.08714 3.3335 5.83333 4.07969 5.83333 5.00016C5.83333 5.92064 5.08714 6.66683 4.16667 6.66683C3.24619 6.66683 2.5 5.92064 2.5 5.00016ZM8.33333 5.00016C8.33333 4.53993 8.70643 4.16683 9.16667 4.16683H16.6667C17.1269 4.16683 17.5 4.53993 17.5 5.00016C17.5 5.4604 17.1269 5.8335 16.6667 5.8335H9.16667C8.70643 5.8335 8.33333 5.4604 8.33333 5.00016ZM2.5 10C2.5 9.07952 3.24619 8.33333 4.16667 8.33333C5.08714 8.33333 5.83333 9.07952 5.83333 10C5.83333 10.9205 5.08714 11.6667 4.16667 11.6667C3.24619 11.6667 2.5 10.9205 2.5 10ZM8.33333 10.0002C8.33333 9.53993 8.70643 9.16683 9.16667 9.16683H16.6667C17.1269 9.16683 17.5 9.53993 17.5 10.0002C17.5 10.4604 17.1269 10.8335 16.6667 10.8335H9.16667C8.70643 10.8335 8.33333 10.4604 8.33333 10.0002ZM2.5 15.0003C2.5 14.0799 3.24619 13.3337 4.16667 13.3337C5.08714 13.3337 5.83333 14.0799 5.83333 15.0003C5.83333 15.9208 5.08714 16.667 4.16667 16.667C3.24619 16.667 2.5 15.9208 2.5 15.0003ZM8.33333 15.0002C8.33333 14.5399 8.70643 14.1668 9.16667 14.1668H16.6667C17.1269 14.1668 17.5 14.5399 17.5 15.0002C17.5 15.4604 17.1269 15.8335 16.6667 15.8335H9.16667C8.70643 15.8335 8.33333 15.4604 8.33333 15.0002Z"
                fill="currentColor"
            />
        </svg>
        <!-- Subgroup/subgrouping icon -->
        <svg
            v-if="icon === 'subgroup'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M16.6667 5.8335C16.6667 5.37326 16.2936 5.00016 15.8334 5.00016H4.16669C3.70645 5.00016 3.33335 5.37326 3.33335 5.8335V6.66683C3.33335 7.12707 3.70645 7.50016 4.16669 7.50016H15.8334C16.2936 7.50016 16.6667 7.12707 16.6667 6.66683V5.8335ZM18.3334 6.66683C18.3334 8.04754 17.2141 9.16683 15.8334 9.16683H4.16669C2.78597 9.16683 1.66669 8.04754 1.66669 6.66683V5.8335C1.66669 4.45278 2.78597 3.3335 4.16669 3.3335H15.8334C17.2141 3.3335 18.3334 4.45278 18.3334 5.8335V6.66683Z"
                fill="currentColor"
            />
            <path
                d="M7.50002 13.3335C7.50002 12.9021 7.17224 12.547 6.75214 12.5042L6.66669 12.5002H4.16669C3.70645 12.5002 3.33335 12.8733 3.33335 13.3335V14.1668C3.33335 14.6271 3.70645 15.0002 4.16669 15.0002H6.66669C7.12692 15.0002 7.50002 14.6271 7.50002 14.1668V13.3335ZM9.16669 14.1668C9.16669 15.5475 8.0474 16.6668 6.66669 16.6668H4.16669C2.78597 16.6668 1.66669 15.5475 1.66669 14.1668V13.3335C1.66669 11.9528 2.78597 10.8335 4.16669 10.8335H6.66669L6.79527 10.8368C8.11622 10.9037 9.16669 11.9959 9.16669 13.3335V14.1668Z"
                fill="currentColor"
            />
            <path
                d="M16.6668 13.3335C16.6668 12.9021 16.339 12.547 15.9189 12.5042L15.8334 12.5002H13.3334C12.8732 12.5002 12.5001 12.8733 12.5001 13.3335V14.1668C12.5001 14.6271 12.8732 15.0002 13.3334 15.0002H15.8334C16.2937 15.0002 16.6668 14.6271 16.6668 14.1668V13.3335ZM18.3334 14.1668C18.3334 15.5475 17.2141 16.6668 15.8334 16.6668H13.3334C11.9527 16.6668 10.8334 15.5475 10.8334 14.1668V13.3335C10.8334 11.9528 11.9527 10.8335 13.3334 10.8335H15.8334L15.962 10.8368C17.283 10.9037 18.3334 11.9959 18.3334 13.3335V14.1668Z"
                fill="currentColor"
            />
        </svg>
        <!-- Groups icon -->
        <svg
            v-if="icon === 'groups'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.66797 5.83594C1.66797 4.45523 2.78726 3.33594 4.16797 3.33594H15.8346C17.2153 3.33594 18.3346 4.45523 18.3346 5.83594V6.66927C18.3346 8.04998 17.2153 9.16927 15.8346 9.16927H4.16797C2.78726 9.16927 1.66797 8.04998 1.66797 6.66927V5.83594ZM4.16797 5.0026C3.70773 5.0026 3.33464 5.3757 3.33464 5.83594V6.66927C3.33464 7.12951 3.70773 7.5026 4.16797 7.5026H15.8346C16.2949 7.5026 16.668 7.12951 16.668 6.66927V5.83594C16.668 5.3757 16.2949 5.0026 15.8346 5.0026H4.16797Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.66797 13.3359C1.66797 11.9552 2.78726 10.8359 4.16797 10.8359H15.8346C17.2153 10.8359 18.3346 11.9552 18.3346 13.3359V14.1693C18.3346 15.55 17.2153 16.6693 15.8346 16.6693H4.16797C2.78726 16.6693 1.66797 15.55 1.66797 14.1693V13.3359ZM4.16797 12.5026C3.70773 12.5026 3.33464 12.8757 3.33464 13.3359V14.1693C3.33464 14.6295 3.70773 15.0026 4.16797 15.0026H15.8346C16.2949 15.0026 16.668 14.6295 16.668 14.1693V13.3359C16.668 12.8757 16.2949 12.5026 15.8346 12.5026H4.16797Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <!-- columns icon -->
        <svg
            v-if="icon === 'columns'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                :class="pathClass"
                id="vector"
                d="M15.8333 6.00017C15.8333 5.51971 15.8323 5.20926 15.813 4.97315C15.7991 4.80362 15.7786 4.7139 15.7601 4.66228L15.7422 4.62159C15.6823 4.50403 15.5956 4.40305 15.4899 4.32618L15.3784 4.25782C15.3372 4.23682 15.2532 4.20551 15.0269 4.18702C14.7907 4.16772 14.4803 4.16667 13.9998 4.16667H10.8333V15.8333H13.9998C14.4803 15.8333 14.7907 15.8323 15.0269 15.813C15.2532 15.7945 15.3372 15.7632 15.3784 15.7422L15.4899 15.6738C15.5956 15.597 15.6823 15.496 15.7422 15.3784L15.7601 15.3377C15.7786 15.2861 15.7991 15.1964 15.813 15.0269C15.8323 14.7907 15.8333 14.4803 15.8333 13.9998V6.00017ZM4.16667 13.9998C4.16667 14.4803 4.16772 14.7907 4.18702 15.0269C4.20551 15.2532 4.23682 15.3372 4.25782 15.3784L4.32618 15.4899C4.40305 15.5956 4.50403 15.6823 4.62159 15.7422L4.66228 15.7601C4.7139 15.7786 4.80362 15.7991 4.97315 15.813C5.20926 15.8323 5.51971 15.8333 6.00017 15.8333H9.16667V4.16667H6.00017C5.51971 4.16667 5.20926 4.16772 4.97315 4.18702C4.80362 4.20087 4.7139 4.22138 4.66228 4.23991L4.62159 4.25782C4.50403 4.31775 4.40305 4.40436 4.32618 4.51009L4.25782 4.62159C4.23682 4.66278 4.20551 4.74683 4.18702 4.97315C4.16772 5.20926 4.16667 5.51971 4.16667 6.00017V13.9998ZM17.5 13.9998C17.5 14.4528 17.5009 14.843 17.4748 15.1628C17.4512 15.451 17.4029 15.738 17.2835 16.0164L17.2274 16.1353C17.0176 16.5468 16.6986 16.8912 16.307 17.1314L16.1353 17.2274C15.82 17.388 15.4921 17.4478 15.1628 17.4748C14.843 17.5009 14.4528 17.5 13.9998 17.5H6.00017C5.54721 17.5 5.15697 17.5009 4.83724 17.4748C4.54901 17.4512 4.26198 17.4029 3.98356 17.2835L3.86475 17.2274C3.45318 17.0176 3.10881 16.6986 2.86866 16.307L2.77263 16.1353C2.612 15.82 2.55216 15.4921 2.52523 15.1628C2.49911 14.843 2.5 14.4528 2.5 13.9998V6.00017C2.5 5.54721 2.49911 5.15697 2.52523 4.83724C2.55216 4.50786 2.612 4.18 2.77263 3.86475L2.86866 3.69304C3.10881 3.30139 3.45317 2.9824 3.86475 2.77263L3.98356 2.71648C4.26199 2.5971 4.54901 2.54879 4.83724 2.52523C5.15697 2.49911 5.54721 2.5 6.00017 2.5H13.9998C14.4528 2.5 14.843 2.49911 15.1628 2.52523C15.4921 2.55216 15.82 2.612 16.1353 2.77263L16.307 2.86866C16.6986 3.10881 17.0176 3.45318 17.2274 3.86475L17.2835 3.98356C17.4029 4.26199 17.4512 4.54901 17.4748 4.83724C17.5009 5.15697 17.5 5.54721 17.5 6.00017V13.9998Z"
                fill="currentColor"
            />
        </svg>
        <!-- MAP ICON -->
        <svg
            v-if="icon === 'map'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.84152 2.88328C7.26916 2.74073 7.73149 2.74073 8.15913 2.88328L12.3686 4.28642C12.4541 4.31493 12.5466 4.31493 12.6321 4.28642L15.5915 3.29994C16.9405 2.85027 18.3337 3.85437 18.3337 5.27637V13.4745C18.3337 14.3712 17.7598 15.1673 16.9091 15.4509L13.1591 16.7009C12.7315 16.8434 12.2692 16.8434 11.8415 16.7009L7.63209 15.2977C7.54656 15.2692 7.45409 15.2692 7.36856 15.2977L4.40913 16.2842C3.06011 16.7339 1.66699 15.7298 1.66699 14.3078V6.1097C1.66699 5.21297 2.24081 4.41685 3.09152 4.13328L6.84152 2.88328ZM8.33366 4.69827V13.7748L11.667 14.8859V5.80938L8.33366 4.69827ZM13.3337 5.80938V14.8859L16.3821 13.8698C16.5522 13.813 16.667 13.6538 16.667 13.4745V5.27637C16.667 4.99197 16.3884 4.79115 16.1186 4.88108L13.3337 5.80938ZM6.66699 13.7748V4.69827L3.61856 5.71442C3.44842 5.77113 3.33366 5.93035 3.33366 6.1097V14.3078C3.33366 14.5922 3.61228 14.793 3.88209 14.7031L6.66699 13.7748Z"
                fill="currentColor"
            />
        </svg>

        <!-- HISTORY ICON -->
        <svg
            v-if="icon === 'history'"
            :class="svgClass"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.2238 4.82951C12.2949 1.90058 7.54615 1.90058 4.61722 4.82951C1.68829 7.75844 1.68829 12.5072 4.61722 15.4361C6.92723 17.7461 10.3674 18.2332 13.1542 16.9019C13.5695 16.7035 13.7453 16.206 13.5469 15.7908C13.3485 15.3755 12.8511 15.1996 12.4358 15.398C10.2664 16.4344 7.59077 16.0526 5.79573 14.2576C3.51767 11.9795 3.51767 8.28608 5.79573 6.00802C8.07379 3.72996 11.7672 3.72996 14.0453 6.00802C15.2085 7.17121 15.65 8.41345 15.6872 10.007L14.6513 8.97099C14.3258 8.64555 13.7982 8.64555 13.4727 8.97099C13.1473 9.29643 13.1473 9.82406 13.4727 10.1495L15.3878 12.0646C15.9573 12.6341 16.8807 12.6341 17.4502 12.0646L19.3653 10.1495C19.6907 9.82406 19.6907 9.29643 19.3653 8.97099C19.0399 8.64555 18.5122 8.64555 18.1868 8.97099L17.3477 9.81004C17.2766 7.96918 16.7276 6.33328 15.2238 4.82951Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0003 5.83398C9.54006 5.83398 9.16696 6.20707 9.16696 6.66731V9.65546L7.3277 11.4947C7.00227 11.8202 7.00227 12.3478 7.3277 12.6732C7.65314 12.9987 8.18078 12.9987 8.50622 12.6732L10.5895 10.5899C10.7458 10.4336 10.8336 10.2217 10.8336 10.0006V6.66731C10.8336 6.20707 10.4605 5.83398 10.0003 5.83398Z"
                fill="currentColor"
            />
        </svg>

        <!-- LOADER ICON -->
        <div
            v-if="icon === 'loader'"
            class="p-1 bg-white dark:bg-slate-800 rounded-full shadow dark:shadow-slate-900/50 flex justify-center items-center"
            :class="{
                'w-12 h-12': size === 'large',
                'w-8 h-8': size === 'medium',
                'w-5 h-5': size === 'small',
            }"
            role="status"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                x="0"
                y="0"
                viewBox="0 0 600 600"
                class="map-spinner"
            >
                <defs>
                    <linearGradient
                        id="Gradient1"
                        gradientTransform="rotate(90)"
                    >
                        <stop offset="0%" stop-color="rgba(255, 84, 0, 1)" />
                        <stop
                            offset="100%"
                            stop-color="rgba(255, 84, 0, 0.5)"
                        />
                    </linearGradient>
                    <linearGradient
                        id="Gradient2"
                        gradientTransform="rotate(90)"
                    >
                        <stop
                            offset="0%"
                            stop-color="rgba(246, 246, 246, 0)"
                            stop-opacity="0"
                        />
                        <stop offset="90%" stop-color="rgba(255, 84, 0, 0.5)" />
                        <stop
                            offset="100%"
                            stop-color="rgba(255, 84, 0, 0.65)"
                        />
                    </linearGradient>
                    <pattern
                        id="Pattern"
                        x="0"
                        y="0"
                        width="600"
                        height="600"
                        patternUnits="userSpaceOnUse"
                    >
                        <g transform="rotate(0, 300, 300)">
                            <rect
                                shape-rendering="crispEdges"
                                x="0"
                                y="0"
                                width="300"
                                height="600"
                                fill="url(#Gradient1)"
                            />
                            <rect
                                shape-rendering="crispEdges"
                                x="300"
                                y="0"
                                width="300"
                                height="600"
                                fill="url(#Gradient2)"
                            />
                        </g>
                    </pattern>
                </defs>
                <path
                    class="map-spinner-rotating"
                    style="stroke: url(#Pattern)"
                    fill="transparent"
                    transform="rotate(105, 300, 300)"
                    stroke-width="60"
                    d="M 364 58 A 250 250 0 1 1 235 58"
                />
            </svg>
        </div>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'eye-on'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9998 6C8.87275 6.00002 5.63287 7.7908 3.3616 11.6063C3.21736 11.8486 3.21736 12.1515 3.3616 12.3939C5.63287 16.2093 8.87274 18 11.9998 18C15.1268 18 18.3666 16.2092 20.6379 12.3937C20.7822 12.1514 20.7822 11.8485 20.6379 11.6062C18.3666 7.7907 15.1268 5.99998 11.9998 6ZM11.9998 4C15.9515 3.99997 19.7903 6.27232 22.3565 10.5831C22.876 11.4558 22.876 12.5441 22.3565 13.4168C19.7903 17.7276 15.9515 20 11.9998 20C8.04805 20 4.20919 17.7277 1.64305 13.4169C1.12354 12.5442 1.12354 11.4559 1.64305 10.5832C4.20919 6.27243 8.04804 4.00003 11.9998 4ZM11.9998 10C10.8952 10 9.99976 10.8954 9.99976 12C9.99976 13.1046 10.8952 14 11.9998 14C13.1043 14 13.9998 13.1046 13.9998 12C13.9998 10.8954 13.1043 10 11.9998 10ZM7.99976 12C7.99976 9.79086 9.79062 8 11.9998 8C14.2089 8 15.9998 9.79086 15.9998 12C15.9998 14.2091 14.2089 16 11.9998 16C9.79062 16 7.99976 14.2091 7.99976 12Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'eye-off'"
            :width="width"
            :height="height"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.52875 1.52925C1.7891 1.2689 2.21121 1.2689 2.47156 1.52925L14.4716 13.5292C14.7319 13.7896 14.7319 14.2117 14.4716 14.4721C14.2112 14.7324 13.7891 14.7324 13.5288 14.4721L1.52875 2.47206C1.2684 2.21171 1.2684 1.7896 1.52875 1.52925ZM13.7592 7.7385C12.0667 4.89509 9.56846 3.73485 7.25216 4.05167C6.88737 4.10156 6.5512 3.84629 6.5013 3.48149C6.45141 3.1167 6.70668 2.78053 7.07147 2.73063C10.0108 2.3286 12.9899 3.83926 14.9049 7.05654C15.2511 7.63822 15.2514 8.36256 14.905 8.94448C14.6409 9.3883 14.3566 9.79977 14.0548 10.1784C13.8253 10.4663 13.4059 10.5137 13.118 10.2842C12.8301 10.0547 12.7827 9.63522 13.0122 9.34731C13.2749 9.01779 13.5249 8.65636 13.7593 8.26254C13.8554 8.10108 13.8554 7.90018 13.7592 7.7385Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.98757 4.06551C5.18861 4.37397 5.10153 4.787 4.79307 4.98804C3.84972 5.60286 2.96999 6.51398 2.24106 7.73867C2.14531 7.89954 2.14515 8.10156 2.24173 8.26377C3.39302 10.1975 4.91893 11.3494 6.48964 11.7908C8.05683 12.2312 9.72239 11.981 11.2072 11.0132C11.5157 10.8122 11.9287 10.8993 12.1298 11.2077C12.3308 11.5162 12.2437 11.9292 11.9353 12.1302C10.1415 13.2993 8.0808 13.623 6.12891 13.0744C4.18055 12.5269 2.39459 11.1269 1.09607 8.94585C0.750093 8.36474 0.748614 7.63922 1.09532 7.05672C1.91687 5.67643 2.93308 4.60877 4.06505 3.87101C4.3735 3.66997 4.78653 3.75705 4.98757 4.06551ZM6.11454 6.11503C6.37489 5.85468 6.797 5.85468 7.05735 6.11503L9.88577 8.94346C10.1461 9.20381 10.1461 9.62592 9.88577 9.88627C9.40393 10.3681 8.73635 10.6673 8.00016 10.6673C6.5274 10.6673 5.33349 9.47341 5.33349 8.00065C5.33349 7.26446 5.6327 6.59688 6.11454 6.11503ZM6.71188 7.65518C6.68247 7.76531 6.66682 7.88109 6.66682 8.00065C6.66682 8.73703 7.26378 9.33399 8.00016 9.33399C8.11972 9.33399 8.2355 9.31834 8.34562 9.28893L6.71188 7.65518Z"
                fill="currentColor"
            />
        </svg>

        <svg
            :width="width"
            :height="height"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'edit' || icon === 'pencil'"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.91879 2.13809C10.6998 1.35705 11.9662 1.35704 12.7472 2.13809L13.8616 3.25248C14.6427 4.03352 14.6427 5.29985 13.8616 6.0809L5.66634 14.2762C5.41629 14.5262 5.07715 14.6667 4.72353 14.6667H1.99967C1.63148 14.6667 1.33301 14.3682 1.33301 14V11.2762C1.33301 10.9225 1.47348 10.5834 1.72353 10.3334L9.91879 2.13809ZM11.8044 3.0809C11.5441 2.82055 11.122 2.82055 10.8616 3.0809L9.94248 4.00002L11.9997 6.05721L12.9188 5.13809C13.1791 4.87774 13.1791 4.45564 12.9188 4.19529L11.8044 3.0809ZM11.0569 7.00002L8.99967 4.94283L2.66634 11.2762L2.66634 13.3334H4.72353L11.0569 7.00002Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <svg
            v-if="icon === 'sort'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.5 4.16536C2.5 3.70513 2.8731 3.33203 3.33333 3.33203H16.6667C17.1269 3.33203 17.5 3.70513 17.5 4.16536C17.5 4.6256 17.1269 4.9987 16.6667 4.9987H3.33333C2.8731 4.9987 2.5 4.6256 2.5 4.16536ZM2.5 9.9987C2.5 9.53846 2.8731 9.16536 3.33333 9.16536H13.3333C13.7936 9.16536 14.1667 9.53846 14.1667 9.9987C14.1667 10.4589 13.7936 10.832 13.3333 10.832H3.33333C2.8731 10.832 2.5 10.4589 2.5 9.9987ZM2.5 15.832C2.5 15.3718 2.8731 14.9987 3.33333 14.9987H10C10.4602 14.9987 10.8333 15.3718 10.8333 15.832C10.8333 16.2923 10.4602 16.6654 10 16.6654H3.33333C2.8731 16.6654 2.5 16.2923 2.5 15.832Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'copy'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.30122 2.5H14.0321C14.4714 2.49999 14.8504 2.49997 15.1625 2.52548C15.492 2.55239 15.8197 2.61182 16.135 2.77249C16.6054 3.01217 16.9878 3.39462 17.2275 3.86503C17.3882 4.18034 17.4476 4.50802 17.4745 4.83748C17.5 5.14962 17.5 5.52858 17.5 5.96786V10.6988C17.5 11.1381 17.5 11.5171 17.4745 11.8292C17.4476 12.1586 17.3882 12.4863 17.2275 12.8016C16.9878 13.2721 16.6054 13.6545 16.135 13.8942C15.8197 14.0548 15.492 14.1143 15.1625 14.1412C14.8827 14.1641 14.5492 14.1664 14.1666 14.1666C14.1664 14.5492 14.1641 14.8827 14.1412 15.1625C14.1143 15.492 14.0548 15.8197 13.8942 16.135C13.6545 16.6054 13.2721 16.9878 12.8016 17.2275C12.4863 17.3882 12.1586 17.4476 11.8292 17.4745C11.5171 17.5 11.1381 17.5 10.6988 17.5H5.96786C5.52858 17.5 5.14962 17.5 4.83748 17.4745C4.50802 17.4476 4.18034 17.3882 3.86503 17.2275C3.39462 16.9878 3.01217 16.6054 2.77249 16.135C2.61182 15.8197 2.55239 15.492 2.52548 15.1625C2.49997 14.8504 2.49999 14.4714 2.5 14.0321V9.30121C2.49999 8.86192 2.49997 8.48295 2.52548 8.17081C2.55239 7.84136 2.61182 7.51368 2.77249 7.19836C3.01217 6.72795 3.39462 6.3455 3.86503 6.10582C4.18034 5.94516 4.50802 5.88573 4.83748 5.85881C5.1173 5.83595 5.45082 5.83359 5.83336 5.83336C5.83359 5.45082 5.83595 5.1173 5.85881 4.83748C5.88573 4.50802 5.94516 4.18034 6.10582 3.86503C6.3455 3.39462 6.72795 3.01217 7.19836 2.77249C7.51368 2.61182 7.84136 2.55239 8.17081 2.52548C8.48296 2.49997 8.86192 2.49999 9.30122 2.5ZM6 7.5C5.51954 7.5 5.20931 7.50065 4.9732 7.51994C4.74681 7.53844 4.66288 7.56984 4.62168 7.59083C4.46487 7.67072 4.33739 7.79821 4.2575 7.95501C4.2365 7.99621 4.2051 8.08015 4.18661 8.30653C4.16732 8.54265 4.16667 8.85287 4.16667 9.33333V14C4.16667 14.4805 4.16732 14.7907 4.18661 15.0268C4.2051 15.2532 4.2365 15.3371 4.2575 15.3783C4.33739 15.5351 4.46487 15.6626 4.62168 15.7425C4.66288 15.7635 4.74681 15.7949 4.9732 15.8134C5.20931 15.8327 5.51954 15.8333 6 15.8333H10.6667C11.1471 15.8333 11.4574 15.8327 11.6935 15.8134C11.9199 15.7949 12.0038 15.7635 12.045 15.7425C12.2018 15.6626 12.3293 15.5351 12.4092 15.3783C12.4302 15.3371 12.4616 15.2532 12.4801 15.0268C12.4994 14.7907 12.5 14.4805 12.5 14V9.33333C12.5 8.85287 12.4994 8.54265 12.4801 8.30653C12.4616 8.08015 12.4302 7.99621 12.4092 7.95501C12.3293 7.79821 12.2018 7.67072 12.045 7.59083C12.0038 7.56984 11.9199 7.53844 11.6935 7.51994C11.4574 7.50065 11.1471 7.5 10.6667 7.5H6ZM14.1667 12.4999V9.30123C14.1667 8.86193 14.1667 8.48296 14.1412 8.17081C14.1143 7.84136 14.0548 7.51368 13.8942 7.19836C13.6545 6.72795 13.2721 6.3455 12.8016 6.10582C12.4863 5.94516 12.1586 5.88573 11.8292 5.85881C11.517 5.83331 11.1381 5.83332 10.6988 5.83333L7.50006 5.83334C7.50043 5.44575 7.50298 5.18082 7.51994 4.9732C7.53844 4.74681 7.56984 4.66288 7.59083 4.62168C7.67072 4.46487 7.79821 4.33739 7.95501 4.2575C7.99621 4.2365 8.08015 4.2051 8.30653 4.18661C8.54265 4.16732 8.85287 4.16667 9.33333 4.16667H14C14.4805 4.16667 14.7907 4.16732 15.0268 4.18661C15.2532 4.2051 15.3371 4.2365 15.3783 4.2575C15.5351 4.33739 15.6626 4.46487 15.7425 4.62168C15.7635 4.66288 15.7949 4.74681 15.8134 4.9732C15.8327 5.20931 15.8333 5.51954 15.8333 6V10.6667C15.8333 11.1471 15.8327 11.4574 15.8134 11.6935C15.7949 11.9199 15.7635 12.0038 15.7425 12.045C15.6626 12.2018 15.5351 12.3293 15.3783 12.4092C15.3371 12.4302 15.2532 12.4616 15.0268 12.4801C14.8192 12.497 14.5543 12.4996 14.1667 12.4999Z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'download'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.83333 11.6667C4.29357 11.6667 4.66667 12.0398 4.66667 12.5V15C4.66667 15.4602 5.03976 15.8333 5.5 15.8333H15.5C15.9602 15.8333 16.3333 15.4602 16.3333 15V12.5C16.3333 12.0398 16.7064 11.6667 17.1667 11.6667C17.6269 11.6667 18 12.0398 18 12.5V15C18 16.3807 16.8807 17.5 15.5 17.5H5.5C4.11929 17.5 3 16.3807 3 15V12.5C3 12.0398 3.3731 11.6667 3.83333 11.6667Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5 12.9167C10.721 12.9167 10.933 12.8289 11.0892 12.6726L14.0059 9.75592C14.3314 9.43049 14.3314 8.90285 14.0059 8.57741C13.6805 8.25198 13.1528 8.25197 12.8274 8.57741L11.3333 10.0715V3.33333C11.3333 2.8731 10.9602 2.5 10.5 2.5C10.0398 2.5 9.66666 2.8731 9.66666 3.33333V10.0715L8.17259 8.57741C7.84715 8.25198 7.31952 8.25197 6.99408 8.57741C6.66864 8.90285 6.66864 9.43049 6.99408 9.75592L9.91073 12.6726C10.067 12.8289 10.279 12.9167 10.5 12.9167Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'dots-vertical'"
            width="3"
            height="14"
            viewBox="0 0 3 14"
            class="w-4 h-4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.66667 2.33333C2.03486 2.33333 2.33333 2.03486 2.33333 1.66667C2.33333 1.29848 2.03486 1 1.66667 1C1.29848 1 1 1.29848 1 1.66667C1 2.03486 1.29848 2.33333 1.66667 2.33333Z"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1.66667 7.66667C2.03486 7.66667 2.33333 7.36819 2.33333 7C2.33333 6.63181 2.03486 6.33333 1.66667 6.33333C1.29848 6.33333 1 6.63181 1 7C1 7.36819 1.29848 7.66667 1.66667 7.66667Z"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1.66667 13C2.03486 13 2.33333 12.7015 2.33333 12.3333C2.33333 11.9651 2.03486 11.6667 1.66667 11.6667C1.29848 11.6667 1 11.9651 1 12.3333C1 12.7015 1.29848 13 1.66667 13Z"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'share'"
        >
            <path
                d="M11.5008 10.0001C11.1266 10.002 10.7575 10.0879 10.4209 10.2514C10.0842 10.415 9.78861 10.652 9.55582 10.9451L5.90082 8.6601C6.03403 8.23018 6.03403 7.77002 5.90082 7.3401L9.55582 5.0551C9.9268 5.51446 10.4484 5.82769 11.0282 5.93931C11.608 6.05092 12.2086 5.95372 12.7236 5.66491C13.2386 5.37611 13.6347 4.91435 13.8419 4.36143C14.049 3.8085 14.0538 3.20011 13.8553 2.64402C13.6568 2.08793 13.2679 1.62003 12.7575 1.32322C12.2471 1.0264 11.6481 0.919827 11.0666 1.02237C10.4851 1.12491 9.95871 1.42996 9.5806 1.88346C9.2025 2.33697 8.99711 2.90966 9.00082 3.5001C9.00318 3.72369 9.03684 3.94585 9.10082 4.1601L5.44582 6.4451C5.12315 6.03889 4.68209 5.74313 4.1838 5.5988C3.68551 5.45447 3.15466 5.46873 2.66483 5.63961C2.17501 5.81048 1.75047 6.1295 1.45007 6.55245C1.14967 6.9754 0.988281 7.48133 0.988281 8.0001C0.988281 8.51888 1.14967 9.0248 1.45007 9.44775C1.75047 9.8707 2.17501 10.1897 2.66483 10.3606C3.15466 10.5315 3.68551 10.5457 4.1838 10.4014C4.68209 10.2571 5.12315 9.96131 5.44582 9.5551L9.10082 11.8401C9.03684 12.0544 9.00318 12.2765 9.00082 12.5001C9.00082 12.9946 9.14745 13.4779 9.42215 13.889C9.69685 14.3002 10.0873 14.6206 10.5441 14.8098C11.0009 14.999 11.5036 15.0485 11.9885 14.9521C12.4735 14.8556 12.919 14.6175 13.2686 14.2679C13.6182 13.9182 13.8563 13.4728 13.9528 12.9878C14.0492 12.5029 13.9997 12.0002 13.8105 11.5434C13.6213 11.0866 13.3009 10.6961 12.8897 10.4214C12.4786 10.1467 11.9953 10.0001 11.5008 10.0001ZM11.5008 2.0001C11.7975 2.0001 12.0875 2.08808 12.3342 2.2529C12.5809 2.41772 12.7731 2.65199 12.8866 2.92608C13.0002 3.20017 13.0299 3.50177 12.972 3.79274C12.9141 4.08371 12.7713 4.35098 12.5615 4.56076C12.3517 4.77054 12.0844 4.9134 11.7935 4.97128C11.5025 5.02916 11.2009 4.99945 10.9268 4.88592C10.6527 4.77239 10.4184 4.58013 10.2536 4.33346C10.0888 4.08678 10.0008 3.79677 10.0008 3.5001C10.0008 3.10228 10.1589 2.72075 10.4402 2.43944C10.7215 2.15814 11.103 2.0001 11.5008 2.0001ZM3.50082 9.5001C3.20415 9.5001 2.91414 9.41213 2.66747 9.24731C2.4208 9.08248 2.22854 8.84822 2.11501 8.57413C2.00147 8.30004 1.97177 7.99844 2.02965 7.70747C2.08752 7.4165 2.23039 7.14922 2.44016 6.93944C2.64994 6.72966 2.91722 6.5868 3.20819 6.52892C3.49916 6.47105 3.80076 6.50075 4.07485 6.61428C4.34894 6.72781 4.58321 6.92007 4.74803 7.16675C4.91285 7.41342 5.00082 7.70343 5.00082 8.0001C5.00082 8.39793 4.84279 8.77946 4.56148 9.06076C4.28018 9.34207 3.89865 9.5001 3.50082 9.5001ZM11.5008 14.0001C11.2042 14.0001 10.9141 13.9121 10.6675 13.7473C10.4208 13.5825 10.2285 13.3482 10.115 13.0741C10.0015 12.8 9.97177 12.4984 10.0296 12.2075C10.0875 11.9165 10.2304 11.6492 10.4402 11.4394C10.6499 11.2297 10.9172 11.0868 11.2082 11.0289C11.4992 10.971 11.8008 11.0008 12.0748 11.1143C12.3489 11.2278 12.5832 11.4201 12.748 11.6667C12.9129 11.9134 13.0008 12.2034 13.0008 12.5001C13.0008 12.8979 12.8428 13.2795 12.5615 13.5608C12.2802 13.8421 11.8986 14.0001 11.5008 14.0001Z"
                fill="currentColor"
            />
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'share-alt'"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.7468 3.16107C14.0722 2.83563 14.5998 2.83563 14.9253 3.16107L17.8419 6.07774C18.1674 6.40317 18.1674 6.93081 17.8419 7.25625L14.9253 10.1729C14.5998 10.4984 14.0722 10.4984 13.7468 10.1729C13.4213 9.84748 13.4213 9.31984 13.7468 8.9944L15.2408 7.50033H11.4194C9.5784 7.50033 8.08602 8.99271 8.08602 10.8337V11.667C8.08602 12.1272 7.71292 12.5003 7.25269 12.5003C6.79245 12.5003 6.41935 12.1272 6.41935 11.667V10.8337C6.41935 8.07223 8.65793 5.83366 11.4194 5.83366H15.2408L13.7468 4.33958C13.4213 4.01414 13.4213 3.48651 13.7468 3.16107ZM3.08602 5.83366C3.54626 5.83366 3.91935 6.20675 3.91935 6.66699V14.167C3.91935 14.6272 4.29245 15.0003 4.75269 15.0003H16.4194C16.8796 15.0003 17.2527 15.3734 17.2527 15.8337C17.2527 16.2939 16.8796 16.667 16.4194 16.667H4.75269C3.37197 16.667 2.25269 15.5477 2.25269 14.167V6.66699C2.25269 6.20675 2.62578 5.83366 3.08602 5.83366Z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'flight'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.61021 3.32325C6.54061 3.31212 6.49799 3.31798 6.47155 3.32519L6.45848 3.32875L6.02231 3.4326C5.95821 3.45103 5.937 3.47016 5.93322 3.47367C5.93009 3.47655 5.91486 3.49058 5.89862 3.5403C5.88051 3.59578 5.88406 3.62116 5.88553 3.62952C5.88715 3.63872 5.89394 3.66934 5.93598 3.72452L5.94055 3.73051L9.33635 8.2722C9.50222 8.49403 9.54702 8.78377 9.45591 9.04534C9.36479 9.30691 9.14967 9.50612 8.88188 9.57689L5.96521 10.3477C5.70429 10.4167 5.42613 10.355 5.2188 10.1822L3.22208 8.5183C3.20468 8.51794 3.18504 8.51914 3.16252 8.5227L2.70849 8.64115L2.70982 8.6432L4.61131 11.8193C4.71457 11.9881 4.84376 12.0964 5.01512 12.1663C5.18344 12.235 5.34724 12.2464 5.53564 12.1957L17.1971 9.05129C17.4326 8.9842 17.5896 8.86067 17.7082 8.65577C17.8235 8.45666 17.8482 8.26872 17.7834 8.03851C17.7166 7.80085 17.5928 7.64291 17.3868 7.52366C17.1877 7.40838 16.9998 7.38368 16.7696 7.44843L16.7616 7.45066L13.6409 8.29505C13.1136 8.43775 12.5497 8.31293 12.1319 7.96097L6.64444 3.33893L6.63615 3.33156C6.63436 3.32997 6.6333 3.32927 6.6333 3.32927C6.6333 3.32927 6.62592 3.32577 6.61021 3.32325ZM6.04801 1.71323C6.32229 1.64086 6.60088 1.63389 6.87353 1.67752C7.19139 1.72838 7.48578 1.86024 7.73373 2.07733L13.2056 6.68624L16.3227 5.8428C16.9799 5.65911 17.6306 5.73897 18.2219 6.08128C18.8076 6.42036 19.2047 6.93603 19.3878 7.58726C19.5731 8.24594 19.4936 8.89828 19.1506 9.49083C18.8115 10.0765 18.2958 10.4736 17.6446 10.6568L17.6359 10.6592L5.96924 13.805C5.43542 13.9487 4.89752 13.9185 4.38529 13.7094C3.87684 13.5019 3.47169 13.1526 3.18629 12.6837L3.18311 12.6785L1.29364 9.52238C1.0012 9.06135 0.954357 8.53411 1.15424 8.02775C1.35762 7.5125 1.76198 7.16129 2.29543 7.02646L2.7944 6.89629L2.81802 6.89157C3.0477 6.84563 3.28259 6.83805 3.51767 6.87517C3.81688 6.92241 4.07736 7.05511 4.29223 7.24058L5.95528 8.62646L7.26198 8.28112L4.6077 4.73122C4.22639 4.22873 4.11615 3.62973 4.31428 3.02297C4.51733 2.40112 4.9799 1.98715 5.59814 1.82071L5.60991 1.81754L6.04801 1.71323Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.62738 16.8754C1.62738 16.4152 2.00047 16.0421 2.46071 16.0421H13.7107C14.1709 16.0421 14.544 16.4152 14.544 16.8754C14.544 17.3356 14.1709 17.7087 13.7107 17.7087H2.46071C2.00047 17.7087 1.62738 17.3356 1.62738 16.8754Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'train'"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                d="M13.0859 7.08366V7.09199M13.0859 10.0003V10.0087M13.0859 12.917V12.9253M4.7526 4.16699H16.4193C17.3397 4.16699 18.0859 4.91318 18.0859 5.83366V7.70866C16.0026 8.54199 16.0026 11.4587 18.0859 12.292V14.167C18.0859 15.0875 17.3397 15.8337 16.4193 15.8337H4.7526C3.83213 15.8337 3.08594 15.0875 3.08594 14.167V12.292C5.16927 11.4587 5.16927 8.54199 3.08594 7.70866V5.83366C3.08594 4.91318 3.83213 4.16699 4.7526 4.16699Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'car' || icon === 'rental-car'"
        >
            <g id="car" clip-path="url(#clip0_2050_14082)">
                <path
                    id="vector"
                    d="M2.25277 8.75033L5.08691 4.85337C5.40054 4.42213 5.90158 4.16699 6.43481 4.16699H14.7208C15.2633 4.16699 15.7718 4.431 16.084 4.87467L18.9194 8.90509M2.25277 8.75033H1.41943M2.25277 8.75033V14.167C2.25277 15.0875 2.99896 15.8337 3.91943 15.8337C4.83991 15.8337 5.5861 15.0875 5.5861 14.167H15.5861C15.5861 15.0875 16.3323 15.8337 17.2528 15.8337C18.1732 15.8337 18.9194 15.0875 18.9194 14.167V8.90509M18.9194 8.90509H19.7528M5.5861 10.8337H7.25277M13.9194 10.8337H15.5861"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2050_14082">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.585938)"
                    />
                </clipPath>
            </defs>
        </svg>
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'other'"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5858 3.54167C9.43518 3.54167 8.50244 4.47441 8.50244 5.625C8.50244 6.77559 9.43518 7.70833 10.5858 7.70833C11.7364 7.70833 12.6691 6.77559 12.6691 5.625C12.6691 4.47441 11.7364 3.54167 10.5858 3.54167ZM6.83577 5.625C6.83577 3.55393 8.51471 1.875 10.5858 1.875C12.6568 1.875 14.3358 3.55393 14.3358 5.625C14.3358 7.69607 12.6568 9.375 10.5858 9.375C8.51471 9.375 6.83577 7.69607 6.83577 5.625ZM6.00244 11.4583C4.85185 11.4583 3.91911 12.3911 3.91911 13.5417C3.91911 14.6923 4.85185 15.625 6.00244 15.625C7.15304 15.625 8.08577 14.6923 8.08577 13.5417C8.08577 12.3911 7.15304 11.4583 6.00244 11.4583ZM2.25244 13.5417C2.25244 11.4706 3.93137 9.79167 6.00244 9.79167C8.07351 9.79167 9.75244 11.4706 9.75244 13.5417C9.75244 15.6127 8.07351 17.2917 6.00244 17.2917C3.93137 17.2917 2.25244 15.6127 2.25244 13.5417ZM15.1691 11.4583C14.0185 11.4583 13.0858 12.3911 13.0858 13.5417C13.0858 14.6923 14.0185 15.625 15.1691 15.625C16.3197 15.625 17.2524 14.6923 17.2524 13.5417C17.2524 12.3911 16.3197 11.4583 15.1691 11.4583ZM11.4191 13.5417C11.4191 11.4706 13.098 9.79167 15.1691 9.79167C17.2402 9.79167 18.9191 11.4706 18.9191 13.5417C18.9191 15.6127 17.2402 17.2917 15.1691 17.2917C13.098 17.2917 11.4191 15.6127 11.4191 13.5417Z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            v-if="icon === 'media'"
        >
            <path
                d="M608 0H160c-17.7 0-32 13.1-32 29.3V128h128V32h256v288h-32v32h128c17.7 0 32-13.1 32-29.3V29.3C640 13.1 625.7 0 608 0zM224 96h-64V32h64zm384 224h-64v-64h64zm0-96h-64v-96h64zm0-128h-64V32h64zm-192 64H32a32 32 0 0 0 -32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0 -32-32zm0 320H32v-24l81.7-61.3 80 40 126.8-95.1L416 403.2zm0-115.2l-96.5-64.4-129.2 96.9-80-40L32 416V192h384zM112 320a48 48 0 1 0 -48-48 48 48 0 0 0 48 48zm0-64a16 16 0 1 1 -16 16 16 16 0 0 1 16-16z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'dollar'"
            :class="svgClass"
        >
            <path
                d="M10.4167 3.86364V2.5M10.4167 16.1364V17.5M12.9431 5.90909C12.4388 5.09391 11.4962 4.54545 10.4167 4.54545H10.0926C8.66074 4.54545 7.5 5.63082 7.5 6.9697V7.07378C7.5 8.03143 8.07864 8.9069 8.99468 9.33517L11.8387 10.6648C12.7547 11.0931 13.3333 11.9686 13.3333 12.9262C13.3333 14.3226 12.1228 15.4545 10.6294 15.4545H10.4167C9.33709 15.4545 8.3945 14.9061 7.8902 14.0909"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'coin'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5V7.12367C13.804 7.32711 14.5135 7.77457 14.9759 8.41405C15.2995 8.86159 15.199 9.48674 14.7515 9.81035C14.304 10.134 13.6788 10.0335 13.3552 9.58595C13.1379 9.28549 12.6534 9 12 9H11.7222C10.8274 9 10.5 9.54492 10.5 9.77778V9.8541C10.5 10.0514 10.6491 10.3826 11.1525 10.584L13.5902 11.5591C14.6572 11.9858 15.5 12.9386 15.5 14.1459C15.5 15.6189 14.323 16.6144 13 16.9091V17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5V16.8763C10.196 16.6729 9.4865 16.2254 9.02411 15.586C8.7005 15.1384 8.80096 14.5133 9.24851 14.1897C9.69605 13.866 10.3212 13.9665 10.6448 14.414C10.8621 14.7145 11.3466 15 12 15H12.1824C13.1298 15 13.5 14.4209 13.5 14.1459C13.5 13.9486 13.3509 13.6174 12.8475 13.416L10.4098 12.4409C9.34283 12.0142 8.5 11.0614 8.5 9.8541V9.77778C8.5 8.31377 9.68936 7.33904 11 7.07331V6.5C11 5.94772 11.4477 5.5 12 5.5Z"
                fill="currentColor"
            />
        </svg>
        <svg
            :width
            :height
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'info'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0003 3.33268C6.31843 3.33268 3.33366 6.31745 3.33366 9.99935C3.33366 13.6812 6.31843 16.666 10.0003 16.666C13.6822 16.666 16.667 13.6812 16.667 9.99935C16.667 6.31745 13.6822 3.33268 10.0003 3.33268ZM1.66699 9.99935C1.66699 5.39698 5.39795 1.66602 10.0003 1.66602C14.6027 1.66602 18.3337 5.39698 18.3337 9.99935C18.3337 14.6017 14.6027 18.3327 10.0003 18.3327C5.39795 18.3327 1.66699 14.6017 1.66699 9.99935ZM8.33366 9.16602C8.33366 8.70578 8.70676 8.33268 9.16699 8.33268H10.0003C10.4606 8.33268 10.8337 8.70578 10.8337 9.16602V13.3327C10.8337 13.7929 10.4606 14.166 10.0003 14.166C9.54009 14.166 9.16699 13.7929 9.16699 13.3327V9.99935C8.70676 9.99935 8.33366 9.62625 8.33366 9.16602Z"
                fill="currentColor"
            />
            <path
                d="M9.58333 6.66602C9.58333 6.4359 9.76988 6.24935 10 6.24935C10.2301 6.24935 10.4167 6.4359 10.4167 6.66602C10.4167 6.89613 10.2301 7.08268 10 7.08268C9.76988 7.08268 9.58333 6.89613 9.58333 6.66602Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 7.49935C9.53976 7.49935 9.16667 7.12625 9.16667 6.66602C9.16667 6.20578 9.53976 5.83268 10 5.83268C10.4602 5.83268 10.8333 6.20578 10.8333 6.66602C10.8333 7.12625 10.4602 7.49935 10 7.49935ZM10 6.24935C9.76988 6.24935 9.58333 6.4359 9.58333 6.66602C9.58333 6.89613 9.76988 7.08268 10 7.08268C10.2301 7.08268 10.4167 6.89613 10.4167 6.66602C10.4167 6.4359 10.2301 6.24935 10 6.24935Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'squiggle'"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 10.667L8 21.3337C8 23.5428 9.79086 25.3337 12 25.3337V25.3337C14.2091 25.3337 16 23.5428 16 21.3337L16 10.667"
                stroke="#475569"
                stroke-width="2"
            />
            <path
                d="M16 21.333L16 10.6663C16 8.4572 17.7909 6.66634 20 6.66634V6.66634C22.2091 6.66634 24 8.4572 24 10.6663L24 21.333"
                stroke="#475569"
                stroke-width="2"
            />
            <circle
                cx="2.66667"
                cy="2.66667"
                r="2.66667"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 5.33203 6.66699)"
                stroke="#475569"
                stroke-width="2"
            />
            <ellipse
                cx="2.66667"
                cy="2.66667"
                rx="2.66667"
                ry="2.66667"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 21.332 20)"
                stroke="#475569"
                stroke-width="2"
            />
        </svg>
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'redemption-tracker'"
        >
            <path
                id="Icon"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.9 3H11.1C12.2756 3 13.2758 3.75137 13.6464 4.80008L18.3 4.8C19.7379 4.8 20.9133 5.92403 20.9954 7.34135L21 7.5V14.7C21 16.1379 19.876 17.3133 18.4586 17.3954L18.3 17.4H14.7C13.5247 17.4 12.5248 16.6491 12.1539 15.6008L4.8 15.6V20.1C4.8 20.5971 4.39706 21 3.9 21C3.40294 21 3 20.5971 3 20.1V3.9C3 3.40294 3.40294 3 3.9 3ZM13.8 6.6V14.7C13.8 15.1616 14.1474 15.542 14.595 15.5939L14.7 15.6H18.3C18.7616 15.6 19.142 15.2526 19.1939 14.805L19.2 14.7V7.5C19.2 7.03845 18.8526 6.65804 18.405 6.60605L18.3 6.6H13.8ZM11.1 4.8H4.8V13.8H12V5.7C12 5.23845 11.6526 4.85804 11.205 4.80605L11.1 4.8Z"
                fill="currentColor"
            />
        </svg>
        <svg
            width="32"
            height="33"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'trip'"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9993 7.16797C11.9993 6.43159 12.5963 5.83464 13.3327 5.83464H18.666C19.4024 5.83464 19.9993 6.43159 19.9993 7.16797V8.5013H11.9993V7.16797ZM22.666 7.16797V8.5013H25.3327C27.5418 8.5013 29.3327 10.2922 29.3327 12.5013V24.5013C29.3327 26.7104 27.5418 28.5013 25.3327 28.5013H6.66602C4.45688 28.5013 2.66602 26.7104 2.66602 24.5013V12.5013C2.66602 10.2922 4.45688 8.5013 6.66602 8.5013H9.33268V7.16797C9.33268 4.95883 11.1235 3.16797 13.3327 3.16797H18.666C20.8752 3.16797 22.666 4.95883 22.666 7.16797ZM5.33268 12.5013C5.33268 11.7649 5.92964 11.168 6.66602 11.168H10.666H21.3327H25.3327C26.0691 11.168 26.666 11.7649 26.666 12.5013V24.5013C26.666 25.2377 26.0691 25.8346 25.3327 25.8346H6.66602C5.92964 25.8346 5.33268 25.2377 5.33268 24.5013V12.5013ZM9.06973 15.8642C8.37776 16.1161 8.02097 16.8812 8.27283 17.5732L8.78321 18.9755C9.03507 19.6674 9.80019 20.0242 10.4922 19.7724L14.4728 18.3235C15.1648 18.0717 15.5216 17.3065 15.2697 16.6146L14.7593 15.2123C14.5075 14.5203 13.7423 14.1636 13.0504 14.4154L9.06973 15.8642ZM23.9537 20.3858C23.6915 21.965 22.3191 23.1691 20.6655 23.1691C18.8246 23.1691 17.3322 21.6767 17.3322 19.8358C17.3322 18.1822 18.5363 16.8098 20.1155 16.5476C20.4644 16.4897 20.806 16.6429 21.056 16.893L23.6083 19.4453C23.8584 19.6953 24.0116 20.0369 23.9537 20.3858Z"
                fill="currentColor"
            />
        </svg>

        <!-- undo -->
        <svg
            :width
            :height
            :class="svgClass"
            v-if="icon === 'undo'"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.2929 2.29289C15.6834 1.90237 16.3166 1.90237 16.7071 2.29289L19.7071 5.29289C20.0976 5.68342 20.0976 6.31658 19.7071 6.70711L16.7071 9.70711C16.3166 10.0976 15.6834 10.0976 15.2929 9.70711C14.9024 9.31658 14.9024 8.68342 15.2929 8.29289L16.5858 7H9.5C6.46243 7 4 9.46243 4 12.5C4 15.5376 6.46243 18 9.5 18H17C17.5523 18 18 18.4477 18 19C18 19.5523 17.5523 20 17 20H9.5C5.35786 20 2 16.6421 2 12.5C2 8.35786 5.35786 5 9.5 5H16.5858L15.2929 3.70711C14.9024 3.31658 14.9024 2.68342 15.2929 2.29289Z"
                fill="currentColor"
            />
        </svg>

        <!-- refresh, rotate -->
        <svg
            :width
            :height
            viewBox="0 0 24 24"
            :class="svgClass"
            v-if="
                icon === 'refresh' || icon === 'rotate' || icon === 'retention'
            "
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 12C3 7.02944 7.02944 3 12 3C14.282 3 16.4025 3.8504 18.0118 5.2544V4C18.0118 3.44772 18.4596 3 19.0118 3C19.5641 3 20.0118 3.44772 20.0118 4V7.25C20.0118 8.2165 19.2283 9 18.2618 9H15.0118C14.4596 9 14.0118 8.55228 14.0118 8C14.0118 7.44772 14.4596 7 15.0118 7H16.9572C15.676 5.76414 13.9105 5 12 5C8.13401 5 5 8.13401 5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12ZM20 11C20.5523 11 21 11.4477 21 12C21 16.9706 16.9706 21 12 21C9.72357 21 7.60792 20.1538 6 18.7559V20C6 20.5523 5.55228 21 5 21C4.44772 21 4 20.5523 4 20V16.75C4 15.7835 4.7835 15 5.75 15H8.75C9.30228 15 9.75 15.4477 9.75 16C9.75 16.5523 9.30228 17 8.75 17H7.04284C8.32397 18.2359 10.0895 19 12 19C15.866 19 19 15.866 19 12C19 11.4477 19.4477 11 20 11Z"
                fill="currentColor"
            />
        </svg>

        <!-- upload -->
        <svg
            :width
            :height
            fill="currentColor"
            v-if="icon === 'upload'"
            :class="svgClass"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4 11.75C4.55228 11.75 5 12.1977 5 12.75V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V12.75C19 12.1977 19.4477 11.75 20 11.75C20.5523 11.75 21 12.1977 21 12.75V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V12.75C3 12.1977 3.44772 11.75 4 11.75Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L17.2071 7.79289C17.5976 8.18342 17.5976 8.81658 17.2071 9.20711C16.8166 9.59763 16.1834 9.59763 15.7929 9.20711L13 6.41421V15.25C13 15.8023 12.5523 16.25 12 16.25C11.4477 16.25 11 15.8023 11 15.25V6.41422L8.20711 9.20711C7.81658 9.59763 7.18342 9.59763 6.79289 9.20711C6.40237 8.81658 6.40237 8.18342 6.79289 7.79289L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z"
                fill="currentColor"
            />
        </svg>

        <!-- track -->
        <svg
            :width
            :height
            :class="svgClass"
            v-if="icon === 'track'"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 7C5 6.44772 5.44772 6 6 6C6.55228 6 7 6.44772 7 7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55229 5 7ZM6 4C4.34315 4 3 5.34315 3 7C3 8.30622 3.83481 9.41746 5 9.82929C5.31278 9.93985 5.64936 10 6 10C6.35064 10 6.68722 9.93985 7 9.82929C8.16519 9.41746 9 8.30622 9 7C9 5.34315 7.65685 4 6 4Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17 17C17 16.4477 17.4477 16 18 16C18.5523 16 19 16.4477 19 17C19 17.5523 18.5523 18 18 18C17.4477 18 17 17.5523 17 17ZM18 14C17.6494 14 17.3128 14.0602 17 14.1707C15.8348 14.5825 15 15.6938 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.6938 20.1652 14.5825 19 14.1707C18.6872 14.0602 18.3506 14 18 14Z"
                fill="currentColor"
            />
            <path
                d="M7 16L7 9.82929C6.68722 9.93985 6.35064 10 6 10C5.64936 10 5.31278 9.93985 5 9.82929L5 16C5 18.2091 6.79086 20 9 20C11.2091 20 13 18.2091 13 16V8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8L17 14.1707C17.3128 14.0602 17.6494 14 18 14C18.3506 14 18.6872 14.0602 19 14.1707V8C19 5.79086 17.2091 4 15 4C12.7909 4 11 5.79086 11 8V16C11 17.1046 10.1046 18 9 18C7.89543 18 7 17.1046 7 16Z"
                fill="currentColor"
            />
        </svg>

        <!-- dollar bill -->
        <svg
            :width
            :height
            :class="svgClass"
            v-if="icon === 'dollar-bill'"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6ZM21 6L3 6V18H21V6ZM4 8C4 7.44772 4.44772 7 5 7H6C6.55228 7 7 7.44772 7 8C7 8.55229 6.55228 9 6 9H5C4.44772 9 4 8.55229 4 8ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM17 16C17 15.4477 17.4477 15 18 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H18C17.4477 17 17 16.5523 17 16Z"
                fill="currentColor"
            />
        </svg>

        <!-- dollar coin -->
        <svg
            :width
            :height
            :class="svgClass"
            v-if="icon === 'dollar-coin' || icon === 'cashback'"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5V7.12367C13.804 7.32711 14.5135 7.77457 14.9759 8.41405C15.2995 8.86159 15.199 9.48674 14.7515 9.81035C14.304 10.134 13.6788 10.0335 13.3552 9.58595C13.1379 9.28549 12.6534 9 12 9H11.7222C10.8274 9 10.5 9.54492 10.5 9.77778V9.8541C10.5 10.0514 10.6491 10.3826 11.1525 10.584L13.5902 11.5591C14.6572 11.9858 15.5 12.9386 15.5 14.1459C15.5 15.6189 14.323 16.6144 13 16.9091V17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5V16.8763C10.196 16.6729 9.4865 16.2254 9.02411 15.586C8.7005 15.1384 8.80096 14.5133 9.24851 14.1897C9.69605 13.866 10.3212 13.9665 10.6448 14.414C10.8621 14.7145 11.3466 15 12 15H12.1824C13.1298 15 13.5 14.4209 13.5 14.1459C13.5 13.9486 13.3509 13.6174 12.8475 13.416L10.4098 12.4409C9.34283 12.0142 8.5 11.0614 8.5 9.8541V9.77778C8.5 8.31377 9.68936 7.33904 11 7.07331V6.5C11 5.94772 11.4477 5.5 12 5.5Z"
                fill="currentColor"
            />
        </svg>

        <!-- Hilton -->

        <svg
            width="54"
            height="16"
            :class="svgClass"
            v-if="icon === 'hilton'"
            viewBox="0 0 54 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="37" height="16" fill="white" />
            <path
                d="M-0.000488281 0V14.7494H6.58602V14.1156H0.627653V0.6338H36.2522V14.1156H30.24V14.7494H36.8804V0H-0.000488281Z"
                fill="#231F20"
            />
            <path
                d="M9.93138 15.8629V14.6587H8.4059V15.8629H7.87646V12.9927H8.4059V14.1788H9.93138V12.9927H10.4608V15.8629H9.93138Z"
                fill="#231F20"
            />
            <path
                d="M14.5527 14.4237C14.5796 15.2657 13.9245 15.972 13.09 15.9991C12.2555 16.0263 11.5556 15.3653 11.5286 14.5233C11.5017 13.6812 12.1568 12.975 12.9913 12.9478C13.0093 12.9478 13.0272 12.9478 13.0362 12.9478C13.8617 12.9388 14.5347 13.5998 14.5527 14.4237ZM12.085 14.4237C12.085 14.9579 12.5157 15.3925 13.0541 15.3925C13.5836 15.3925 14.0143 14.9579 14.0143 14.4146C14.0143 13.8714 13.5836 13.4458 13.0451 13.4458C12.5157 13.4458 12.094 13.8714 12.085 14.4056C12.076 14.4146 12.076 14.4237 12.085 14.4237Z"
                fill="#231F20"
            />
            <path
                d="M17.6155 15.8624L16.1259 13.8523V15.8624H15.6055V12.9922H16.1618L17.6514 15.0022V12.9922H18.1719V15.8624H17.6155Z"
                fill="#231F20"
            />
            <path
                d="M22.2368 14.4237C22.2637 15.2657 21.6086 15.972 20.7741 15.9991C19.9396 16.0263 19.2396 15.3653 19.2127 14.5233C19.1858 13.6812 19.8409 12.975 20.6754 12.9478C20.6933 12.9478 20.7113 12.9478 20.7203 12.9478C21.5458 12.9388 22.2188 13.5998 22.2368 14.4237ZM19.7601 14.4237C19.7601 14.9579 20.1998 15.3925 20.7292 15.3834C21.2587 15.3834 21.6894 14.9398 21.6804 14.4056C21.6804 13.8714 21.2497 13.4458 20.7203 13.4458C20.1908 13.4277 19.7511 13.8533 19.7421 14.3784C19.7421 14.3965 19.7421 14.4056 19.7421 14.4237H19.7601Z"
                fill="#231F20"
            />
            <path
                d="M24.542 12.9922C25.4214 12.9922 25.7714 13.2729 25.7714 13.9338C25.8253 14.3413 25.556 14.7216 25.1522 14.803L25.8611 15.8624H25.2509L24.5869 14.8755H24.4074H23.8421V15.8624H23.3037V12.9922H24.542ZM23.8421 14.459H24.5869C25.0625 14.459 25.242 14.3141 25.242 13.961C25.242 13.6079 25.0625 13.463 24.5869 13.463H23.8421V14.459Z"
                fill="#231F20"
            />
            <path
                d="M29.0019 13.2564L28.7775 13.6729C28.4724 13.5008 28.1314 13.4103 27.7815 13.4012C27.5212 13.4012 27.2969 13.5099 27.2969 13.7543C27.2969 13.9083 27.3866 13.9898 27.9161 14.1346C28.616 14.3248 29.0826 14.4515 29.0826 15.04C29.0826 15.6286 28.607 15.9093 27.934 15.9093C27.4674 15.9183 27.0008 15.7825 26.606 15.529L26.8303 15.1215C27.1803 15.3298 27.5751 15.4384 27.9789 15.4384C28.266 15.4384 28.5083 15.3298 28.5083 15.0853C28.5083 14.8409 28.3199 14.7594 27.7635 14.6145C27.0995 14.4425 26.7316 14.2885 26.7316 13.8087C26.7316 13.2111 27.2341 12.9395 27.8533 12.9395C28.2481 12.9485 28.6429 13.0572 29.0019 13.2564Z"
                fill="#231F20"
            />
            <path
                d="M9.83335 3.62188V10.1953L10.3448 10.2677V10.6571H7.81433V10.2677L8.36171 10.1953V7.20738H5.13127V10.1953L5.62481 10.2677V10.6571H3.13916V10.2677L3.64167 10.1953V3.62188L3.13916 3.5585V3.17822H5.62481V3.5585L5.13127 3.62188V6.43777H8.36171V3.62188L7.81433 3.5585V3.17822H10.3448V3.5585L9.83335 3.62188Z"
                fill="#231F20"
            />
            <path
                d="M13.2875 10.2505L13.7631 10.3138V10.6579H11.439V10.3138L11.9146 10.2505V5.75048L11.439 5.67805V5.33398H13.2875V10.2505Z"
                fill="#231F20"
            />
            <path
                d="M14.7715 10.3221L15.2381 10.2587V3.57661L14.7715 3.51323V3.17822H16.629V10.2587L17.1046 10.3221V10.6571H14.7715V10.3221Z"
                fill="#231F20"
            />
            <path
                d="M19.9315 5.33317H21.1788V5.83116H19.9315V9.00016C19.9315 9.81505 20.102 10.0776 20.8378 10.0776C21.0891 10.0867 21.3403 10.0686 21.5826 10.0233V10.4036C21.0352 10.6118 20.4519 10.7295 19.8687 10.7476C18.8008 10.7476 18.5496 10.2587 18.5496 9.32612V5.84022H17.5625V5.33317H18.5765V4.20139L19.9315 3.79395V5.33317Z"
                fill="#231F20"
            />
            <path
                d="M27.4291 8.04963C27.4291 9.70657 26.3074 10.8202 24.5666 10.8202C22.8795 10.8202 21.8027 10.0959 21.8027 8.04963C21.8027 6.33837 22.9244 5.18848 24.6653 5.18848C26.4061 5.18848 27.4291 6.22067 27.4291 8.04963ZM25.9036 8.01342C25.9036 6.32932 25.4011 5.59592 24.6025 5.59592C23.8038 5.59592 23.3192 6.30216 23.3192 8.01342C23.3192 9.72468 23.8218 10.4037 24.6025 10.4037C25.446 10.4037 25.9036 9.73373 25.9036 8.01342Z"
                fill="#231F20"
            />
            <path
                d="M33.7406 10.3126V10.6476H31.4165V10.3126L31.8831 10.2492V7.21602C31.8831 6.38303 31.578 6.0118 30.923 6.0118C30.5192 6.05707 30.1333 6.211 29.8013 6.45546V10.2492L30.2769 10.3126V10.6476H27.9707V10.3126L28.4463 10.2492V5.77639L27.9707 5.71301V5.33273H29.8372V6.08424C30.4115 5.62247 30.9589 5.24219 31.7575 5.24219C32.7984 5.24219 33.265 5.85788 33.265 7.0621V10.2583L33.7406 10.3126Z"
                fill="#231F20"
            />
            <path
                d="M13.348 3.92973C13.348 4.34623 13.016 4.68124 12.6032 4.68124C12.1904 4.68124 11.8584 4.34623 11.8584 3.92973C11.8584 3.51323 12.1904 3.17822 12.6032 3.17822C13.016 3.17822 13.348 3.51323 13.348 3.92973Z"
                fill="#231F20"
            />
        </svg>

        <!-- Chase -->

        <svg
            width="54"
            height="16"
            :class="svgClass"
            v-if="icon === 'chase'"
            viewBox="0 0 54 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M34.1094 4.19141V11.8011H40.7418L39.9053 10.4621H35.6272V8.53336H39.7694V7.24241H35.6272V5.50037H39.8962L40.7217 4.19141H34.1094Z"
                fill="#141414"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.71911 4.19141C1.14652 4.19141 0.351562 5.15926 0.351562 6.57129V9.41107C0.351562 11.0422 1.37457 11.8044 2.71 11.8044L7.45287 11.8025L6.57397 10.4117H3.00371C2.24478 10.4117 1.91412 10.1349 1.91412 9.27428V6.69655C1.91412 5.86412 2.19325 5.53919 3.02469 5.53919H6.61137L7.45512 4.19141H2.71911Z"
                fill="#141414"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.4773 4.19187C26.5683 4.19187 25.6379 4.74605 25.6379 6.16825V6.53339C25.6379 8.01523 26.5336 8.58094 27.4298 8.5879H30.5746C30.9025 8.5879 31.1666 8.64152 31.1666 9.20031V9.84694C31.1579 10.3503 30.9112 10.4644 30.5641 10.4644H26.4265L25.5781 11.8034H30.6617C31.8872 11.8034 32.7186 11.1859 32.7186 9.75819V9.23452C32.7186 7.85577 31.9442 7.20173 30.747 7.20173H27.7441C27.4112 7.20173 27.179 7.11254 27.179 6.61012L27.1786 6.08459C27.1786 5.6589 27.3395 5.5036 27.7272 5.5036L31.6646 5.50083L32.4892 4.19141L27.4773 4.19187Z"
                fill="#141414"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.9067 4.19922L16.3438 11.8085H18.0267L18.7209 10.2393H22.5912L23.2813 11.8085H24.972L21.4045 4.19922H19.9067ZM20.6515 5.77949L22.0211 8.94189H19.2915L20.6515 5.77949Z"
                fill="#141414"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M47.0595 3C46.8655 3 46.7109 3.15854 46.7109 3.35497V5.82776H53.1612L50.2231 3H47.0595Z"
                fill="#005EB8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M53.3899 6.57671C53.3899 6.38027 53.2353 6.22266 53.0405 6.22266H50.6016V12.7591L53.3899 9.78301V6.57671Z"
                fill="#005EB8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M49.8665 12.9987C50.058 12.9987 50.2168 12.8402 50.2168 12.6447V10.1719H43.7656L46.7021 12.9983L49.8665 12.9987Z"
                fill="#005EB8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.5234 9.4235C43.5234 9.61763 43.6809 9.77521 43.8728 9.77521H46.3139V3.23828L43.526 6.21626L43.5234 9.4235Z"
                fill="#005EB8"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.0042 4.19141V7.21053H9.85431V4.19141H8.34375V11.8044H9.85431V8.53336H14.0042V11.8044H15.5189V4.19141H14.0042Z"
                fill="#141414"
            />
        </svg>

        <svg
            v-if="icon === 'broken-chain'"
            :width
            :height
            :class="svgClass"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9987 1.83325C12.7351 1.83325 13.332 2.43021 13.332 3.16659V4.49992C13.332 5.2363 12.7351 5.83325 11.9987 5.83325C11.2623 5.83325 10.6654 5.2363 10.6654 4.49992V3.16659C10.6654 2.43021 11.2623 1.83325 11.9987 1.83325ZM17.242 4.19393C18.5245 3.40801 20.1395 3.40801 21.422 4.19393C21.83 4.44391 22.2009 4.81561 22.6313 5.2468C22.6626 5.27814 22.6942 5.3098 22.7261 5.34174L27.1569 9.77247C27.1888 9.80442 27.2205 9.83602 27.2518 9.86731C27.683 10.2977 28.0547 10.6687 28.3047 11.0766C29.0906 12.3591 29.0906 13.9741 28.3047 15.2566L27.1678 14.5599L28.3047 15.2566C28.0547 15.6645 27.683 16.0355 27.2518 16.4659C27.2205 16.4971 27.1888 16.5287 27.1569 16.5607L24.9415 18.7761C24.4208 19.2968 23.5766 19.2968 23.0559 18.7761C22.5352 18.2554 22.5352 17.4111 23.0559 16.8904L25.2713 14.6751C25.8516 14.0947 25.9693 13.9639 26.031 13.8632C26.293 13.4357 26.293 12.8974 26.031 12.4699C25.9693 12.3693 25.8516 12.2385 25.2712 11.6581L20.8405 7.22736L21.7833 6.28455L20.8405 7.22736C20.2602 6.647 20.1293 6.5293 20.0287 6.46763C19.6012 6.20566 19.0629 6.20566 18.6354 6.46763C18.5347 6.5293 18.4039 6.647 17.8235 7.22736L16.8807 6.28456L17.8235 7.22736L15.6082 9.44273C15.0875 9.96343 14.2433 9.96343 13.7226 9.44273C13.2019 8.92203 13.2019 8.07781 13.7226 7.55711L15.9379 5.34175C15.9699 5.3098 16.0015 5.27814 16.0328 5.24679C16.4631 4.81561 16.8341 4.44391 17.242 4.19393ZM3.72256 4.22378C4.24325 3.70308 5.08747 3.70308 5.60817 4.22378L6.94151 5.55711C7.46221 6.07781 7.46221 6.92203 6.94151 7.44273C6.42081 7.96343 5.57659 7.96343 5.05589 7.44273L3.72256 6.10939C3.20186 5.58869 3.20186 4.74448 3.72256 4.22378ZM1.33203 12.4999C1.33203 11.7635 1.92898 11.1666 2.66536 11.1666H3.9987C4.73508 11.1666 5.33203 11.7635 5.33203 12.4999C5.33203 13.2363 4.73508 13.8333 3.9987 13.8333H2.66536C1.92898 13.8333 1.33203 13.2363 1.33203 12.4999ZM8.94151 14.2238C9.46221 14.7445 9.46221 15.5887 8.94151 16.1094L6.72614 18.3248C6.14578 18.9051 6.02808 19.0359 5.96641 19.1366C5.70444 19.5641 5.70444 20.1024 5.96641 20.5299C6.02808 20.6306 6.14578 20.7614 6.72614 21.3417L5.78333 22.2846L6.72614 21.3417L11.1569 25.7725L10.2141 26.7153L11.1569 25.7725C11.7372 26.3528 11.8681 26.4705 11.9687 26.5322C12.3962 26.7942 12.9345 26.7942 13.362 26.5322C13.4627 26.4705 13.5935 26.3528 14.1739 25.7725L16.3892 23.5571C16.9099 23.0364 17.7541 23.0364 18.2748 23.5571C18.7955 24.0778 18.7955 24.922 18.2748 25.4427L16.0595 27.6581C16.0275 27.69 15.9959 27.7217 15.9646 27.7531C15.5343 28.1842 15.1633 28.5559 14.7554 28.8059L14.0587 27.6691L14.7554 28.8059C13.4729 29.5918 11.8579 29.5918 10.5754 28.8059C10.1674 28.5559 9.79641 28.1842 9.36604 27.753C9.33477 27.7217 9.30318 27.69 9.27125 27.6581L4.84053 23.2274C4.80858 23.1954 4.77691 23.1638 4.74557 23.1325C4.31438 22.7022 3.94269 22.3312 3.69271 21.9232C2.90679 20.6407 2.90679 19.0258 3.69271 17.7433C3.94269 17.3353 4.31439 16.9643 4.74557 16.534C4.77692 16.5027 4.80858 16.4711 4.84052 16.4391L7.05589 14.2238C7.57659 13.7031 8.42081 13.7031 8.94151 14.2238ZM26.6654 20.4999C26.6654 19.7635 27.2623 19.1666 27.9987 19.1666H29.332C30.0684 19.1666 30.6654 19.7635 30.6654 20.4999C30.6654 21.2363 30.0684 21.8333 29.332 21.8333H27.9987C27.2623 21.8333 26.6654 21.2363 26.6654 20.4999ZM25.0559 25.5571C25.5766 25.0364 26.4208 25.0364 26.9415 25.5571L28.2748 26.8904C28.7955 27.4111 28.7955 28.2554 28.2748 28.7761C27.7541 29.2968 26.9099 29.2968 26.3892 28.7761L25.0559 27.4427C24.5352 26.922 24.5352 26.0778 25.0559 25.5571ZM19.9987 27.1666C20.7351 27.1666 21.332 27.7635 21.332 28.4999V29.8333C21.332 30.5696 20.7351 31.1666 19.9987 31.1666C19.2623 31.1666 18.6654 30.5696 18.6654 29.8333V28.4999C18.6654 27.7635 19.2623 27.1666 19.9987 27.1666Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'arrow'"
            width="28"
            height="36"
            viewBox="0 0 28 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.7441 14.0773C16.0695 13.7519 16.5972 13.7519 16.9226 14.0773L19.6667 16.8214C20.3175 17.4723 20.3175 18.5276 19.6667 19.1784L16.9226 21.9225C16.5972 22.2479 16.0695 22.2479 15.7441 21.9225C15.4186 21.5971 15.4186 21.0694 15.7441 20.744L18.4882 17.9999L15.7441 15.2558C15.4186 14.9304 15.4186 14.4028 15.7441 14.0773Z"
                fill="currentColor"
            />
            <defs>
                <filter
                    id="filter0_d_20_7499"
                    x="-2"
                    y="-1"
                    width="40"
                    height="40"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_20_7499"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_20_7499"
                        result="shape"
                    />
                </filter>
                <clipPath id="clip0_20_7499">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(8 8)"
                    />
                </clipPath>
            </defs>
        </svg>
        <!-- GRAPH / TIERED ICON -->
        <svg
            v-if="icon === 'graph' || icon === 'tiered'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M7.7737 16.8407V12.674H4.16536C3.70513 12.674 3.33203 13.0471 3.33203 13.5073V16.0073C3.33203 16.4676 3.70513 16.8407 4.16536 16.8407H7.7737ZM7.7737 16.8407H12.2154M7.7737 16.8407L7.77371 8.92399C7.77371 8.46375 8.14681 8.09066 8.60705 8.09066H12.2154V16.8407M12.2154 16.8407L12.2153 4.34066C12.2153 3.88042 12.5884 3.50732 13.0487 3.50732H15.8237C16.2839 3.50732 16.657 3.88042 16.657 4.34066V16.0073C16.657 16.4676 16.2839 16.8407 15.8237 16.8407H12.2154Z"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="square"
                stroke-linejoin="round"
            />
        </svg>
        <!-- GRID ICON (category placeholder, v2 spec) -->
        <svg
            v-if="icon === 'grid'"
            :width="width"
            :height="height"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M6 13C6 12.4477 5.55228 12 5 12H3C2.44772 12 2 12.4477 2 13V15C2 15.5523 2.44772 16 3 16H5C5.55228 16 6 15.5523 6 15V13ZM16 13C16 12.4477 15.5523 12 15 12H13C12.4477 12 12 12.4477 12 13V15C12 15.5523 12.4477 16 13 16H15C15.5523 16 16 15.5523 16 15V13ZM6 3C6 2.44772 5.55228 2 5 2H3C2.44772 2 2 2.44772 2 3V5C2 5.55228 2.44772 6 3 6H5C5.55228 6 6 5.55228 6 5V3ZM16 3C16 2.44772 15.5523 2 15 2H13C12.4477 2 12 2.44772 12 3V5C12 5.55228 12.4477 6 13 6H15C15.5523 6 16 5.55228 16 5V3ZM8 15C8 16.6569 6.65685 18 5 18H3C1.34315 18 0 16.6569 0 15V13C0 11.3431 1.34315 10 3 10H5C6.65685 10 8 11.3431 8 13V15ZM18 15C18 16.6569 16.6569 18 15 18H13C11.3431 18 10 16.6569 10 15V13C10 11.3431 11.3431 10 13 10H15C16.6569 10 18 11.3431 18 13V15ZM8 5C8 6.65685 6.65685 8 5 8H3C1.34315 8 0 6.65685 0 5V3C0 1.34315 1.34315 0 3 0H5C6.65685 0 8 1.34315 8 3V5ZM18 5C18 6.65685 16.6569 8 15 8H13C11.3431 8 10 6.65685 10 5V3C10 1.34315 11.3431 0 13 0H15C16.6569 0 18 1.34315 18 3V5Z"
                fill="currentColor"
            />
        </svg>
        <!-- BANK ADD ICON (add bank connection, v2 spec) -->
        <svg
            v-if="icon === 'bank-add'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M10.4165 15.8333C10.8767 15.8333 11.2498 16.2064 11.2498 16.6667C11.2498 17.1269 10.8767 17.5 10.4165 17.5H3.65621C3.19615 17.5 2.8231 17.1275 2.82288 16.6675C2.82285 16.2073 3.19598 15.8334 3.65621 15.8333H10.4165ZM4.16646 14.1667V10C4.16668 9.54004 4.53983 9.16683 4.9998 9.16667C5.4599 9.16667 5.83292 9.53994 5.83313 10V14.1667C5.83313 14.6269 5.46003 15 4.9998 15C4.5397 14.9998 4.16646 14.6268 4.16646 14.1667ZM9.16646 14.1667V10C9.16668 9.54004 9.53983 9.16683 9.9998 9.16667C10.4599 9.16667 10.8329 9.53994 10.8331 10V14.1667C10.8331 14.6269 10.46 15 9.9998 15C9.5397 14.9998 9.16646 14.6268 9.16646 14.1667ZM14.1665 10.8333V10C14.1667 9.54003 14.5398 9.16683 14.9998 9.16667C15.46 9.16672 15.8332 9.54058 15.8331 10.0008V10.8333C15.8331 11.2936 15.46 11.6667 14.9998 11.6667C14.5396 11.6666 14.1665 11.2935 14.1665 10.8333ZM8.65784 1.5332C9.47674 1.01211 10.5237 1.01209 11.3426 1.5332L17.1995 5.26123C18.6062 6.1564 17.9725 8.33325 16.3051 8.33333H3.69527C2.02798 8.33333 1.39376 6.15655 2.80009 5.26123L8.65784 1.5332ZM10.4474 2.93945C10.1745 2.76587 9.82592 2.76593 9.55302 2.93945L3.69527 6.66667H16.3051L10.4474 2.93945Z"
                fill="currentColor"
            />
            <path
                d="M15 18.3333V16.6667H13.3333C12.8731 16.6667 12.5 16.2936 12.5 15.8333C12.5 15.3731 12.8731 15 13.3333 15H15V13.3333C15 12.8731 15.3731 12.5 15.8333 12.5C16.2936 12.5 16.6667 12.8731 16.6667 13.3333V15H18.3333C18.7936 15 19.1667 15.3731 19.1667 15.8333C19.1667 16.2936 18.7936 16.6667 18.3333 16.6667H16.6667V18.3333C16.6667 18.7936 16.2936 19.1667 15.8333 19.1667C15.3731 19.1667 15 18.7936 15 18.3333Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'flame'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.1576 2.87872C11.742 2.04384 12.9147 1.74205 13.8306 2.37181C14.7823 3.02616 16.428 4.29085 17.8444 6.06625C19.2602 7.84076 20.5 10.1941 20.5 12.9999C20.5 17.9973 16.7478 21.9999 12 21.9999C7.25223 21.9999 3.5 17.9973 3.5 12.9999C3.5 10.9645 4.37408 8.36394 6.07753 6.2877C6.82386 5.37804 8.11166 5.4323 8.86407 6.15513L11.1576 2.87872ZM12 19.9999C13.4497 19.9999 14.625 18.6584 14.625 17.0035C14.625 15.2278 13.2438 13.9216 12.4852 13.3381C12.1956 13.1153 11.8044 13.1153 11.5148 13.3381C10.7562 13.9216 9.375 15.2278 9.375 17.0035C9.375 18.6584 10.5503 19.9999 12 19.9999Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'chevron-down-small'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.07611 7.74408C6.40155 7.41864 6.92918 7.41864 7.25462 7.74408L9.9987 10.4882L12.7428 7.74408C13.0682 7.41864 13.5958 7.41864 13.9213 7.74408C14.2467 8.06951 14.2467 8.59715 13.9213 8.92259L11.1772 11.6667C10.5263 12.3175 9.47106 12.3175 8.82019 11.6667L6.07611 8.92259C5.75067 8.59715 5.75067 8.06951 6.07611 7.74408Z"
                fill="currentColor"
            />
        </svg>

        <!-- CHEVRON GRABBER VERTICAL (up/down selector) -->
        <svg
            v-if="icon === 'chevron-grabber-vertical'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.66699 7.49987L9.41107 4.7558C9.73651 4.43036 10.2641 4.43036 10.5896 4.7558L13.3337 7.49987M6.66699 12.4999L9.41107 15.244C9.73651 15.5694 10.2641 15.5694 10.5896 15.244L13.3337 12.4999"
                stroke="#1E293B"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- switch-horizontal (arrows left-right for sync/connection) -->
        <svg
            v-if="icon === 'switch-horizontal'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.338 10.2444C14.0126 9.919 13.485 9.91896 13.1596 10.2444C12.8343 10.5698 12.8343 11.0973 13.1596 11.4228L15.0704 13.3336H3.33216C2.87198 13.3336 2.49882 13.7067 2.49882 14.1669C2.49882 14.6271 2.87198 15.0002 3.33216 15.0002H15.0704L13.1596 16.911C12.8343 17.2365 12.8343 17.764 13.1596 18.0894C13.485 18.4148 14.0126 18.4148 14.338 18.0894L17.0822 15.3453C17.733 14.6944 17.733 13.6394 17.0822 12.9885L14.338 10.2444ZM6.83802 1.91104C6.51257 1.58566 5.98505 1.58562 5.65963 1.91104L2.91549 4.65518C2.26478 5.30602 2.26478 6.36111 2.91549 7.01195L5.65963 9.75609C5.98505 10.0815 6.51257 10.0815 6.83802 9.75609C7.16345 9.43065 7.16345 8.90314 6.83802 8.5777L4.92721 6.6669H16.6655C17.1257 6.6669 17.4988 6.2938 17.4988 5.83356C17.4988 5.37333 17.1257 5.00023 16.6655 5.00023H4.92721L6.83802 3.08942C7.16345 2.76399 7.16345 2.23648 6.83802 1.91104Z"
                fill="#64748B"
            />
        </svg>
        <svg
            v-if="icon === 'sparkles'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_90_3319)">
                <path
                    d="M5.33464 10.667C5.33464 11.0352 5.63311 11.3337 6.0013 11.3337C6.36949 11.3337 6.66797 11.0352 6.66797 10.667C6.66797 9.128 7.00851 8.17204 7.59076 7.58978C8.17301 7.00753 9.12898 6.66699 10.668 6.66699C11.0362 6.66699 11.3346 6.36852 11.3346 6.00033C11.3346 5.63214 11.0362 5.33366 10.668 5.33366C9.12898 5.33366 8.17301 4.99312 7.59076 4.41087C7.00851 3.82861 6.66797 2.87265 6.66797 1.33366C6.66797 0.965469 6.36949 0.666992 6.0013 0.666992C5.63311 0.666992 5.33464 0.965469 5.33464 1.33366C5.33464 2.87265 4.99409 3.82861 4.41184 4.41087C3.82959 4.99312 2.87363 5.33366 1.33464 5.33366C0.966446 5.33366 0.667969 5.63214 0.667969 6.00033C0.667969 6.36852 0.966446 6.66699 1.33464 6.66699C2.87363 6.66699 3.82959 7.00753 4.41184 7.58978C4.99409 8.17204 5.33464 9.128 5.33464 10.667Z"
                    fill="white"
                />
                <path
                    d="M11.0013 14.667C11.0013 15.0352 11.2998 15.3337 11.668 15.3337C12.0362 15.3337 12.3346 15.0352 12.3346 14.667C12.3346 13.7067 12.5479 13.1674 12.8581 12.8571C13.1684 12.5469 13.7077 12.3337 14.668 12.3337C15.0362 12.3337 15.3346 12.0352 15.3346 11.667C15.3346 11.2988 15.0362 11.0003 14.668 11.0003C13.7077 11.0003 13.1684 10.7871 12.8581 10.4768C12.5479 10.1666 12.3346 9.62728 12.3346 8.66699C12.3346 8.2988 12.0362 8.00033 11.668 8.00033C11.2998 8.00033 11.0013 8.2988 11.0013 8.66699C11.0013 9.62728 10.7881 10.1666 10.4778 10.4768C10.1676 10.7871 9.62825 11.0003 8.66797 11.0003C8.29978 11.0003 8.0013 11.2988 8.0013 11.667C8.0013 12.0352 8.29978 12.3337 8.66797 12.3337C9.62825 12.3337 10.1676 12.5469 10.4778 12.8571C10.7881 13.1674 11.0013 13.7067 11.0013 14.667Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_90_3319">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'base-coins'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0013 3.33366C6.3194 3.33366 3.33464 6.31843 3.33464 10.0003C3.33464 13.6822 6.3194 16.667 10.0013 16.667C13.6832 16.667 16.668 13.6822 16.668 10.0003C16.668 6.31843 13.6832 3.33366 10.0013 3.33366ZM1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699C14.6037 1.66699 18.3346 5.39795 18.3346 10.0003C18.3346 14.6027 14.6037 18.3337 10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003ZM10.0013 4.58366C10.4615 4.58366 10.8346 4.95676 10.8346 5.41699V5.93671C11.5047 6.10625 12.0959 6.47914 12.4812 7.01203C12.7509 7.38499 12.6672 7.90594 12.2942 8.17561C11.9213 8.44529 11.4003 8.36157 11.1306 7.98862C10.9496 7.73823 10.5458 7.50033 10.0013 7.50033H9.76982C9.02417 7.50033 8.7513 7.95443 8.7513 8.14847V8.21208C8.7513 8.37646 8.87558 8.65251 9.29509 8.82031L11.3265 9.63288C12.2156 9.98852 12.918 10.7825 12.918 11.7886C12.918 13.0161 11.9371 13.8457 10.8346 14.0912V14.5837C10.8346 15.0439 10.4615 15.417 10.0013 15.417C9.54106 15.417 9.16797 15.0439 9.16797 14.5837V14.0639C8.49793 13.8944 7.90672 13.5215 7.52139 12.9886C7.25172 12.6157 7.33544 12.0947 7.70839 11.825C8.08134 11.5554 8.60229 11.6391 8.87197 12.012C9.05302 12.2624 9.45679 12.5003 10.0013 12.5003H10.1533C10.9428 12.5003 11.2513 12.0177 11.2513 11.7886C11.2513 11.6242 11.127 11.3481 10.7075 11.1803L8.6761 10.3678C7.78699 10.0121 7.08464 9.21816 7.08464 8.21208V8.14847C7.08464 6.92847 8.07577 6.1162 9.16797 5.89475V5.41699C9.16797 4.95676 9.54106 4.58366 10.0013 4.58366Z"
                fill="#64748B"
            />
        </svg>

        <svg
            v-if="icon === 'check-green'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5905 3.193C22.0362 3.51911 22.1332 4.1448 21.8071 4.59053L10.1012 20.5905C9.94056 20.8101 9.69734 20.9548 9.42768 20.9911C9.15802 21.0274 8.8852 20.9523 8.67214 20.7831L2.37802 15.7831C1.94558 15.4395 1.8735 14.8105 2.21703 14.3781C2.56056 13.9456 3.18961 13.8735 3.62205 14.2171L9.10146 18.5699L20.193 3.40961C20.5191 2.96388 21.1448 2.8669 21.5905 3.193Z"
                fill="#10B981"
            />
        </svg>
        <svg
            v-if="icon === 'warning'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.8611 4.49407C12.477 3.83531 11.5259 3.83531 11.1418 4.49408L4.14013 16.5017C3.75255 17.1665 4.23223 18 4.99982 18H19.0031C19.7707 18 20.2504 17.1665 19.8628 16.5017L12.8611 4.49407ZM9.41404 3.48664C10.5698 1.50446 13.4331 1.50445 14.5889 3.48664L21.5905 15.4943C22.7548 17.4911 21.3155 20 19.0031 20H4.99982C2.6874 20 1.24807 17.4911 2.4124 15.4943L9.41404 3.48664ZM12.0015 8.01917C12.5537 8.01917 13.0015 8.46689 13.0015 9.01917V12.0134C13.0015 12.5657 12.5537 13.0134 12.0015 13.0134C11.4492 13.0134 11.0015 12.5657 11.0015 12.0134V9.01917C11.0015 8.46689 11.4492 8.01917 12.0015 8.01917ZM10.7515 15C10.7515 14.3096 11.3111 13.75 12.0015 13.75C12.6918 13.75 13.2515 14.3096 13.2515 15C13.2515 15.6904 12.6918 16.25 12.0015 16.25C11.3111 16.25 10.7515 15.6904 10.7515 15Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <svg
            v-if="icon === 'win'"
            width="230"
            height="229"
            viewBox="0 0 260 259"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                opacity="0.8"
                cx="130.001"
                cy="128.109"
                r="84.0323"
                transform="rotate(11.3725 130.001 128.109)"
                stroke="url(#paint0_radial_203_2987)"
                stroke-width="91.7965"
                stroke-miterlimit="3.13764"
                stroke-dasharray="44.35 49.51"
            />
            <g filter="url(#filter0_dddd_203_2987)">
                <path
                    d="M169.514 127.505C169.514 130.288 168.846 132.868 167.509 135.231C166.512 136.994 165.264 138.471 163.759 139.643C162.825 140.37 162.223 141.51 162.223 142.693C162.223 146.906 160.809 150.481 158.011 153.435C155.197 156.404 151.808 157.881 147.844 157.881C147.671 157.881 147.499 157.878 147.327 157.872C144.697 157.776 141.943 158.825 140.145 160.748C139.335 161.615 138.419 162.39 137.397 163.073C135.066 164.659 132.501 165.436 129.718 165.436C126.873 165.436 124.293 164.674 121.992 163.12C120.984 162.45 120.08 161.681 119.277 160.81C117.48 158.862 114.714 157.787 112.065 157.873C111.908 157.878 111.751 157.881 111.592 157.881C107.628 157.881 104.224 156.404 101.379 153.435C98.534 150.481 97.1194 146.89 97.1194 142.693C97.1194 141.502 96.5999 140.368 95.6605 139.635C94.156 138.461 92.9085 136.993 91.9117 135.231C90.5903 132.868 89.9219 130.288 89.9219 127.505C89.9219 124.552 90.6681 121.831 92.1449 119.375C92.7899 118.302 93.5328 117.351 94.3723 116.521C96.212 114.703 97.3035 112.05 97.1463 109.469C97.1283 109.174 97.1194 108.88 97.1194 108.587C97.1194 104.389 98.534 100.798 101.379 97.8448C104.224 94.8912 107.628 93.3988 111.592 93.3988C111.765 93.3988 111.937 93.4019 112.109 93.4081C114.739 93.5036 117.493 92.4543 119.291 90.5317C120.101 89.6646 121.017 88.89 122.039 88.2066C124.37 86.6366 126.935 85.8438 129.718 85.8438C132.501 85.8438 135.066 86.6366 137.397 88.1911C138.413 88.8751 139.329 89.6507 140.142 90.5189C141.94 92.4406 144.696 93.4867 147.327 93.3925C147.498 93.3863 147.671 93.3833 147.844 93.3833C151.808 93.3833 155.197 94.8601 158.011 97.8292C160.824 100.798 162.223 104.374 162.223 108.571C162.223 108.863 162.217 109.151 162.204 109.435C162.084 112.02 163.225 114.688 165.065 116.507C165.904 117.337 166.646 118.287 167.291 119.36C168.768 121.831 169.514 124.552 169.514 127.505ZM128.024 139.491L144.455 114.882C144.875 114.23 144.999 113.514 144.859 112.753C144.704 111.991 144.315 111.385 143.662 110.981C143.009 110.561 142.294 110.421 141.532 110.53C140.755 110.654 140.133 111.027 139.667 111.68L128.572 128.365C126.824 130.992 123.11 131.365 120.877 129.136L118.525 126.79C117.935 126.2 117.251 125.92 116.489 125.951C115.712 125.982 115.043 126.262 114.452 126.79C113.924 127.319 113.66 127.987 113.66 128.796C113.66 129.588 113.924 130.257 114.452 130.801L123.609 139.957L124.059 140.315C124.588 140.672 125.132 140.843 125.661 140.843C126.702 140.828 127.495 140.392 128.024 139.491Z"
                    fill="#FF5331"
                />
                <path
                    d="M128.024 139.491L144.455 114.882C144.875 114.23 144.999 113.514 144.859 112.753C144.704 111.991 144.315 111.385 143.662 110.981C143.009 110.561 142.294 110.421 141.532 110.53C140.755 110.654 140.133 111.027 139.667 111.68L128.572 128.365C126.824 130.992 123.11 131.365 120.877 129.136L118.525 126.79C117.935 126.2 117.251 125.92 116.489 125.951C115.712 125.982 115.043 126.262 114.452 126.79C113.924 127.319 113.66 127.987 113.66 128.796C113.66 129.588 113.924 130.257 114.452 130.801L123.609 139.957L124.059 140.315C124.588 140.672 125.132 140.843 125.661 140.843C126.702 140.828 127.495 140.392 128.024 139.491Z"
                    fill="#FF5331"
                />
                <path
                    d="M159.099 154.467L159.099 154.467C162.168 151.227 163.723 147.28 163.723 142.693C163.723 142.01 164.081 141.293 164.681 140.826C166.355 139.522 167.728 137.889 168.814 135.97C170.282 133.375 171.014 130.539 171.014 127.505C171.014 124.286 170.197 121.299 168.579 118.59L168.577 118.587C167.871 117.413 167.052 116.363 166.12 115.441C164.554 113.893 163.604 111.627 163.702 109.505C163.716 109.197 163.723 108.886 163.723 108.571C163.723 104.002 162.185 100.054 159.099 96.7974C156.011 93.5386 152.232 91.8833 147.844 91.8833C147.653 91.8833 147.463 91.8866 147.273 91.8934C145.041 91.9734 142.716 91.0741 141.237 89.4939C140.344 88.5399 139.341 87.6915 138.235 86.9469L138.229 86.943C135.657 85.2282 132.804 84.3438 129.718 84.3438C126.632 84.3438 123.777 85.2281 121.203 86.9611C120.09 87.7057 119.086 88.5538 118.195 89.5072C116.716 91.0889 114.393 91.99 112.163 91.9091C111.974 91.9022 111.783 91.8988 111.592 91.8988C107.201 91.8988 103.412 93.5715 100.298 96.8042C97.175 100.047 95.6194 104.015 95.6194 108.587C95.6194 108.911 95.6293 109.235 95.649 109.56C95.7782 111.68 94.8717 113.919 93.318 115.455C92.3845 116.377 91.5652 117.428 90.8593 118.602C89.2384 121.298 88.4219 124.287 88.4219 127.505C88.4219 130.539 89.1535 133.372 90.6025 135.963L90.6025 135.963L90.6062 135.97C91.6935 137.892 93.0673 139.514 94.7377 140.818C95.2903 141.249 95.6194 141.934 95.6194 142.693C95.6194 147.264 97.1747 151.232 100.298 154.475C103.415 157.727 107.205 159.381 111.592 159.381C111.767 159.381 111.941 159.378 112.114 159.372C114.359 159.299 116.694 160.222 118.174 161.827C119.059 162.786 120.054 163.632 121.157 164.366C123.716 166.094 126.591 166.936 129.718 166.936C132.797 166.936 135.654 166.071 138.236 164.317C139.348 163.573 140.35 162.725 141.241 161.773C142.72 160.191 145.043 159.29 147.273 159.371C147.462 159.378 147.653 159.381 147.844 159.381C152.232 159.381 156.011 157.726 159.099 154.467Z"
                    stroke="white"
                    stroke-width="3"
                />
            </g>
            <g filter="url(#filter1_dddd_203_2987)">
                <path
                    d="M128.028 139.492L144.459 114.884C144.879 114.231 145.004 113.516 144.864 112.754C144.708 111.993 144.32 111.386 143.667 110.982C143.014 110.563 142.299 110.423 141.537 110.531C140.76 110.656 140.138 111.029 139.671 111.682L125.199 133.445L118.53 126.792C117.939 126.201 117.255 125.921 116.493 125.952C115.716 125.984 115.048 126.263 114.457 126.792C113.928 127.32 113.664 127.989 113.664 128.797C113.664 129.59 113.928 130.259 114.457 130.803L123.613 139.959L124.064 140.316C124.592 140.674 125.137 140.845 125.665 140.845C126.707 140.829 127.499 140.394 128.028 139.492Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dddd_203_2987"
                    x="68.9219"
                    y="79.8438"
                    width="121.592"
                    height="151.592"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="5.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.09 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_203_2987"
                        result="effect2_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="25" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_203_2987"
                        result="effect3_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="45" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_203_2987"
                        result="effect4_dropShadow_203_2987"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_203_2987"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_dddd_203_2987"
                    x="95.6641"
                    y="107.496"
                    width="67.2539"
                    height="96.3486"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="5.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.09 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_203_2987"
                        result="effect2_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="25" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_203_2987"
                        result="effect3_dropShadow_203_2987"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="45" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_203_2987"
                        result="effect4_dropShadow_203_2987"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_203_2987"
                        result="shape"
                    />
                </filter>
                <radialGradient
                    id="paint0_radial_203_2987"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(130.001 128.109) rotate(151.831) scale(106.196)"
                >
                    <stop
                        offset="0.075"
                        stop-color="#FD421D"
                        stop-opacity="0"
                    />
                    <stop
                        offset="0.475658"
                        stop-color="#FD421D"
                        stop-opacity="0.2"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#FD421D"
                        stop-opacity="0"
                    />
                </radialGradient>
            </defs>
        </svg>

        <svg
            v-if="icon === 'circle-info'"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0013 3.33366C6.3194 3.33366 3.33464 6.31843 3.33464 10.0003C3.33464 13.6822 6.3194 16.667 10.0013 16.667C13.6832 16.667 16.668 13.6822 16.668 10.0003C16.668 6.31843 13.6832 3.33366 10.0013 3.33366ZM1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699C14.6037 1.66699 18.3346 5.39795 18.3346 10.0003C18.3346 14.6027 14.6037 18.3337 10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003ZM8.33464 9.16699C8.33464 8.70676 8.70773 8.33366 9.16797 8.33366H10.0013C10.4615 8.33366 10.8346 8.70676 10.8346 9.16699V13.3337C10.8346 13.7939 10.4615 14.167 10.0013 14.167C9.54106 14.167 9.16797 13.7939 9.16797 13.3337V10.0003C8.70773 10.0003 8.33464 9.62723 8.33464 9.16699Z"
                fill="#64748B"
            />
            <path
                d="M9.58431 6.66699C9.58431 6.43687 9.77086 6.25033 10.001 6.25033C10.2311 6.25033 10.4176 6.43687 10.4176 6.66699C10.4176 6.89711 10.2311 7.08366 10.001 7.08366C9.77086 7.08366 9.58431 6.89711 9.58431 6.66699Z"
                fill="#64748B"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.001 7.50033C9.54074 7.50033 9.16764 7.12723 9.16764 6.66699C9.16764 6.20676 9.54074 5.83366 10.001 5.83366C10.4612 5.83366 10.8343 6.20676 10.8343 6.66699C10.8343 7.12723 10.4612 7.50033 10.001 7.50033ZM10.001 6.25033C9.77086 6.25033 9.58431 6.43687 9.58431 6.66699C9.58431 6.89711 9.77086 7.08366 10.001 7.08366C10.2311 7.08366 10.4176 6.89711 10.4176 6.66699C10.4176 6.43687 10.2311 6.25033 10.001 6.25033Z"
                fill="#64748B"
            />
        </svg>

        <svg
            v-if="icon === 'circle-i'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0013 3.33366C6.3194 3.33366 3.33464 6.31843 3.33464 10.0003C3.33464 13.6822 6.3194 16.667 10.0013 16.667C13.6832 16.667 16.668 13.6822 16.668 10.0003C16.668 6.31843 13.6832 3.33366 10.0013 3.33366ZM1.66797 10.0003C1.66797 5.39795 5.39893 1.66699 10.0013 1.66699C14.6037 1.66699 18.3346 5.39795 18.3346 10.0003C18.3346 14.6027 14.6037 18.3337 10.0013 18.3337C5.39893 18.3337 1.66797 14.6027 1.66797 10.0003ZM8.33464 9.16699C8.33464 8.70676 8.70773 8.33366 9.16797 8.33366H10.0013C10.4615 8.33366 10.8346 8.70676 10.8346 9.16699V13.3337C10.8346 13.7939 10.4615 14.167 10.0013 14.167C9.54106 14.167 9.16797 13.7939 9.16797 13.3337V10.0003C8.70773 10.0003 8.33464 9.62723 8.33464 9.16699Z"
                fill="currentColor"
            />
            <path
                d="M9.58431 6.66699C9.58431 6.43687 9.77086 6.25033 10.001 6.25033C10.2311 6.25033 10.4176 6.43687 10.4176 6.66699C10.4176 6.89711 10.2311 7.08366 10.001 7.08366C9.77086 7.08366 9.58431 6.89711 9.58431 6.66699Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.001 7.50033C9.54074 7.50033 9.16764 7.12723 9.16764 6.66699C9.16764 6.20676 9.54074 5.83366 10.001 5.83366C10.4612 5.83366 10.8343 6.20676 10.8343 6.66699C10.8343 7.12723 10.4612 7.50033 10.001 7.50033ZM10.001 6.25033C9.77086 6.25033 9.58431 6.43687 9.58431 6.66699C9.58431 6.89711 9.77086 7.08366 10.001 7.08366C10.2311 7.08366 10.4176 6.89711 10.4176 6.66699C10.4176 6.43687 10.2311 6.25033 10.001 6.25033Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'pass' || icon === 'free_nights'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V9.17071C22 9.59452 21.7328 9.97231 21.3332 10.1135C20.5551 10.3886 20 11.1307 20 12C20 12.8693 20.5551 13.6114 21.3332 13.8865C21.7328 14.0277 22 14.4055 22 14.8293V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V14.8293C2 14.4055 2.26716 14.0277 2.66675 13.8865C3.4449 13.6114 4 12.8693 4 12C4 11.1307 3.4449 10.3886 2.66675 10.1135C2.26716 9.97231 2 9.59452 2 9.17071V7ZM5 6C4.44772 6 4 6.44772 4 7V8.53543C5.1948 9.22657 6 10.5183 6 12C6 13.4817 5.1948 14.7734 4 15.4646V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V15.4646C18.8052 14.7734 18 13.4817 18 12C18 10.5183 18.8052 9.22657 20 8.53543V7C20 6.44771 19.5523 6 19 6H5Z"
                fill="currentColor"
            />
            <path
                d="M14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8Z"
                fill="currentColor"
            />
            <path
                d="M14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12Z"
                fill="currentColor"
            />
            <path
                d="M14 16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'star'"
            :width
            :height
            :class="svgClass"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2055_12293)">
                <path
                    :class="pathClass"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.6275 1.86222C11.1798 0.71259 12.8203 0.712594 13.3726 1.86222L15.7347 6.77927L21.1754 7.49166C22.4368 7.65682 22.962 9.21543 22.0228 10.101L18.0469 13.8499L19.0447 19.2025C19.2816 20.4733 17.9363 21.4154 16.8248 20.8162L12 18.2151L7.17531 20.8162C6.06382 21.4154 4.71844 20.4733 4.95534 19.2025L5.95315 13.8499L1.97724 10.101C1.03808 9.21543 1.56329 7.65682 2.82465 7.49166L8.26537 6.77927L10.6275 1.86222ZM12 3.62381L9.95564 7.8795C9.73227 8.34447 9.28919 8.66229 8.78114 8.72881L4.08888 9.3432L7.51675 12.5754C7.89139 12.9287 8.06245 13.4484 7.96769 13.9568L7.10553 18.5817L11.2765 16.3331C11.728 16.0896 12.2721 16.0896 12.7236 16.3331L16.8946 18.5817L16.0324 13.9568C15.9376 13.4484 16.1087 12.9287 16.4833 12.5754L19.9112 9.3432L15.2189 8.72881C14.7109 8.66229 14.2678 8.34447 14.0444 7.8795L12 3.62381Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2055_12293">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'star-filled'"
            :width
            :height
            :class="svgClass"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'CheckIcon'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.0273 3.52827C14.2877 3.78862 14.2877 4.21073 14.0273 4.47108L6.24953 12.2489C5.98918 12.5092 5.56707 12.5092 5.30672 12.2489L1.97338 8.91552C1.71303 8.65517 1.71303 8.23306 1.97338 7.97271C2.23373 7.71237 2.65584 7.71237 2.91619 7.97271L5.77812 10.8346L13.0845 3.52827C13.3448 3.26792 13.767 3.26792 14.0273 3.52827Z"
                fill="#10B981"
            />
        </svg>

        <svg
            v-if="icon === 'plus+icon'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9984 5.99805C12.5507 5.99805 12.9984 6.44576 12.9984 6.99805V10.998H16.9984C17.5507 10.998 17.9984 11.4458 17.9984 11.998C17.9984 12.5503 17.5507 12.998 16.9984 12.998H12.9984V16.998C12.9984 17.5503 12.5507 17.998 11.9984 17.998C11.4461 17.998 10.9984 17.5503 10.9984 16.998V12.998H6.99841C6.44613 12.998 5.99841 12.5503 5.99841 11.998C5.99841 11.4458 6.44613 10.998 6.99841 10.998H10.9984V6.99805C10.9984 6.44576 11.4461 5.99805 11.9984 5.99805Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'arrow-left-small'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.78574 5.8681C9.11118 6.19354 9.11118 6.72118 8.78574 7.04661L6.66667 9.16567H15C15.4602 9.16567 15.8333 9.53877 15.8333 9.99901C15.8333 10.4592 15.4602 10.8323 15 10.8323H6.66666L8.78574 12.9514C9.11118 13.2769 9.11118 13.8045 8.78574 14.1299C8.4603 14.4554 7.93267 14.4554 7.60723 14.1299L4.65482 11.1775C4.00394 10.5266 4.00395 9.47137 4.65482 8.8205L7.60723 5.8681C7.93267 5.54266 8.46031 5.54266 8.78574 5.8681Z"
                fill="currentColor"
            />
        </svg>
        <!-- edit bank / edit connection icon -->
        <svg
            v-if="icon === 'editBank' || icon === 'editConnection'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M11.9988 19L12.1013 19.0058C12.6054 19.057 12.9985 19.4824 12.9988 20C12.9988 20.5178 12.6056 20.9439 12.1013 20.9951L11.9988 21H4.38647C3.83423 20.9999 3.38647 20.5522 3.38647 20C3.38673 19.4479 3.83438 19 4.38647 19H11.9988ZM4.99878 17V12C4.99903 11.448 5.44681 11.0002 5.99878 11C6.5509 11 6.99852 11.4479 6.99878 12L6.99878 17C6.99878 17.5523 6.55106 18 5.99878 18C5.44666 17.9998 4.99878 17.5521 4.99878 17ZM10.9988 17V12C10.999 11.448 11.4468 11.0002 11.9988 11C12.5509 11 12.9985 11.4479 12.9988 12V17C12.9988 17.5523 12.5511 18 11.9988 18C11.4467 17.9998 10.9988 17.5521 10.9988 17ZM16.9988 12.0996V12C16.999 11.448 17.4468 11.0002 17.9988 11C18.5509 11 18.9985 11.4479 18.9988 12V12.0996C18.9988 12.6519 18.5511 13.0996 17.9988 13.0996C17.4467 13.0994 16.9988 12.6518 16.9988 12.0996ZM10.5759 1.73044C11.5272 1.21743 12.6888 1.25354 13.6101 1.83982L20.6384 6.31345L20.7898 6.41794C22.2782 7.54775 21.5036 9.99988 19.5652 9.99998L4.43335 9.99998C2.4326 9.99998 1.67153 7.38783 3.35913 6.31345L10.3884 1.83982L10.5759 1.73044ZM12.5359 3.52732C12.2492 3.34494 11.8927 3.32203 11.5886 3.45896L11.4626 3.52732L4.43335 7.99998L19.5652 7.99998L12.5359 3.52732Z"
                fill="currentColor"
            />
            <path
                d="M17.9933 14.2778C19.0341 13.4291 20.5691 13.4904 21.5392 14.4604L21.7218 14.6616C22.5138 15.6329 22.5138 17.035 21.7218 18.0063L21.5392 18.2075L18.0392 21.7075C17.8516 21.895 17.5973 22.0005 17.3321 22.0005L14.9991 22.0005C14.4468 22.0005 13.9991 21.5527 13.9991 21.0005V18.6674C13.9991 18.4023 14.1046 18.1479 14.2921 17.9604L17.7921 14.4604L17.9933 14.2778ZM20.1251 15.8745C19.9029 15.6523 19.56 15.6246 19.3077 15.7915L19.2062 15.8745L15.9991 19.0815V20.0005H16.9181L20.1251 16.7934L20.2091 16.6919C20.3519 16.4756 20.3519 16.1923 20.2091 15.976L20.1251 15.8745Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'hidden'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            v-if="icon === '10xTravel'"
            width="130"
            height="14"
            viewBox="0 0 130 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <rect
                y="0.175781"
                width="130"
                height="13.65"
                fill="url(#pattern0_2079_2839)"
            />
            <defs>
                <pattern
                    id="pattern0_2079_2839"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                >
                    <use
                        xlink:href="#image0_2079_2839"
                        transform="scale(0.000833333 0.00793651)"
                    />
                </pattern>
                <image
                    id="image0_2079_2839"
                    width="1200"
                    height="126"
                    xlink:href="data:image/png;base64,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"
                />
            </defs>
        </svg>
        <svg
            v-if="icon === 'verify'"
            :width="width"
            :height="height"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.72261 3.19161C9.39712 2.4153 10.6025 2.41529 11.277 3.19161L12.4089 4.49432C12.4146 4.5009 12.4233 4.50407 12.4319 4.50271L14.1363 4.23233C15.1521 4.07121 16.0754 4.846 16.0931 5.87426L16.1228 7.59975C16.123 7.60847 16.1276 7.6165 16.1351 7.62099L17.6146 8.50945C18.4962 9.03891 18.7055 10.226 18.0581 11.025L16.9717 12.3659C16.9663 12.3727 16.9646 12.3818 16.9675 12.3901L17.5297 14.0217C17.8648 14.994 17.2621 16.0378 16.2525 16.2338L14.5584 16.5627C14.5499 16.5644 14.5428 16.5703 14.5396 16.5785L13.9216 18.1897C13.5533 19.1499 12.4206 19.5622 11.5212 19.0634L10.0121 18.2264C10.0044 18.2221 9.99517 18.2221 9.98754 18.2264L8.47838 19.0634C7.57903 19.5622 6.44635 19.1499 6.07803 18.1897L5.45997 16.5785C5.45685 16.5703 5.44975 16.5644 5.44118 16.5627L3.74707 16.2338C2.73751 16.0378 2.13482 14.994 2.46987 14.0217L3.03211 12.3901C3.03496 12.3818 3.03335 12.3727 3.02786 12.3659L1.94149 11.025C1.29409 10.226 1.5034 9.03891 2.38505 8.50945L3.86452 7.62099C3.87199 7.61649 3.87663 7.60847 3.87678 7.59975L3.90648 5.87426C3.92418 4.846 4.84754 4.07121 5.86326 4.23233L7.56769 4.50271C7.5763 4.50407 7.58501 4.5009 7.59073 4.49432L8.72261 3.19161ZM12.6724 10.282C12.9978 9.95653 12.9978 9.42889 12.6724 9.10345C12.347 8.77802 11.8193 8.77802 11.4939 9.10345L9.16648 11.4309L8.50573 10.7701C8.1803 10.4447 7.65266 10.4447 7.32722 10.7701C7.00179 11.0956 7.00179 11.6232 7.32722 11.9486L8.2826 12.904C8.77075 13.3922 9.56221 13.3922 10.0504 12.904L12.6724 10.282Z"
                fill="#FD421D"
            />
        </svg>

        <svg
            v-if="icon === 'bell-added-color'"
            :width="width"
            :height="height"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.3076 8.72123C15.7673 8.69825 16.1587 9.05258 16.1816 9.51225L16.2314 10.4966C16.2373 10.6116 16.2669 10.7247 16.3184 10.8277L17.3408 12.8716C17.4455 13.0809 17.5 13.3124 17.5 13.5464C17.4999 14.3789 16.8247 15.0542 15.9922 15.0542H14.083C13.6968 16.9558 12.0155 18.3871 10 18.3872C7.98441 18.3872 6.30328 16.9558 5.91699 15.0542H4.00684C3.22658 15.0541 2.58517 14.4606 2.50781 13.7007L2.5 13.5464L2.50977 13.3716C2.53 13.1981 2.58068 13.0286 2.65918 12.8716L3.68164 10.8277C3.73315 10.7247 3.76274 10.6117 3.76855 10.4966L3.91797 7.50639C4.04996 4.86664 5.84837 2.69001 8.2627 1.97221C8.70379 1.84117 9.16769 2.09264 9.29883 2.53373C9.42987 2.97483 9.1784 3.43872 8.7373 3.56986C6.98286 4.09156 5.6778 5.67399 5.58203 7.58939L5.43262 10.5796C5.41531 10.9251 5.32656 11.2634 5.17188 11.5728L4.26465 13.3872H15.7344L14.8271 11.5728C14.6725 11.2634 14.5837 10.9251 14.5664 10.5796L14.5176 9.59525C14.4947 9.13578 14.8482 8.74443 15.3076 8.72123ZM10 16.7203C8.91207 16.7203 7.98914 16.0244 7.64551 15.0542H12.3545C12.0109 16.0244 11.0879 16.7201 10 16.7203Z"
                fill="currentColor"
            />
            <path
                d="M16.9107 1.96283C17.2362 1.63739 17.7637 1.63739 18.0891 1.96283C18.4146 2.28826 18.4146 2.81578 18.0891 3.14121L13.5058 7.72455C13.3495 7.88083 13.1376 7.96869 12.9166 7.96869C12.6956 7.96869 12.4837 7.88083 12.3274 7.72455L10.2441 5.64121C9.91864 5.31578 9.91864 4.78826 10.2441 4.46283C10.5492 4.15773 11.0317 4.1389 11.359 4.40586L11.4225 4.46283L12.9166 5.95697L16.9107 1.96283Z"
                fill="#FD421D"
            />
        </svg>

        <svg
            v-if="icon === 'clock-fast'"
            :width="width"
            :height="height"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.3387 11.7253L12.8387 9.22526M12.0054 2.55859H8.67204M4.50537 8.39193H2.00537M2.00537 11.7253H3.67204C3.67204 15.4072 6.65681 18.3919 10.3387 18.3919C14.0206 18.3919 17.0054 15.4072 17.0054 11.7253C17.0054 8.04336 14.0206 5.05859 10.3387 5.05859H2.00537"
                stroke="currentColor"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <svg
            v-if="icon === 'transfer-partners'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M18 13V12.166C17.7725 12.2729 17.5335 12.3716 17.2861 12.46C15.8857 12.9601 14.0165 13.25 12 13.25C9.98346 13.25 8.11434 12.9601 6.71387 12.46C6.46652 12.3716 6.22753 12.2729 6 12.166V13.9824C6.00647 14.0016 6.04116 14.0788 6.19531 14.209C6.42465 14.4026 6.81586 14.6223 7.38672 14.8262C8.51973 15.2308 10.1507 15.5 12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C9.98346 17.5 8.11434 17.2101 6.71387 16.71C6.46652 16.6216 6.22753 16.5229 6 16.416V18.4824C6.00647 18.5016 6.04116 18.5788 6.19531 18.709C6.42465 18.9026 6.81586 19.1223 7.38672 19.3262C8.51973 19.7308 10.1507 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C9.98346 22 8.11434 21.7101 6.71387 21.21C6.0181 20.9615 5.38435 20.6417 4.90527 20.2373C4.43081 19.8367 4 19.2537 4 18.5V5.5C4 4.74631 4.43081 4.16333 4.90527 3.7627C5.38435 3.35825 6.0181 3.03853 6.71387 2.79004C8.11434 2.28989 9.98346 2 12 2C14.0165 2 15.8857 2.28989 17.2861 2.79004C17.9819 3.03853 18.6157 3.35825 19.0947 3.7627C19.5692 4.16333 20 4.74631 20 5.5V13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13ZM18 7.91602C17.7725 8.02288 17.5335 8.12162 17.2861 8.20996C15.8857 8.71011 14.0165 9 12 9C9.98346 9 8.11434 8.71011 6.71387 8.20996C6.46652 8.12162 6.22753 8.02288 6 7.91602V9.73242C6.00647 9.75162 6.04116 9.82882 6.19531 9.95898C6.42465 10.1526 6.81586 10.3723 7.38672 10.5762C8.51973 10.9808 10.1507 11.25 12 11.25C13.8493 11.25 15.4803 10.9808 16.6133 10.5762C17.1841 10.3723 17.5754 10.1526 17.8047 9.95898C17.9588 9.82882 17.9935 9.75162 18 9.73242V7.91602ZM12 4C10.1507 4 8.51973 4.26921 7.38672 4.67383C6.81586 4.87771 6.42465 5.09737 6.19531 5.29102C6.07074 5.3962 6.02381 5.46673 6.00684 5.5C6.02381 5.53327 6.07074 5.6038 6.19531 5.70898C6.42465 5.90263 6.81586 6.12229 7.38672 6.32617C8.51973 6.73079 10.1507 7 12 7C13.8493 7 15.4803 6.73079 16.6133 6.32617C17.1841 6.12229 17.5754 5.90263 17.8047 5.70898C17.9288 5.60422 17.975 5.53344 17.9922 5.5C17.975 5.46656 17.9288 5.39578 17.8047 5.29102C17.5754 5.09737 17.1841 4.87771 16.6133 4.67383C15.4803 4.26921 13.8493 4 12 4Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.7389 15.4792C19.3833 15.0567 18.7525 15.0024 18.3299 15.358C17.9073 15.7136 17.8531 16.3445 18.2087 16.767L19.2464 18.0001H15.003C14.4507 18.0001 14.003 18.4478 14.003 19.0001C14.003 19.5524 14.4507 20.0001 15.003 20.0001H19.2464L18.2087 21.2331C17.8531 21.6557 17.9073 22.2865 18.3299 22.6421C18.7525 22.9978 19.3833 22.9435 19.7389 22.5209L22.1601 19.644C22.4733 19.2718 22.4733 18.7283 22.1601 18.3562L19.7389 15.4792Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'transfer-bonuses'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M18.3271 15.3584C18.7233 15.025 19.3021 15.0515 19.666 15.4043L19.7363 15.4795L22.1572 18.3564C22.4701 18.7285 22.4701 19.2715 22.1572 19.6436L19.7363 22.5205L19.666 22.5957C19.3021 22.9485 18.7233 22.975 18.3271 22.6416C17.9047 22.286 17.8505 21.6559 18.2061 21.2334L19.2441 20H15C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18H19.2441L18.2061 16.7666L18.1436 16.6855C17.8581 16.2668 17.9311 15.6918 18.3271 15.3584ZM6 9.58789C5.45526 9.77109 5.00599 9.9838 4.66699 10.209C4.07858 10.5999 4.00003 10.8936 4 11C4 11.0906 4.05063 11.3132 4.44629 11.6309C4.83578 11.9436 5.45493 12.2554 6.28613 12.5039H6.28711C6.3853 12.5333 6.4862 12.5607 6.58887 12.5879C6.23867 12.1472 6 11.6158 6 11V9.58789ZM8 11C8 11.0906 8.05063 11.3132 8.44629 11.6309C8.83579 11.9435 9.45494 12.2554 10.2861 12.5039C11.3158 12.8117 12.5974 13 14 13C15.4032 13 16.6841 12.8124 17.7129 12.5039H17.7139C18.5455 12.2554 19.1644 11.9434 19.5537 11.6309C19.949 11.3134 20 11.0908 20 11V9.7207C19.49 10.0004 18.9086 10.233 18.2861 10.4189L18.2871 10.4199C17.0479 10.7915 15.5708 11 14 11C12.4287 11 10.9521 10.7901 9.71387 10.4199C9.09154 10.2339 8.51003 10.0005 8 9.7207V11ZM20 7C20 6.92389 19.9684 6.76734 19.7383 6.53418C19.5039 6.29676 19.1148 6.03747 18.5557 5.79785C17.4407 5.32005 15.8308 5 14 5C12.1692 5 10.5593 5.32005 9.44434 5.79785C8.8852 6.03747 8.49609 6.29676 8.26172 6.53418C8.03162 6.76734 8 6.92389 8 7C8 7.09057 8.05063 7.31316 8.44629 7.63086C8.83579 7.94355 9.45494 8.25539 10.2861 8.50391C11.3158 8.81173 12.5974 9 14 9C15.4032 9 16.6841 8.81235 17.7129 8.50391H17.7139C18.5455 8.25542 19.1644 7.94343 19.5537 7.63086C19.949 7.31335 20 7.09085 20 7ZM22 11C22 11.929 21.4577 12.6665 20.8066 13.1895C20.1495 13.7172 19.2681 14.1255 18.2861 14.4189L18.2871 14.4199C17.0479 14.7915 15.5708 15 14 15C13.3131 15 12.6446 14.9569 12.0059 14.8809C11.3645 14.9577 10.6924 15 10 15C8.42921 15 6.95211 14.7915 5.71289 14.4199V14.4189C5.09092 14.2329 4.50977 14.0003 4 13.7207V15C4 15.0906 4.05063 15.3132 4.44629 15.6309C4.83578 15.9436 5.45493 16.2554 6.28613 16.5039H6.28711C7.31587 16.8124 8.59682 17 10 17C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19C8.42921 19 6.95211 18.7915 5.71289 18.4199V18.4189C4.73194 18.1256 3.8513 17.7178 3.19434 17.1904C2.54324 16.6676 2 15.9294 2 15V11C2.00003 9.90937 2.73937 9.08793 3.55957 8.54297C4.22205 8.1028 5.06155 7.75441 6 7.5V7C6 6.24775 6.35969 5.61453 6.83789 5.12988C7.31192 4.64956 7.94887 4.26314 8.65625 3.95996C10.0748 3.35204 11.9648 3 14 3C16.0352 3 17.9252 3.35204 19.3438 3.95996C20.0511 4.26314 20.6881 4.64956 21.1621 5.12988C21.6403 5.61453 22 6.24775 22 7V11Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'transfer-rate'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.24987 17.5L3.5058 14.7559C3.18036 14.4305 3.18036 13.9028 3.5058 13.5774L6.24987 10.8333M13.7499 9.16667L16.494 6.42259C16.8194 6.09715 16.8194 5.56951 16.494 5.24408L13.7499 2.5M4.16654 14.1667H16.6665M3.33321 5.83333H15.8332"
                stroke="#64748B"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <svg
            v-if="icon === 'gift'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.832 9.77703V15C15.832 15.9205 15.0858 16.6667 14.1654 16.6667H5.83203C4.91156 16.6667 4.16536 15.9205 4.16536 15V9.77703M15.832 9.77703V9.58333M15.832 9.77703C16.3302 9.48885 16.6654 8.95024 16.6654 8.33333C16.6654 7.41286 15.9192 6.66667 14.9987 6.66667H4.9987C4.07822 6.66667 3.33203 7.41286 3.33203 8.33333C3.33203 8.95024 3.6672 9.48885 4.16536 9.77703M15.832 9.77703C15.5869 9.91884 15.3023 10 14.9987 10H4.9987C4.69513 10 4.41051 9.91884 4.16536 9.77703M4.16536 9.58333V9.77703M9.9987 6.66667V5.27778M9.9987 6.66667H8.60981C7.07568 6.66667 5.83203 5.42301 5.83203 3.88889C5.83203 3.12183 6.45386 2.5 7.22092 2.5C8.75504 2.5 9.9987 3.74365 9.9987 5.27778M9.9987 6.66667H11.3876C12.9217 6.66667 14.1654 5.42301 14.1654 3.88889C14.1654 3.12183 13.5435 2.5 12.7765 2.5C11.2424 2.5 9.9987 3.74365 9.9987 5.27778M9.9987 6.66667V16.6667"
                stroke="currentColor"
                stroke-width="1.5"
            />
        </svg>

        <svg
            v-if="icon === 'calculator'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.9997 4.16797C14.9997 3.70773 14.6266 3.33464 14.1663 3.33464H5.83301C5.37277 3.33464 4.99967 3.70773 4.99967 4.16797V15.8346C4.99967 16.2949 5.37277 16.668 5.83301 16.668H14.1663C14.6266 16.668 14.9997 16.2949 14.9997 15.8346V4.16797ZM16.6663 15.8346C16.6663 17.2153 15.5471 18.3346 14.1663 18.3346H5.83301C4.4523 18.3346 3.33301 17.2153 3.33301 15.8346V4.16797C3.33301 2.78726 4.4523 1.66797 5.83301 1.66797H14.1663C15.5471 1.66797 16.6663 2.78726 16.6663 4.16797V15.8346Z"
                fill="#64748B"
            />
            <path
                d="M8.12467 13.9596C8.12467 14.5349 7.6583 15.0013 7.08301 15.0013C6.50771 15.0013 6.04134 14.5349 6.04134 13.9596C6.04134 13.3843 6.50771 12.918 7.08301 12.918C7.6583 12.918 8.12467 13.3843 8.12467 13.9596ZM11.0413 13.9596C11.0413 14.5349 10.575 15.0013 9.99967 15.0013C9.42438 15.0013 8.95801 14.5349 8.95801 13.9596C8.95801 13.3843 9.42438 12.918 9.99967 12.918C10.575 12.918 11.0413 13.3843 11.0413 13.9596ZM13.958 13.9596C13.958 14.5349 13.4916 15.0013 12.9163 15.0013C12.341 15.0013 11.8747 14.5349 11.8747 13.9596C11.8747 13.3843 12.341 12.918 12.9163 12.918C13.4916 12.918 13.958 13.3843 13.958 13.9596ZM8.12467 10.2096C8.12467 10.7849 7.6583 11.2513 7.08301 11.2513C6.50771 11.2513 6.04134 10.7849 6.04134 10.2096C6.04134 9.63434 6.50771 9.16797 7.08301 9.16797C7.6583 9.16797 8.12467 9.63434 8.12467 10.2096ZM11.0413 10.2096C11.0413 10.7849 10.575 11.2513 9.99967 11.2513C9.42438 11.2513 8.95801 10.7849 8.95801 10.2096C8.95801 9.63434 9.42438 9.16797 9.99967 9.16797C10.575 9.16797 11.0413 9.63434 11.0413 10.2096ZM13.958 10.2096C13.958 10.7849 13.4916 11.2513 12.9163 11.2513C12.341 11.2513 11.8747 10.7849 11.8747 10.2096C11.8747 9.63434 12.341 9.16797 12.9163 9.16797C13.4916 9.16797 13.958 9.63434 13.958 10.2096Z"
                fill="#64748B"
            />
            <path
                d="M13.958 6.04297C13.958 6.61827 13.4916 7.08464 12.9163 7.08464H7.08301C6.50771 7.08464 6.04134 6.61827 6.04134 6.04297C6.04134 5.46767 6.50771 5.0013 7.08301 5.0013H12.9163C13.4916 5.0013 13.958 5.46767 13.958 6.04297Z"
                fill="#64748B"
            />
        </svg>
        <svg
            v-if="icon === 'airplane'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.4086 4.15586C18.4082 4.15628 18.4077 4.15669 18.4073 4.15711L15.3102 7.27926C15.079 7.51225 14.7483 7.61701 14.4252 7.55956L5.43243 5.96085C5.39945 5.95578 5.37373 5.95819 5.34124 5.9695C5.28099 5.99045 5.25099 6.01343 5.23232 6.03211L4.83232 6.43211C4.76894 6.49549 4.75884 6.5293 4.75842 6.53074C4.75782 6.53264 4.75705 6.53546 4.75688 6.54186C4.75669 6.54881 4.7571 6.56527 4.76343 6.59346C4.78231 6.67754 4.80765 6.72781 4.93376 6.78717L11.1718 9.482C11.4767 9.61373 11.6964 9.8883 11.7579 10.2147C11.8194 10.5412 11.7149 10.8769 11.4788 11.1106L8.92883 13.6356C8.69959 13.8626 8.37493 13.965 8.05692 13.9107L4.98192 13.3857C4.97397 13.3844 4.96603 13.3829 4.95811 13.3814L4.95732 13.3821L4.53775 13.8017C4.53816 13.8062 4.53877 13.8115 4.53968 13.8177C4.54118 13.828 4.5428 13.8355 4.54412 13.8406C4.54738 13.8429 4.55183 13.8457 4.55768 13.8491L7.92587 15.6704C8.09695 15.7629 8.23734 15.9033 8.32985 16.0743L10.1511 19.4425C10.1545 19.4484 10.1574 19.4528 10.1596 19.4561C10.1647 19.4574 10.1722 19.459 10.1825 19.4605C10.1887 19.4614 10.194 19.4621 10.1985 19.4625L10.6181 19.0429L10.6189 19.0421L10.6156 19.0247L10.0656 15.9247C10.0082 15.6014 10.1133 15.2705 10.3466 15.0394L12.8966 12.5144C13.1318 12.2815 13.4671 12.1801 13.792 12.2436C14.1169 12.307 14.3893 12.5272 14.5196 12.8315L17.1885 19.0673C17.223 19.1398 17.2524 19.1673 17.265 19.1775C17.2771 19.1872 17.3043 19.206 17.3713 19.2194C17.4306 19.2313 17.4535 19.224 17.4593 19.2221C17.4671 19.2197 17.5043 19.2067 17.5681 19.1429C17.5757 19.1353 17.5834 19.1278 17.5913 19.1205L17.9724 18.7632C17.9786 18.7554 17.9906 18.7366 18.0027 18.695C18.0198 18.6364 18.0217 18.589 18.0143 18.5423L16.4403 9.57285C16.3842 9.25317 16.4867 8.92616 16.7153 8.69574L19.8153 5.57074L19.8181 5.56789C20.0077 5.37828 20.1002 5.16449 20.1002 4.8625C20.1002 4.56051 20.0077 4.34672 19.8181 4.15711C19.6285 3.96749 19.4147 3.875 19.1127 3.875C18.8114 3.875 18.5979 3.96709 18.4086 4.15586ZM16.9931 2.74289C17.5702 2.16584 18.298 1.875 19.1127 1.875C19.9274 1.875 20.6553 2.16584 21.2323 2.74289C21.8094 3.31995 22.1002 4.04782 22.1002 4.8625C22.1002 5.67655 21.8098 6.40393 21.2337 6.98077C21.2332 6.98122 21.2328 6.98166 21.2323 6.98211L18.4996 9.73687L19.9866 18.2106C20.0454 18.563 20.0219 18.9148 19.9227 19.255C19.8224 19.5991 19.6466 19.9178 19.3823 20.1821C19.3747 20.1897 19.367 20.1972 19.3592 20.2045L18.9695 20.5698C18.4334 21.0987 17.7381 21.3324 16.9791 21.1806C16.2352 21.0318 15.6774 20.5708 15.3661 19.8917C15.3626 19.884 15.3592 19.8762 15.3559 19.8685L13.2593 14.9699L12.1264 16.0916L12.5832 18.6663C12.646 18.9903 12.6295 19.3196 12.5288 19.6386C12.4308 19.9491 12.2633 20.2261 12.0323 20.4571L11.6073 20.8821C11.1387 21.3507 10.5302 21.5327 9.89292 21.4395C9.24515 21.3447 8.72016 20.985 8.40106 20.4106L8.39552 20.4007L6.71236 17.2879L3.58954 15.5992C3.01516 15.2801 2.65555 14.7551 2.56075 14.1073C2.46749 13.47 2.64948 12.8615 3.11811 12.3929L3.54311 11.9679C3.77409 11.7369 4.05111 11.5695 4.36158 11.4714C4.67935 11.3711 5.0074 11.3544 5.33015 11.4163L7.88684 11.8528L9.01975 10.731L4.12864 8.618L4.10856 8.60907C3.4417 8.30342 2.97606 7.76236 2.812 7.03154C2.63917 6.26166 2.87953 5.55647 3.41811 5.01789L3.81811 4.61789C4.0661 4.3699 4.36111 4.19288 4.68419 4.0805C5.03393 3.95886 5.39925 3.92771 5.76461 3.98861L5.77526 3.99038L14.2593 5.49872L16.9903 2.74574L16.9931 2.74289Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'plane'"
            width="326"
            height="282"
            viewBox="0 0 326 282"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2009_21216)">
                <circle
                    cx="163"
                    cy="141"
                    r="87"
                    stroke="url(#paint0_linear_2009_21216)"
                    stroke-width="2"
                />
                <circle
                    cx="163"
                    cy="141"
                    r="141"
                    stroke="url(#paint1_linear_2009_21216)"
                    stroke-width="2"
                />
            </g>
            <g clip-path="url(#clip1_2009_21216)">
                <g filter="url(#filter0_dddd_2009_21216)">
                    <path
                        d="M153.836 165.359C152.46 166.733 152.017 168.774 152.606 170.626C153.6 173.751 154.402 176.94 155.007 180.174C156.737 189.449 152.433 191.003 150.087 191.186C149.171 191.257 148.323 190.823 147.635 190.214L117.834 163.82C116.762 162.87 116.108 161.48 116.543 160.115C117.294 157.756 119.473 154.427 125.79 154.989C128.687 155.242 131.802 155.645 134.743 156.087C136.628 156.37 138.524 155.584 139.629 154.031L139.641 154.015C141.346 151.621 143.256 148.938 145.289 146.113C147.19 143.471 146.126 139.737 143.109 138.515L117.361 128.086C115.186 127.204 113.919 124.916 114.816 122.747C116.898 117.705 122.298 109.867 135.202 113.349C142.089 115.205 152.262 117.775 160.789 119.895C162.721 120.376 164.743 119.656 166.018 118.127C173.464 109.186 189.616 93.146 198.58 100.038C204.827 105.702 191.846 125.337 183.859 134.645C182.611 136.1 182.192 138.109 182.865 139.904C185.98 148.21 189.677 157.963 192.306 164.597C197.273 177.127 190.698 183.655 186.119 186.507C184.07 187.783 181.553 186.791 180.409 184.666L167.54 160.763C165.948 157.805 161.95 157.228 159.579 159.608C157.535 161.661 155.596 163.601 153.836 165.359Z"
                        fill="#FF7237"
                    />
                    <path
                        d="M156.481 179.898L156.482 179.899C157.383 184.732 156.787 187.931 155.285 189.977C153.771 192.039 151.604 192.572 150.204 192.681C148.727 192.796 147.493 192.092 146.64 191.337L116.84 164.943L117.834 163.82L116.84 164.943C115.506 163.762 114.434 161.792 115.114 159.659C115.551 158.286 116.429 156.552 118.187 155.251C119.967 153.934 122.475 153.188 125.922 153.495C128.859 153.751 132.007 154.159 134.966 154.604C136.303 154.805 137.636 154.245 138.407 153.161L138.419 153.145L138.419 153.145L138.421 153.143C140.125 150.75 142.037 148.065 144.071 145.237C145.409 143.378 144.655 140.76 142.546 139.905L116.798 129.476C114.031 128.355 112.146 125.281 113.429 122.174C114.529 119.512 116.55 115.989 120.117 113.605C123.746 111.179 128.779 110.062 135.593 111.9C142.464 113.752 152.624 116.319 161.151 118.44C162.492 118.773 163.937 118.281 164.865 117.167C168.626 112.651 174.624 106.292 180.869 101.917C183.987 99.7325 187.26 97.975 190.417 97.2389C193.61 96.4943 196.799 96.777 199.494 98.8493L199.543 98.8863L199.588 98.9272C201.721 100.861 202.011 103.814 201.518 106.773C201.018 109.776 199.653 113.211 197.893 116.657C194.364 123.569 189.047 130.902 184.998 135.622C184.08 136.692 183.802 138.131 184.27 139.378C187.384 147.683 191.077 157.424 193.7 164.044L156.481 179.898ZM156.481 179.898C155.865 176.604 155.048 173.355 154.036 170.172C153.606 168.822 153.94 167.374 154.895 166.42M156.481 179.898L154.895 166.42M154.895 166.42C156.657 164.661 158.597 162.72 160.642 160.666C162.305 158.997 165.105 159.405 166.219 161.474L179.088 185.377C180.54 188.074 183.956 189.62 186.912 187.78C189.344 186.265 192.399 183.72 194.161 179.796M154.895 166.42L194.161 179.796M194.161 179.796C195.945 175.821 196.311 170.631 193.7 164.045L194.161 179.796Z"
                        stroke="white"
                        stroke-width="3"
                    />
                </g>
                <g filter="url(#filter1_dd_2009_21216)">
                    <rect
                        x="64"
                        y="141"
                        width="26"
                        height="26"
                        rx="13"
                        fill="#FFEBE7"
                    />
                    <path
                        d="M81.2926 149.704L72.7164 158.281M80.3737 158.893C81.3947 158.893 81.9052 158.368 81.9052 157.055C81.9052 155.743 81.3947 155.218 80.3737 155.218C79.3527 155.218 78.8422 155.743 78.8422 157.055C78.8422 158.368 79.3527 158.893 80.3737 158.893ZM73.6353 152.767C74.6563 152.767 75.1668 152.242 75.1668 150.93C75.1668 149.617 74.6563 149.092 73.6353 149.092C72.6143 149.092 72.1039 149.617 72.1039 150.93C72.1039 152.242 72.6143 152.767 73.6353 152.767Z"
                        stroke="#FF7459"
                        stroke-width="1.23853"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
                <g filter="url(#filter2_dd_2009_21216)">
                    <rect
                        x="229"
                        y="94"
                        width="27"
                        height="27"
                        rx="13.5"
                        fill="#FFEBE7"
                    />
                    <path
                        d="M247.452 112.885C248.245 112.885 248.888 112.202 248.888 111.358V109.737C248.888 109.368 248.572 109.081 248.246 108.908C247.775 108.657 247.452 108.14 247.452 107.542C247.452 106.944 247.775 106.427 248.246 106.176C248.572 106.003 248.888 105.716 248.888 105.347V103.726C248.888 102.883 248.245 102.199 247.452 102.199H237.394C236.601 102.199 235.958 102.883 235.958 103.726V105.347C235.958 105.716 236.274 106.003 236.6 106.176C237.071 106.427 237.394 106.944 237.394 107.542C237.394 108.14 237.071 108.657 236.6 108.908C236.274 109.081 235.958 109.368 235.958 109.737V111.358C235.958 112.202 236.601 112.885 237.394 112.885H247.452Z"
                        stroke="#FF7459"
                        stroke-width="1.28616"
                    />
                    <path
                        d="M242.434 107.352L242.434 107.733"
                        stroke="#FF7459"
                        stroke-width="1.28616"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M242.434 104.488L242.434 104.87"
                        stroke="#FF7459"
                        stroke-width="1.28616"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M242.434 110.215L242.434 110.596"
                        stroke="#FF7459"
                        stroke-width="1.28616"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_dddd_2009_21216"
                    x="93.511"
                    y="92.3652"
                    width="127.713"
                    height="164.828"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="5.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.09 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="25" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_2009_21216"
                        result="effect3_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="45" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_2009_21216"
                        result="effect4_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_dd_2009_21216"
                    x="62.4951"
                    y="140.498"
                    width="29.0097"
                    height="31.0162"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.250811" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.00973" />
                    <feGaussianBlur stdDeviation="0.752433" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_dd_2009_21216"
                    x="227.437"
                    y="93.4791"
                    width="30.1255"
                    height="32.2092"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.260457" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.12549" />
                    <feGaussianBlur stdDeviation="0.781373" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2009_21216"
                    x1="163"
                    y1="54"
                    x2="163"
                    y2="228"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2009_21216"
                    x1="163"
                    y1="0"
                    x2="163"
                    y2="282"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <clipPath id="clip0_2009_21216">
                    <rect width="325.33" height="282" fill="white" />
                </clipPath>
                <clipPath id="clip1_2009_21216">
                    <rect
                        width="258"
                        height="218.001"
                        fill="white"
                        transform="translate(34 28)"
                    />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'chat-messages'"
            width="326"
            height="282"
            viewBox="0 0 326 282"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2009_21216)">
                <circle
                    cx="163.333"
                    cy="141"
                    r="87"
                    stroke="url(#paint0_linear_2009_21216)"
                    stroke-width="2"
                />
                <circle
                    cx="163.333"
                    cy="141"
                    r="141"
                    stroke="url(#paint1_linear_2009_21216)"
                    stroke-width="2"
                />
            </g>
            <g filter="url(#filter0_dddd_2009_21216)">
                <path
                    d="M210.521 157.23C211.338 154.586 211.778 151.775 211.778 148.861C211.778 139.636 207.366 131.445 200.543 126.299C195.846 122.756 190.007 120.657 183.68 120.657C168.161 120.657 155.581 133.284 155.581 148.861C155.581 155.211 157.671 161.07 161.199 165.784C166.325 172.635 174.487 177.066 183.68 177.066C187.088 177.066 190.354 176.457 193.376 175.342C198.241 173.546 202.984 174.663 207.748 175.972C209.673 176.501 211.443 174.899 211.074 172.93C210.095 167.718 208.988 162.189 210.521 157.23Z"
                    fill="url(#paint2_linear_2009_21216)"
                />
                <path
                    d="M113.243 135.885C111.544 131.128 110.619 126.001 110.619 120.657C110.619 95.7335 130.749 75.5293 155.581 75.5293C184.382 75.5293 200.543 99.8692 200.543 126.299C195.846 122.756 190.007 120.657 183.68 120.657C168.161 120.657 155.581 133.284 155.581 148.861C155.581 155.211 157.671 161.07 161.199 165.784C152.968 165.784 145.088 165.165 137.588 161.992C130.658 159.06 122.002 162.31 114.626 164.621C112.721 165.218 110.946 163.615 111.347 161.653C113.036 153.384 115.915 143.367 113.243 135.885Z"
                    fill="url(#paint3_linear_2009_21216)"
                />
                <path
                    d="M202.039 125.56C208.884 130.999 213.278 139.416 213.278 148.861C213.278 151.927 212.815 154.887 211.954 157.672C210.573 162.141 211.521 167.186 212.505 172.425L212.548 172.653C213.126 175.73 210.326 178.236 207.351 177.418C202.562 176.102 198.258 175.139 193.896 176.749C190.709 177.925 187.267 178.566 183.68 178.566C174.264 178.566 165.876 174.152 160.458 167.282C152.426 167.245 144.553 166.567 137.004 163.373C133.929 162.073 130.374 162.104 126.548 162.815C123.379 163.405 120.177 164.427 117.044 165.427C116.384 165.638 115.727 165.848 115.075 166.052C112.076 166.991 109.249 164.431 109.877 161.353C110.121 160.16 110.385 158.948 110.651 157.725C111.328 154.619 112.022 151.436 112.443 148.275C113.03 143.882 113.046 139.793 111.83 136.389C110.075 131.472 109.119 126.175 109.119 120.657C109.119 94.9103 129.915 74.0293 155.581 74.0293C170.448 74.0293 182.111 80.3297 190.026 90.0562C197.772 99.5751 201.891 112.319 202.039 125.56Z"
                    stroke="white"
                    stroke-width="3"
                />
            </g>
            <path
                d="M210.521 157.228C211.338 154.584 211.779 151.773 211.779 148.859C211.779 139.634 207.366 131.443 200.543 126.297C195.847 122.754 190.007 120.655 183.68 120.655C168.161 120.655 155.581 133.282 155.581 148.859C155.581 155.209 157.672 161.068 161.199 165.782C166.325 172.633 174.487 177.064 183.68 177.064C187.088 177.064 190.354 176.455 193.377 175.34C198.242 173.544 202.984 174.661 207.748 175.97C209.673 176.499 211.444 174.897 211.074 172.928C210.095 167.716 208.988 162.187 210.521 157.228Z"
                fill="#FF7237"
            />
            <path
                d="M113.243 135.883C111.545 131.126 110.619 125.999 110.619 120.655C110.619 95.7316 130.749 75.5273 155.581 75.5273C184.383 75.5273 200.543 99.8672 200.543 126.297C195.847 122.754 190.007 120.655 183.68 120.655C168.161 120.655 155.581 133.282 155.581 148.859C155.581 155.209 157.672 161.068 161.199 165.782C152.968 165.782 145.088 165.163 137.588 161.99C130.659 159.058 122.002 162.309 114.626 164.619C112.721 165.216 110.947 163.613 111.347 161.651C113.036 153.382 115.915 143.365 113.243 135.883Z"
                fill="#FF7237"
            />
            <path
                d="M200.543 126.297C195.847 122.754 190.007 120.655 183.68 120.655C168.161 120.655 155.581 133.282 155.581 148.859C155.581 155.209 157.672 161.068 161.199 165.782M200.543 126.297C207.366 131.443 211.779 139.634 211.779 148.859C211.779 151.773 211.338 154.584 210.521 157.228C208.988 162.187 210.095 167.716 211.074 172.928C211.444 174.897 209.673 176.499 207.748 175.97C202.984 174.661 198.242 173.544 193.377 175.34C190.354 176.455 187.088 177.064 183.68 177.064C174.487 177.064 166.325 172.633 161.199 165.782M200.543 126.297C200.543 99.8672 184.383 75.5273 155.581 75.5273C130.749 75.5273 110.619 95.7316 110.619 120.655C110.619 125.999 111.545 131.126 113.243 135.883C115.915 143.365 113.036 153.382 111.347 161.651C110.947 163.613 112.721 165.216 114.626 164.619C122.002 162.308 130.659 159.058 137.588 161.99C145.088 165.163 152.968 165.782 161.199 165.782"
                stroke="white"
                stroke-width="3"
            />
            <g filter="url(#filter1_dd_2009_21216)">
                <path
                    d="M253.997 97C253.997 104.18 248.177 110 240.997 110C233.818 110 227.997 104.18 227.997 97C227.997 89.8203 233.818 84 240.997 84C248.177 84 253.997 89.8203 253.997 97Z"
                    fill="#FFEBE7"
                />
            </g>
            <path
                d="M237.732 94.8696L238.234 95.1203L238.545 94.6539L241.189 90.6877C241.211 90.6548 241.248 90.635 241.287 90.635C241.327 90.635 241.364 90.6548 241.386 90.6877L244.03 94.6539L244.341 95.1203L244.842 94.8696L248.767 92.9073C248.807 92.887 248.856 92.8917 248.892 92.9193C248.928 92.947 248.945 92.9928 248.935 93.0371L247.302 100.877C247.145 101.63 246.481 102.17 245.712 102.17H236.863C236.093 102.17 235.429 101.63 235.272 100.877L233.639 93.0371C233.63 92.9928 233.647 92.947 233.682 92.9193C233.718 92.8917 233.767 92.887 233.807 92.9073L237.732 94.8696Z"
                stroke="#FF7459"
                stroke-width="1.27"
            />
            <g filter="url(#filter2_dd_2009_21216)">
                <circle cx="76.382" cy="146.303" r="12.6971" fill="#FFEBE7" />
            </g>
            <path
                d="M70.0108 146.066L70.4562 145.611L70.0108 146.066C70.0987 146.152 70.1874 146.237 70.2768 146.322C70.9452 146.954 71.6546 147.546 72.4007 148.092C72.4183 148.105 72.4265 148.119 72.4301 148.13C72.4336 148.141 72.4335 148.151 72.4301 148.161C72.1203 149.091 71.8806 150.051 71.717 151.036C71.6842 151.234 71.6544 151.432 71.6278 151.632C71.4833 152.714 72.6273 153.366 73.5087 152.914C73.6847 152.824 73.8593 152.731 74.0322 152.636C74.8255 152.199 75.5851 151.711 76.3061 151.176C76.3518 151.143 76.4243 151.143 76.4699 151.176C77.191 151.711 77.9506 152.199 78.7439 152.636C78.9168 152.731 79.0913 152.824 79.2674 152.914C80.1487 153.366 81.2928 152.714 81.1483 151.632C81.1217 151.432 81.0919 151.234 81.0591 151.036C80.8954 150.051 80.6557 149.091 80.346 148.161C80.3425 148.151 80.3425 148.141 80.346 148.13C80.3496 148.119 80.3578 148.105 80.3753 148.092C81.1215 147.546 81.8309 146.954 82.4993 146.322C82.5887 146.237 82.6773 146.152 82.7652 146.066C83.5344 145.314 83.0835 144.1 82.079 143.925C81.8603 143.886 81.6403 143.852 81.4191 143.821C80.6445 143.711 79.8639 143.647 79.0824 143.626C79.0158 143.624 78.9823 143.583 78.9754 143.562C78.6897 142.675 78.3404 141.815 77.9328 140.987L77.3616 141.269L77.9328 140.987C77.8033 140.725 77.668 140.465 77.527 140.209C77.0346 139.316 75.7414 139.316 75.2491 140.209C75.108 140.465 74.9727 140.725 74.8433 140.987L75.4145 141.269L74.8433 140.987C74.4357 141.815 74.0864 142.675 73.8007 143.562C73.7937 143.583 73.7603 143.624 73.6937 143.626C72.9121 143.647 72.1315 143.711 71.3569 143.821C71.1358 143.852 70.9158 143.886 70.697 143.925L70.8066 144.552L70.697 143.925C69.6926 144.1 69.2417 145.314 70.0108 146.066Z"
                stroke="#FF7459"
                stroke-width="1.27355"
            />
            <defs>
                <filter
                    id="filter0_dddd_2009_21216"
                    x="89.6188"
                    y="69.5293"
                    width="143.16"
                    height="173.537"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="5.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.09 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="25" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_2009_21216"
                        result="effect3_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="45" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_2009_21216"
                        result="effect4_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_dd_2009_21216"
                    x="226.067"
                    y="83.3564"
                    width="29.8615"
                    height="32.4359"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.321795" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.86154" />
                    <feGaussianBlur stdDeviation="0.965385" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_dd_2009_21216"
                    x="62.1375"
                    y="133.09"
                    width="28.4891"
                    height="30.5526"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.257904" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.09484" />
                    <feGaussianBlur stdDeviation="0.773711" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2009_21216"
                    x1="163.333"
                    y1="54"
                    x2="163.333"
                    y2="228"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2009_21216"
                    x1="163.333"
                    y1="0"
                    x2="163.333"
                    y2="282"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2009_21216"
                    x1="161.199"
                    y1="75.5293"
                    x2="161.199"
                    y2="177.066"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF7854" />
                    <stop offset="1" stop-color="#FE643D" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2009_21216"
                    x1="161.199"
                    y1="75.5293"
                    x2="161.199"
                    y2="177.066"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF7854" />
                    <stop offset="1" stop-color="#FE643D" />
                </linearGradient>
                <clipPath id="clip0_2009_21216">
                    <rect
                        width="325.33"
                        height="282"
                        fill="white"
                        transform="translate(0.333344)"
                    />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'bell-illustration'"
            width="326"
            height="282"
            viewBox="0 0 326 282"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2009_21216)">
                <circle
                    cx="163.667"
                    cy="141"
                    r="87"
                    stroke="url(#paint0_linear_2009_21216)"
                    stroke-width="2"
                />
                <circle
                    cx="163.667"
                    cy="141"
                    r="141"
                    stroke="url(#paint1_linear_2009_21216)"
                    stroke-width="2"
                />
            </g>
            <g clip-path="url(#clip1_2009_21216)">
                <g filter="url(#filter0_dddd_2009_21216)">
                    <path
                        d="M180.967 182.836C184.782 184 188.907 182.517 191.108 179.193C193.258 175.946 193.042 171.675 191.386 168.151C189.351 163.822 187.468 157.476 189.355 150.902C196.29 126.739 192.192 109.798 173.511 104.444C154.831 99.0899 141.714 110.774 134.782 134.852C132.851 141.649 127.241 146.345 122.818 149.11C119.532 151.165 117.334 154.884 117.912 158.716C118.384 161.846 120.612 164.427 123.64 165.351L143.579 171.441C143.214 172.743 143.094 174.102 143.226 175.448C143.365 176.876 143.784 178.262 144.459 179.527C145.135 180.793 146.052 181.913 147.16 182.824C148.268 183.735 149.545 184.418 150.917 184.836C152.289 185.253 153.73 185.396 155.157 185.257C156.585 185.117 157.971 184.698 159.236 184.023C160.502 183.348 161.622 182.43 162.533 181.322C163.389 180.281 164.044 179.091 164.466 177.812L180.967 182.836Z"
                        fill="#FF7237"
                    />
                    <path
                        d="M171.581 87.5876C171.031 91.5939 173.756 95.3148 177.742 96C180.927 96.5475 184.105 94.9935 185.629 92.1431L187.355 88.9126C189.916 84.1221 187.167 78.2141 181.854 77.0868C177.218 76.1034 172.723 79.2635 172.079 83.9585L171.581 87.5876Z"
                        fill="#FF7237"
                    />
                    <path
                        d="M133.339 134.442L133.341 134.437C136.848 122.256 141.978 112.982 148.795 107.447C155.694 101.845 164.162 100.204 173.925 103.002C183.705 105.805 189.813 111.722 192.47 120.17C195.09 128.501 194.299 139.112 190.797 151.316C189.055 157.387 190.778 163.332 192.743 167.513C194.552 171.359 194.88 176.214 192.359 180.021C189.791 183.899 184.979 185.628 180.53 184.271M133.339 134.442L180.53 184.271M133.339 134.442C131.562 140.698 126.343 145.138 122.023 147.838C118.354 150.132 115.742 154.384 116.429 158.94C116.987 162.641 119.622 165.693 123.202 166.785C123.202 166.785 123.202 166.785 123.203 166.786L141.822 172.473C141.662 173.503 141.631 174.552 141.733 175.594C141.891 177.218 142.368 178.794 143.136 180.233C143.904 181.673 144.948 182.947 146.208 183.982C147.468 185.018 148.92 185.796 150.48 186.271C152.041 186.745 153.68 186.908 155.303 186.75C156.927 186.591 158.503 186.114 159.942 185.347C161.382 184.579 162.656 183.535 163.691 182.275C164.353 181.47 164.909 180.588 165.348 179.648M133.339 134.442L165.348 179.648M180.53 184.271L165.348 179.648M180.53 184.271L165.348 179.648M170.095 87.3838C169.435 92.1912 172.705 96.6561 177.488 97.4783C181.31 98.1354 185.123 96.2705 186.951 92.8502L188.678 89.6197C191.71 83.9484 188.456 76.9541 182.165 75.6195C176.677 74.4552 171.355 78.1964 170.593 83.7546L170.095 87.3838Z"
                        stroke="white"
                        stroke-width="3"
                    />
                </g>
                <path
                    d="M141.018 172.24L165.56 179.712"
                    stroke="white"
                    stroke-width="3"
                />
                <g filter="url(#filter1_dd_2009_21216)">
                    <circle
                        cx="247.699"
                        cy="159.081"
                        r="12.6971"
                        fill="#FFEBE7"
                    />
                </g>
                <path
                    d="M252.957 156.996H248.868C248.634 156.996 248.444 156.806 248.444 156.572V152.561C248.444 152.141 247.899 151.976 247.666 152.326L242.162 160.581C241.974 160.864 242.176 161.241 242.515 161.241H246.604C246.839 161.241 247.029 161.432 247.029 161.666V165.677C247.029 166.097 247.573 166.261 247.806 165.912L253.31 157.656C253.498 157.374 253.296 156.996 252.957 156.996Z"
                    stroke="#FF7459"
                    stroke-width="1.27"
                    stroke-linejoin="round"
                />
                <g filter="url(#filter2_dd_2009_21216)">
                    <circle
                        cx="90.0112"
                        cy="94.3934"
                        r="12.6971"
                        fill="#FFEBE7"
                    />
                </g>
                <path
                    d="M90.6866 91.6011C90.6866 91.2504 90.4023 90.9661 90.0516 90.9661C89.7009 90.9661 89.4166 91.2504 89.4166 91.6011H90.6866ZM90.0516 94.4312H89.4166C89.4166 94.5997 89.4835 94.7612 89.6026 94.8803L90.0516 94.4312ZM95.7843 94.4312C95.7843 97.5974 93.2177 100.164 90.0516 100.164V101.434C93.9191 101.434 97.0543 98.2988 97.0543 94.4312H95.7843ZM90.0516 100.164C86.8855 100.164 84.3188 97.5974 84.3188 94.4312H83.0488C83.0488 98.2988 86.1841 101.434 90.0516 101.434V100.164ZM84.3188 94.4312C84.3188 91.2651 86.8855 88.6985 90.0516 88.6985V87.4285C86.1841 87.4285 83.0488 90.5637 83.0488 94.4312H84.3188ZM90.0516 88.6985C93.2177 88.6985 95.7843 91.2651 95.7843 94.4312H97.0543C97.0543 90.5637 93.9191 87.4285 90.0516 87.4285V88.6985ZM89.4166 91.6011V94.4312H90.6866V91.6011H89.4166ZM89.6026 94.8803L91.3714 96.6491L92.2694 95.7511L90.5006 93.9822L89.6026 94.8803Z"
                    fill="#FF7459"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dddd_2009_21216"
                    x="96.8179"
                    y="70.9062"
                    width="116.857"
                    height="180.402"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="11" />
                    <feGaussianBlur stdDeviation="5.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.09 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="25" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_2009_21216"
                        result="effect3_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="45" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.329412 0 0 0 0 0.345098 0 0 0 0 0.372549 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_2009_21216"
                        result="effect4_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_dd_2009_21216"
                    x="233.071"
                    y="145.74"
                    width="29.2558"
                    height="31.8304"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.321795" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.86154" />
                    <feGaussianBlur stdDeviation="0.965386" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_dd_2009_21216"
                    x="75.3833"
                    y="81.0527"
                    width="29.2558"
                    height="31.8304"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="0.321795" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.05 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2009_21216"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3.86154" />
                    <feGaussianBlur stdDeviation="0.965386" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.894118 0 0 0 0 0.0941176 0 0 0 0 0.0941176 0 0 0 0.01 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_2009_21216"
                        result="effect2_dropShadow_2009_21216"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_2009_21216"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2009_21216"
                    x1="163.667"
                    y1="54"
                    x2="163.667"
                    y2="228"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2009_21216"
                    x1="163.667"
                    y1="0"
                    x2="163.667"
                    y2="282"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#F65D3C" stop-opacity="0" />
                    <stop
                        offset="0.205"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.73"
                        stop-color="#F65D3C"
                        stop-opacity="0.12"
                    />
                    <stop
                        offset="0.855"
                        stop-color="#F65D3C"
                        stop-opacity="0"
                    />
                </linearGradient>
                <clipPath id="clip0_2009_21216">
                    <rect
                        width="325.33"
                        height="282"
                        fill="white"
                        transform="translate(0.666626)"
                    />
                </clipPath>
                <clipPath id="clip1_2009_21216">
                    <rect
                        width="258"
                        height="218.001"
                        fill="white"
                        transform="translate(33.9987 28)"
                    />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'quote'"
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M38.7837 27.7727C38.2304 23.9798 35.7901 21.753 32.1881 21.6162C31.8822 21.6046 31.5869 21.4749 31.4121 21.2235C30.3296 19.6665 29.25 16.7044 30.8583 11.7578C31.181 10.7653 30.2098 10.0491 29.5681 10.8722C23.2851 18.9314 19.3061 36.4345 32.4229 35.6115C36.0826 35.3819 39.3615 31.7337 38.7837 27.7727Z"
                fill="#FF6726"
            />
            <path
                d="M19.5273 29.7997C19.5409 25.9662 17.4567 23.4009 13.9146 22.7297C13.614 22.6727 13.3403 22.5006 13.2201 22.2193C12.3944 20.2876 11.9317 15.7278 14.4161 10.4777C14.8624 9.53454 14 8.69849 13.2605 9.4346C5.77427 16.8865 -1.04731 35.4645 12.0777 36.6052C15.7309 36.9227 19.513 33.8028 19.5273 29.7997Z"
                fill="#FF6726"
            />
        </svg>

        <svg
            v-if="icon === 'plane-looping'"
            width="325"
            height="231"
            viewBox="0 0 325 231"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2079_2958)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48.3617 80.7885C47.4557 80.1567 46.209 80.3789 45.5771 81.2849C45.0374 82.0588 44.5423 82.8564 44.091 83.6756C43.5581 84.6431 43.9104 85.8595 44.8779 86.3924C45.8454 86.9253 47.0617 86.573 47.5947 85.6055C47.9785 84.9086 48.3994 84.2307 48.8581 83.573C49.4899 82.667 49.2677 81.4204 48.3617 80.7885ZM59.8248 72.6112C60.1966 73.6513 61.3411 74.1931 62.3813 73.8214C62.7834 73.6776 63.1932 73.5388 63.6107 73.4049C64.0394 73.2674 64.4627 73.1393 64.8808 73.0201C65.9431 72.7175 66.5589 71.611 66.2563 70.5487C65.9537 69.4864 64.8472 68.8706 63.7849 69.1732C63.3238 69.3045 62.8586 69.4454 62.3893 69.5959C61.9306 69.743 61.4791 69.896 61.035 70.0547C59.9948 70.4265 59.453 71.5711 59.8248 72.6112ZM42.5076 100.308C41.4088 100.421 40.6099 101.404 40.7231 102.502C40.8144 103.388 40.9348 104.28 41.0836 105.177C41.2645 106.267 42.2944 107.003 43.3841 106.822C44.4738 106.641 45.2105 105.612 45.0296 104.522C44.8939 103.704 44.7846 102.894 44.702 102.092C44.5888 100.994 43.6063 100.195 42.5076 100.308ZM-5.11613 186.204C-4.93088 187.293 -3.89797 188.025 -2.80904 187.84C-1.94921 187.694 -1.09535 187.542 -0.247457 187.383C0.83834 187.18 1.55416 186.136 1.35138 185.05C1.14859 183.964 0.103987 183.248 -0.981801 183.451C-1.80849 183.606 -2.64118 183.754 -3.47987 183.897C-4.5688 184.082 -5.30137 185.115 -5.11613 186.204ZM80.4035 70.9659C79.8948 71.9464 80.2773 73.1536 81.2578 73.6622C81.9437 74.018 82.5945 74.4216 83.2107 74.8707C84.1033 75.5213 85.3544 75.3251 86.005 74.4325C86.6556 73.5399 86.4594 72.2888 85.5668 71.6382C84.7883 71.0708 83.9656 70.5607 83.0998 70.1115C82.1193 69.6029 80.9121 69.9854 80.4035 70.9659ZM48.2041 120.197C47.2321 120.722 46.8693 121.935 47.3938 122.907C47.8094 123.677 48.2426 124.445 48.6931 125.212C49.2529 126.164 50.4786 126.482 51.4308 125.922C52.383 125.362 52.7011 124.137 52.1413 123.184C51.7152 122.46 51.306 121.734 50.914 121.007C50.3894 120.035 49.1762 119.672 48.2041 120.197ZM15.2731 181.572C15.6081 182.625 16.7328 183.206 17.7854 182.871C18.6392 182.6 19.4855 182.322 20.3244 182.037C21.3704 181.682 21.9308 180.547 21.5761 179.501C21.2214 178.455 20.0858 177.894 19.0397 178.249C18.2247 178.525 17.4024 178.796 16.5726 179.06C15.52 179.395 14.9382 180.519 15.2731 181.572ZM92.5757 86.9559C91.4845 87.1273 90.7389 88.1509 90.9104 89.2421C91.0376 90.0521 91.1388 90.8846 91.2134 91.7383C91.3095 92.8387 92.2795 93.6528 93.3798 93.5567C94.4802 93.4606 95.2943 92.4906 95.1982 91.3902C95.116 90.4488 95.0039 89.5251 94.8619 88.6212C94.6905 87.53 93.6669 86.7844 92.5757 86.9559ZM34.7181 174.025C35.2139 175.012 36.416 175.41 37.403 174.914C38.2141 174.507 39.0162 174.093 39.8094 173.673C40.7856 173.157 41.1581 171.946 40.6414 170.97C40.1247 169.994 38.9144 169.621 37.9381 170.138C37.1701 170.545 36.3933 170.945 35.6076 171.34C34.6206 171.836 34.2223 173.038 34.7181 174.025ZM60.031 137.246C59.2286 138.005 59.1935 139.271 59.9526 140.074C60.56 140.716 61.1801 141.352 61.8127 141.983C62.595 142.763 63.8613 142.761 64.6411 141.978C65.4209 141.196 65.4189 139.93 64.6366 139.15C64.0317 138.547 63.4388 137.938 62.8584 137.325C62.0993 136.522 60.8335 136.487 60.031 137.246ZM52.7385 163.348C53.3982 164.234 54.6512 164.418 55.5371 163.758C56.2535 163.224 56.9598 162.685 57.656 162.142C58.5266 161.462 58.6812 160.205 58.0014 159.335C57.3216 158.464 56.0647 158.309 55.1941 158.989C54.5219 159.514 53.8398 160.034 53.1479 160.55C52.262 161.209 52.0787 162.462 52.7385 163.348ZM91.9501 107.779C90.8796 107.507 89.7912 108.154 89.5191 109.225C89.313 110.036 89.0894 110.853 88.8481 111.675C88.5372 112.735 89.1444 113.846 90.2043 114.157C91.2642 114.468 92.3755 113.861 92.6864 112.801C92.9412 111.933 93.1776 111.069 93.3959 110.21C93.6679 109.14 93.0207 108.051 91.9501 107.779ZM68.5166 149.637C69.3313 150.383 70.5964 150.328 71.3423 149.513C71.9525 148.847 72.5506 148.177 73.1367 147.503C73.862 146.67 73.7747 145.407 72.9416 144.682C72.1085 143.956 70.8452 144.044 70.1199 144.877C69.5557 145.525 68.9798 146.17 68.3922 146.812C67.6463 147.626 67.702 148.891 68.5166 149.637ZM84.6307 127.324C83.6639 126.79 82.4471 127.14 81.9128 128.107C81.5005 128.853 81.0743 129.599 80.6342 130.345C80.0728 131.296 80.389 132.523 81.3403 133.084C82.2916 133.645 83.5178 133.329 84.0791 132.378C84.5383 131.6 84.9832 130.821 85.4137 130.042C85.948 129.075 85.5974 127.858 84.6307 127.324ZM75.6355 150.954C75.0229 151.873 75.2715 153.115 76.1906 153.728C76.924 154.216 77.6669 154.697 78.4192 155.169C79.3548 155.756 80.5892 155.474 81.1764 154.538C81.7635 153.603 81.4811 152.368 80.5455 151.781C79.8242 151.329 79.112 150.868 78.4089 150.399C77.4897 149.787 76.248 150.035 75.6355 150.954ZM93.8732 160.904C93.475 161.934 93.9874 163.092 95.0177 163.49C95.847 163.811 96.6837 164.121 97.5276 164.421C98.5686 164.79 99.7119 164.246 100.081 163.205C100.451 162.164 99.9067 161.021 98.8658 160.651C98.0567 160.364 97.2547 160.067 96.4597 159.759C95.4294 159.361 94.2714 159.874 93.8732 160.904ZM113.851 166.644C113.688 167.736 114.441 168.754 115.533 168.918C116.405 169.048 117.281 169.167 118.164 169.274C119.26 169.408 120.257 168.627 120.39 167.53C120.524 166.434 119.743 165.437 118.647 165.304C117.801 165.201 116.96 165.087 116.125 164.962C115.032 164.798 114.014 165.551 113.851 166.644ZM134.596 167.903C134.669 169.005 135.622 169.839 136.724 169.766C137.595 169.708 138.47 169.638 139.348 169.557C140.448 169.455 141.257 168.481 141.155 167.381C141.053 166.281 140.079 165.472 138.979 165.574C138.135 165.652 137.295 165.719 136.458 165.775C135.356 165.848 134.522 166.801 134.596 167.903ZM155.122 164.839C155.41 165.906 156.508 166.537 157.575 166.249C158.431 166.017 159.289 165.775 160.15 165.521C161.209 165.208 161.815 164.096 161.502 163.037C161.189 161.977 160.077 161.372 159.018 161.684C158.186 161.93 157.358 162.164 156.532 162.387C155.465 162.675 154.834 163.773 155.122 164.839ZM174.703 158.023C175.168 159.026 176.357 159.461 177.359 158.997C178.159 158.625 178.961 158.244 179.764 157.853C180.757 157.368 181.169 156.171 180.685 155.178C180.201 154.185 179.004 153.773 178.011 154.257C177.231 154.637 176.453 155.008 175.676 155.368C174.674 155.832 174.238 157.021 174.703 158.023ZM193.065 148.132C193.668 149.058 194.907 149.32 195.832 148.718C196.546 148.254 197.261 147.781 197.977 147.299C198.893 146.683 199.137 145.44 198.52 144.524C197.904 143.607 196.661 143.364 195.744 143.98C195.046 144.45 194.348 144.912 193.652 145.365C192.726 145.967 192.463 147.206 193.065 148.132ZM209.845 136.019C210.55 136.869 211.81 136.987 212.661 136.282C213.333 135.724 214.007 135.159 214.68 134.585C215.521 133.869 215.623 132.607 214.907 131.766C214.19 130.925 212.928 130.823 212.087 131.539C211.427 132.102 210.767 132.656 210.107 133.203C209.257 133.908 209.139 135.169 209.845 136.019ZM225.329 122.097C226.112 122.877 227.378 122.874 228.158 122.092C228.786 121.461 229.414 120.823 230.043 120.178C230.814 119.387 230.798 118.121 230.007 117.35C229.216 116.579 227.95 116.595 227.179 117.386C226.56 118.021 225.942 118.649 225.324 119.269C224.544 120.052 224.547 121.318 225.329 122.097ZM239.556 106.842C240.397 107.557 241.66 107.456 242.375 106.614C242.951 105.938 243.526 105.256 244.102 104.567C244.81 103.719 244.697 102.458 243.849 101.75C243.002 101.042 241.74 101.155 241.032 102.002C240.464 102.682 239.897 103.355 239.329 104.022C238.613 104.863 238.715 106.126 239.556 106.842Z"
                    fill="#E2E8F0"
                />
                <path
                    d="M258.791 91.1043C258.132 91.8005 257.942 92.8127 258.258 93.7177C258.792 95.2443 259.231 96.805 259.575 98.3907C260.556 102.938 258.456 103.764 257.303 103.887C256.852 103.935 256.428 103.733 256.08 103.442L241.024 90.8466C240.482 90.3932 240.141 89.7172 240.336 89.0381C240.674 87.8648 241.701 86.194 244.823 86.3828C246.254 86.4673 247.795 86.6228 249.251 86.7997C250.184 86.9131 251.108 86.4993 251.631 85.7184L251.637 85.7102C252.444 84.5064 253.348 83.1575 254.311 81.7366C255.211 80.4078 254.634 78.5821 253.13 78.0217L240.294 73.2391C239.209 72.835 238.553 71.7247 238.965 70.6428C239.921 68.1288 242.474 64.1904 248.883 65.7268C252.303 66.546 257.353 67.6712 261.586 68.5979C262.545 68.8078 263.532 68.4251 264.139 67.6533C267.685 63.1427 275.423 55.0118 279.938 58.2845C283.096 60.9892 276.97 70.8483 273.163 75.5474C272.568 76.2821 272.389 77.278 272.746 78.1536C274.397 82.2043 276.355 86.96 277.743 90.1938C280.366 96.3009 277.215 99.6102 274.998 101.079C274.006 101.737 272.752 101.283 272.158 100.251L265.482 88.6483C264.656 87.2126 262.678 86.9835 261.542 88.1896C260.563 89.2299 259.635 90.2131 258.791 91.1043Z"
                    fill="#E2E8F0"
                />
            </g>
            <defs>
                <clipPath id="clip0_2079_2958">
                    <rect width="325" height="231" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'benefits'"
            width="97"
            height="64"
            viewBox="0 0 97 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M39.1986 15.7304C39.6306 12.5379 42.5689 10.3 45.7615 10.7321C48.9541 11.1641 51.1919 14.1025 50.7598 17.295L50.1116 22.0847C49.6796 25.2773 46.7412 27.5151 43.5487 27.083C40.3561 26.651 38.1183 23.7127 38.5504 20.5201L39.1986 15.7304ZM45.4933 12.714C43.3953 12.4301 41.4644 13.9007 41.1805 15.9986L40.5323 20.7883C40.2484 22.8863 41.7189 24.8172 43.8169 25.1011C45.9149 25.385 47.8458 23.9145 48.1297 21.8165L48.7779 17.0268C49.0618 14.9289 47.5912 12.9979 45.4933 12.714ZM34.8911 24.0558C35.3905 23.82 35.9865 24.0337 36.2223 24.5331C37.2227 26.652 39.2381 29.3589 43.1687 29.8908C47.0993 30.4227 49.7617 28.3489 51.2893 26.5721C51.6494 26.1534 52.2807 26.1058 52.6995 26.4658C53.1183 26.8259 53.1659 27.4573 52.8058 27.876C51.1777 29.7696 48.2281 32.1703 43.8972 31.9642L43.7015 33.4107C43.6274 33.958 43.1237 34.3416 42.5764 34.2676C42.0291 34.1935 41.6455 33.6898 41.7195 33.1425L41.9153 31.696C37.6855 30.7436 35.48 27.6452 34.4138 25.387C34.178 24.8876 34.3917 24.2916 34.8911 24.0558Z"
                fill="#FF7237"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M53.8687 38.9973C52.487 38.8433 51.1716 39.7337 50.8299 41.1201L49.8178 45.2263C49.446 46.7345 50.3673 48.2585 51.8754 48.6302L53.6353 49.064C54.1715 49.1961 54.7133 48.8686 54.8455 48.3324L56.7252 40.7064C56.8574 40.1702 56.5298 39.6283 55.9936 39.4962L55.8271 39.4551C57.0496 36.0776 60.8997 34.0538 64.8719 35.0329C68.844 36.012 71.3125 39.5932 70.8253 43.152L70.6588 43.111C70.1226 42.9788 69.5807 43.3064 69.4486 43.8426L67.5689 51.4685C67.4367 52.0047 67.7642 52.5466 68.3005 52.6788L68.6862 52.7739C67.7746 54.5773 65.7105 55.5808 63.6648 55.0765L61.6117 54.5705C61.176 54.4631 60.9099 54.0228 61.0173 53.5871L61.1619 53.0005C61.294 52.4643 60.9665 51.9224 60.4303 51.7902C59.894 51.6581 59.3522 51.9856 59.22 52.5219L59.0754 53.1085C58.7037 54.6166 59.6249 56.1406 61.1331 56.5123L63.1862 57.0184C66.3319 57.7938 69.5077 56.1115 70.6904 53.1946C71.9719 53.2153 73.1444 52.3523 73.4642 51.0549L74.4763 46.9486C74.8181 45.5623 74.0672 44.1625 72.7722 43.6567C73.5623 38.9095 70.2891 34.3083 65.3505 33.091C60.4119 31.8737 55.3753 34.4266 53.8687 38.9973ZM71.1511 45.2922L69.7501 50.9762L70.539 51.1707C70.9747 51.2781 71.4149 51.0119 71.5223 50.5762L72.5344 46.47C72.6418 46.0343 72.3757 45.594 71.94 45.4866L71.1511 45.2922ZM54.544 41.1987L53.7551 41.0043C53.3194 40.8969 52.8792 41.163 52.7718 41.5987L51.7596 45.705C51.6522 46.1407 51.9184 46.5809 52.3541 46.6883L53.143 46.8828L54.544 41.1987Z"
                fill="#FF7237"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.93694 41.9442C8.28349 40.174 9.18881 38.2092 10.959 37.5558L26.829 31.6976C28.5992 31.0442 30.564 31.9495 31.2174 33.7197L32.1589 36.2703C32.3005 36.6539 32.1943 37.085 31.8907 37.359C30.1454 38.9339 31.1991 41.7883 33.5491 41.8515C33.9578 41.8625 34.3187 42.1213 34.4603 42.5049L35.4018 45.0554C36.0553 46.8256 35.15 48.7904 33.3797 49.4438L17.5098 55.302C15.7396 55.9555 13.7748 55.0501 13.1213 53.2799L12.1799 50.7294C12.0382 50.3458 12.1445 49.9146 12.448 49.6407C14.1933 48.0658 13.1396 45.2113 10.7897 45.1481C10.3809 45.1371 10.02 44.8784 9.87843 44.4948L8.93694 41.9442ZM11.6516 39.432C10.9176 39.703 10.5423 40.5176 10.8132 41.2516L11.5384 43.2162C14.9741 43.8004 16.5045 47.9464 14.2724 50.6227L14.9976 52.5873C15.2685 53.3213 16.0832 53.6967 16.8172 53.4258L32.6871 47.5676C33.4211 47.2967 33.7965 46.482 33.5256 45.748L32.8004 43.7834C29.3647 43.1993 27.8342 39.0532 30.0664 36.3769L29.3412 34.4123C29.0702 33.6783 28.2556 33.3029 27.5216 33.5739L11.6516 39.432ZM23.7593 37.3389C24.2774 37.1476 24.8524 37.4126 25.0437 37.9307L25.0479 37.9421C25.2391 38.4602 24.9741 39.0352 24.456 39.2265C23.9379 39.4177 23.3629 39.1528 23.1716 38.6346L23.1674 38.6233C22.9762 38.1052 23.2411 37.5301 23.7593 37.3389ZM25.2238 41.3064C25.7419 41.1151 26.317 41.3801 26.5082 41.8982L26.5124 41.9095C26.7037 42.4277 26.4387 43.0027 25.9206 43.194C25.4025 43.3852 24.8274 43.1202 24.6361 42.6021L24.632 42.5908C24.4407 42.0727 24.7057 41.4976 25.2238 41.3064ZM26.6883 45.2739C27.2064 45.0826 27.7815 45.3476 27.9728 45.8657L27.9769 45.877C28.1682 46.3951 27.9032 46.9702 27.3851 47.1615C26.867 47.3527 26.2919 47.0877 26.1007 46.5696L26.0965 46.5583C25.9052 46.0402 26.1702 45.4651 26.6883 45.2739Z"
                fill="#FF7237"
            />
        </svg>

        <svg
            v-if="icon === 'stars'"
            width="97"
            height="64"
            viewBox="0 0 97 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M65.0835 26.6279C65.6358 26.6279 66.0835 27.0756 66.0835 27.6279C66.0835 32.6541 67.1355 36.0445 69.167 38.1888C71.1869 40.321 74.3667 41.4207 79.0977 41.4207C79.6499 41.4207 80.0977 41.8684 80.0977 42.4207C80.0977 42.9729 79.6499 43.4207 79.0977 43.4207C74.3667 43.4207 71.1869 44.5203 69.167 46.6525C67.1355 48.7968 66.0835 52.1872 66.0835 57.2134C66.0835 57.7657 65.6358 58.2134 65.0835 58.2134C64.5312 58.2134 64.0835 57.7657 64.0835 57.2134C64.0835 52.1872 63.0315 48.7968 61 46.6525C58.9801 44.5203 55.8003 43.4207 51.0693 43.4207C50.5171 43.4207 50.0693 42.9729 50.0693 42.4207C50.0693 41.8684 50.5171 41.4207 51.0693 41.4207C55.8003 41.4207 58.9801 40.321 61 38.1888C63.0315 36.0445 64.0835 32.6541 64.0835 27.6279C64.0835 27.0756 64.5312 26.6279 65.0835 26.6279ZM65.0835 34.9986C64.4933 36.7981 63.6282 38.3227 62.4519 39.5643C61.2298 40.8543 59.7162 41.7927 57.922 42.4207C59.7162 43.0486 61.2298 43.987 62.4519 45.277C63.6282 46.5186 64.4933 48.0432 65.0835 49.8427C65.6737 48.0432 66.5388 46.5186 67.7151 45.277C68.9372 43.987 70.4508 43.0486 72.245 42.4207C70.4508 41.7927 68.9372 40.8543 67.7151 39.5643C66.5388 38.3227 65.6737 36.7981 65.0835 34.9986Z"
                fill="#FF7237"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M52.3452 12.2305C52.8285 12.2305 53.2202 12.6222 53.2202 13.1055C53.2202 16.0633 53.8406 17.9932 54.977 19.1927C56.1032 20.3815 57.9033 21.0269 60.6787 21.0269C61.162 21.0269 61.5537 21.4187 61.5537 21.9019C61.5537 22.3852 61.162 22.7769 60.6787 22.7769C57.9033 22.7769 56.1032 23.4224 54.977 24.6112C53.8406 25.8107 53.2202 27.7405 53.2202 30.6984C53.2202 31.1817 52.8285 31.5734 52.3452 31.5734C51.862 31.5734 51.4702 31.1817 51.4702 30.6984C51.4702 27.7405 50.8498 25.8107 49.7134 24.6112C48.5872 23.4224 46.7871 22.7769 44.0117 22.7769C43.5285 22.7769 43.1367 22.3852 43.1367 21.9019C43.1367 21.4187 43.5285 21.0269 44.0117 21.0269C46.7871 21.0269 48.5872 20.3815 49.7134 19.1927C50.8498 17.9932 51.4702 16.0633 51.4702 13.1055C51.4702 12.6222 51.862 12.2305 52.3452 12.2305ZM52.3452 18.2864C52.0034 19.0894 51.554 19.7945 50.9839 20.3962C50.3791 21.0346 49.663 21.5313 48.8426 21.9019C49.663 22.2726 50.3791 22.7693 50.9839 23.4076C51.554 24.0094 52.0034 24.7145 52.3452 25.5174C52.687 24.7145 53.1365 24.0094 53.7066 23.4076C54.3113 22.7693 55.0274 22.2726 55.8478 21.9019C55.0274 21.5313 54.3113 21.0346 53.7066 20.3962C53.1365 19.7945 52.687 19.0894 52.3452 18.2864Z"
                fill="#FF7237"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M69.9233 7.41406C70.3376 7.41406 70.6733 7.74985 70.6733 8.16406C70.6733 10.2209 71.1054 11.5305 71.8663 12.3337C72.6186 13.1278 73.8352 13.5758 75.7607 13.5758C76.175 13.5758 76.5107 13.9116 76.5107 14.3258C76.5107 14.74 76.175 15.0758 75.7607 15.0758C73.8352 15.0758 72.6186 15.5237 71.8663 16.3178C71.1054 17.1211 70.6733 18.4307 70.6733 20.4875C70.6733 20.9017 70.3376 21.2375 69.9233 21.2375C69.5091 21.2375 69.1733 20.9017 69.1733 20.4875C69.1733 18.4307 68.7413 17.1211 67.9803 16.3178C67.228 15.5237 66.0115 15.0758 64.0859 15.0758C63.6717 15.0758 63.3359 14.74 63.3359 14.3258C63.3359 13.9116 63.6717 13.5758 64.0859 13.5758C66.0115 13.5758 67.228 13.1278 67.9803 12.3337C68.7413 11.5305 69.1733 10.2209 69.1733 8.16406C69.1733 7.74985 69.5091 7.41406 69.9233 7.41406ZM69.9233 12.1231C69.6967 12.5863 69.4141 13.0014 69.0693 13.3653C68.6969 13.7584 68.2673 14.0759 67.7845 14.3258C68.2673 14.5756 68.6969 14.8932 69.0693 15.2862C69.4141 15.6501 69.6967 16.0652 69.9233 16.5284C70.15 16.0652 70.4326 15.6501 70.7774 15.2862C71.1498 14.8932 71.5794 14.5756 72.0621 14.3258C71.5794 14.0759 71.1498 13.7584 70.7774 13.3653C70.4326 13.0014 70.15 12.5863 69.9233 12.1231Z"
                fill="#FF7237"
            />
        </svg>

        <svg
            v-if="icon === 'travel-course'"
            width="96"
            height="64"
            viewBox="0 0 96 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M57.5627 19.8704C55.9524 19.559 54.2931 19.6074 52.7036 20.012C51.1141 20.4167 49.6337 21.1677 48.3683 22.2113C48.3506 22.2259 48.3324 22.2399 48.3137 22.2533L34.8272 31.8962C32.002 33.9163 28.1093 33.4875 25.7914 30.9009L24.9032 29.9096C24.8057 29.8095 24.6787 29.7431 24.5407 29.7202C24.3993 29.6967 24.2542 29.7201 24.1274 29.7868L19.6054 32.1688C19.4893 32.2437 19.3996 32.3534 19.3493 32.4825C19.3051 32.5961 19.2936 32.7193 19.3154 32.8383L25.699 45.3672C25.9845 45.887 26.4626 46.2742 27.0308 46.4452C27.6027 46.6173 28.2195 46.5565 28.7468 46.2759L28.7601 46.2689L40.2739 40.3624C41.3822 39.7939 42.6906 40.6366 42.6315 41.8807L42.3729 47.3243C42.3758 47.4553 42.4107 47.5837 42.4748 47.6981C42.5419 47.818 42.6386 47.9187 42.7558 47.9905C42.8729 48.0623 43.0065 48.1028 43.1438 48.1082C43.2811 48.1135 43.4175 48.0835 43.5399 48.0211L43.5429 48.0195L48.9378 45.2884C49.0514 45.232 49.149 45.1479 49.2214 45.0438C49.2939 44.9397 49.3389 44.819 49.3522 44.6929L49.3547 44.672L50.2247 37.8432C50.3962 36.4965 51.2232 35.3221 52.4333 34.7067L64.0707 28.7888C64.0906 28.7787 64.1107 28.7693 64.1312 28.7606C64.431 28.6325 64.7004 28.4424 64.9216 28.2028C65.1429 27.9633 65.3109 27.6797 65.4148 27.3706C65.5187 27.0615 65.556 26.7339 65.5243 26.4094C65.4927 26.0848 65.3927 25.7707 65.2311 25.4875L65.2215 25.4704C64.4364 24.0303 63.3428 22.7815 62.0188 21.8134C60.6947 20.8453 59.1731 20.1818 57.5627 19.8704ZM52.2102 18.0739C54.0853 17.5965 56.0427 17.5394 57.9425 17.9068C59.8422 18.2742 61.6373 19.0569 63.1992 20.199C64.7586 21.3392 66.0472 22.8094 66.973 24.5048C67.2715 25.0306 67.4562 25.6133 67.5149 26.2152C67.5739 26.8204 67.5043 27.4312 67.3106 28.0076C67.1169 28.5841 66.8035 29.113 66.391 29.5597C65.9865 29.9977 65.4956 30.347 64.9495 30.5857L53.3399 36.4895C52.7201 36.8046 52.2965 37.4062 52.2086 38.0959L51.3398 44.9154C51.2894 45.3721 51.1256 45.8089 50.8631 46.1861C50.5993 46.5653 50.2443 46.872 49.8308 47.078L44.4492 49.8024C44.4488 49.8026 44.4484 49.8028 44.4479 49.803C44.0209 50.0208 43.5451 50.1253 43.066 50.1067C42.5865 50.088 42.1198 49.9465 41.7107 49.6958C41.3015 49.445 40.9636 49.0934 40.7293 48.6746C40.4951 48.2558 40.3722 47.7838 40.3727 47.304C40.3727 47.2964 40.3727 47.2889 40.3729 47.2814C40.3731 47.2734 40.3734 47.2654 40.3738 47.2574L40.6026 42.4416L29.6792 48.0452C28.6877 48.5705 27.529 48.6838 26.4544 48.3603C25.3772 48.0361 24.4718 47.2994 23.9354 46.3106C23.9313 46.303 23.9273 46.2954 23.9234 46.2877L17.4822 33.646C17.4546 33.5917 17.432 33.5351 17.4146 33.4767C17.2468 32.9117 17.2717 32.3068 17.4854 31.7574C17.6991 31.208 18.0895 30.7453 18.5951 30.4422C18.6109 30.4327 18.627 30.4237 18.6433 30.4151L23.1956 28.0172C23.7087 27.7471 24.2965 27.6522 24.8685 27.7472C25.4406 27.8423 25.9659 28.122 26.3641 28.5435C26.3701 28.5499 26.376 28.5563 26.3819 28.5629L27.2809 29.5662C28.9183 31.3934 31.6682 31.6963 33.664 30.2693L47.123 20.646C48.6098 19.4265 50.3464 18.5484 52.2102 18.0739ZM49.912 55.4848C60.7031 50.5202 72.5711 48.3466 84.4236 49.1642C90.2669 49.5673 96.0139 50.691 101.538 52.4937C102.063 52.665 102.35 53.2295 102.179 53.7545C102.007 54.2796 101.443 54.5663 100.918 54.395C95.5493 52.6432 89.9644 51.5512 84.2859 51.1595C72.7677 50.3649 61.2345 52.4772 50.7479 57.3018C42.9151 60.9054 35.8542 65.9359 29.9144 72.1098C29.5315 72.5078 28.8985 72.52 28.5005 72.1371C28.1025 71.7542 28.0902 71.1212 28.4731 70.7232C34.5856 64.3697 41.8517 59.1932 49.912 55.4848Z"
                fill="#FF7237"
            />
            <defs>
                <clipPath id="clip0_2111_7652">
                    <rect width="96" height="64" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <!-- Edit entity / edit company -->
        <svg
            v-if="icon === 'editEntity' || icon === 'editCompany'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                :class="pathClass"
                d="M17.9941 14.2773C19.0349 13.4287 20.5699 13.4899 21.54 14.46L21.7227 14.6611C22.5147 15.6325 22.5147 17.0345 21.7227 18.0059L21.54 18.207L18.04 21.707C17.8525 21.8945 17.5982 22 17.333 22L15 22C14.4477 22 14 21.5523 14 21V18.667C14 18.4018 14.1055 18.1475 14.293 17.96L17.793 14.46L17.9941 14.2773ZM20.126 15.874C19.9037 15.6519 19.5609 15.6241 19.3086 15.791L19.207 15.874L16 19.0811V20H16.9189L20.126 16.793L20.21 16.6914C20.3527 16.4752 20.3527 16.1918 20.21 15.9756L20.126 15.874ZM10 12C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14L8 14C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12L10 12ZM19 10.75V10C19 9.44771 18.5523 9 18 9H15L15 14C15 14.5523 14.5523 15 14 15C13.4477 15 13 14.5523 13 14L13 6C13 5.44772 12.5523 5 12 5L6 5C5.44772 5 5 5.44772 5 6L5 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H2C1.44772 20 1 19.5523 1 19C1 18.4477 1.44772 18 2 18H3L3 6C3 4.34315 4.34315 3 6 3L12 3C13.6569 3 15 4.34315 15 6V7H18C19.6569 7 21 8.34315 21 10V10.75C21 11.3023 20.5523 11.75 20 11.75C19.4477 11.75 19 11.3023 19 10.75ZM10 8C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H10Z"
                fill="currentColor"
            />
        </svg>
        <!-- Add entity / add company -->
        <svg
            v-if="icon === 'addEntity' || icon === 'addCompany'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M10 12C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14L8 14C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12L10 12ZM19 12.5V10C19 9.44771 18.5523 9 18 9H15L15 15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15L13 6C13 5.44772 12.5523 5 12 5L6 5C5.44772 5 5 5.44772 5 6L5 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H2C1.44772 20 1 19.5523 1 19C1 18.4477 1.44772 18 2 18H3L3 6C3 4.34315 4.34315 3 6 3L12 3C13.6569 3 15 4.34315 15 6V7H18C19.6569 7 21 8.34315 21 10V12.5C21 13.0523 20.5523 13.5 20 13.5C19.4477 13.5 19 13.0523 19 12.5ZM10 8C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H10Z"
                fill="currentColor"
            />
            <path
                d="M17 22V20L15 20C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18H17L17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16L19 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H19V22C19 22.5523 18.5523 23 18 23C17.4477 23 17 22.5523 17 22Z"
                fill="currentColor"
            />
        </svg>
        <!-- Add user icon -->
        <svg
            v-if="icon === 'addUser'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4ZM6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5ZM8 16C6.34315 16 5 17.3431 5 19V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V19C3 16.2386 5.23858 14 8 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H8Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.0001 14C18.5524 14 19.0001 14.4477 19.0001 15V17H21.0001C21.5524 17 22.0001 17.4477 22.0001 18C22.0001 18.5523 21.5524 19 21.0001 19H19.0001V21C19.0001 21.5523 18.5524 22 18.0001 22C17.4478 22 17.0001 21.5523 17.0001 21V19H15.0001C14.4478 19 14.0001 18.5523 14.0001 18C14.0001 17.4477 14.4478 17 15.0001 17H17.0001V15C17.0001 14.4477 17.4478 14 18.0001 14Z"
                fill="currentColor"
            />
        </svg>
        <!-- Add Card Icon -->
        <svg
            v-if="icon === 'addCard'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.33366 5.83398C3.33366 5.37375 3.70675 5.00065 4.16699 5.00065H15.8337C16.294 5.00065 16.667 5.37367 16.667 5.83378V7.50065H3.33366V5.83398ZM3.33366 9.16732H17.5003C17.9606 9.16732 18.3337 8.79422 18.3337 8.33398V5.83378C18.3337 4.45293 17.2142 3.33398 15.8337 3.33398H4.16699C2.78628 3.33398 1.66699 4.45327 1.66699 5.83398V14.1673C1.66699 15.548 2.78628 16.6673 4.16699 16.6673H10.0003C10.4606 16.6673 10.8337 16.2942 10.8337 15.834C10.8337 15.3737 10.4606 15.0007 10.0003 15.0007H4.16699C3.70676 15.0007 3.33366 14.6276 3.33366 14.1673V9.16732ZM5.83366 10.834C5.37342 10.834 5.00033 11.2071 5.00033 11.6673C5.00033 12.1276 5.37342 12.5007 5.83366 12.5007H8.33366C8.7939 12.5007 9.16699 12.1276 9.16699 11.6673C9.16699 11.2071 8.7939 10.834 8.33366 10.834H5.83366Z"
                fill="currentColor"
            />
            <path
                d="M15.8337 17.5007V15.834H14.167C13.7068 15.834 13.3337 15.4609 13.3337 15.0007C13.3337 14.5404 13.7068 14.1673 14.167 14.1673H15.8337V12.5007C15.8337 12.0404 16.2068 11.6673 16.667 11.6673C17.1272 11.6673 17.5003 12.0404 17.5003 12.5007V14.1673H19.167C19.619 14.1888 20.0003 14.5299 20.0003 15.0007C20.0003 15.4714 19.619 15.8125 19.167 15.834H17.5003V17.5007C17.5003 17.9609 17.1272 18.334 16.667 18.334C16.2068 18.334 15.8337 17.9609 15.8337 17.5007Z"
                fill="currentColor"
            />
        </svg>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            v-if="icon === 'webinar'"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H13C14.6569 4 16 5.34315 16 7V8.38197L19.1056 6.82918C20.4354 6.16428 22 7.13127 22 8.61803V15.382C22 16.8687 20.4354 17.8357 19.1056 17.1708L16 15.618V17C16 18.6569 14.6569 20 13 20H5C3.34315 20 2 18.6569 2 17V7ZM16 13.382L20 15.382V8.61803L16 10.618V13.382ZM14 7C14 6.44772 13.5523 6 13 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H13C13.5523 18 14 17.5523 14 17V7Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'settings' || icon === 'gear'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99935 3.33366C9.80942 3.33366 9.63205 3.42858 9.5267 3.58661L9.06447 4.27996L8.41947 3.84996L9.06447 4.27996C8.49804 5.12961 7.4648 5.5399 6.4698 5.31028L5.89959 5.17869C5.69736 5.13203 5.48536 5.19283 5.33861 5.33958L4.74935 4.75033L5.3386 5.33958C5.19185 5.48634 5.13105 5.69834 5.17772 5.90057L5.3093 6.47078C5.53892 7.46578 5.12863 8.49901 4.27898 9.06545L3.58564 9.52768C3.42761 9.63303 3.33268 9.8104 3.33268 10.0003C3.33268 10.1903 3.4276 10.3676 3.58564 10.473L4.27898 10.9352C5.12863 11.5016 5.53892 12.5349 5.3093 13.5299L5.17772 14.1001C5.13105 14.3023 5.19185 14.5143 5.33861 14.6611C5.48536 14.8078 5.69736 14.8686 5.89959 14.822L6.4698 14.6904C7.4648 14.4608 8.49804 14.871 9.06447 15.7207L9.5267 16.414C9.63205 16.5721 9.80942 16.667 9.99935 16.667C10.1893 16.667 10.3666 16.5721 10.472 16.414L10.9342 15.7207C11.5007 14.871 12.5339 14.4608 13.5289 14.6904L14.0991 14.822C14.3013 14.8686 14.5133 14.8078 14.6601 14.6611L15.2493 15.2503L14.6601 14.6611C14.8068 14.5143 14.8676 14.3023 14.821 14.1001L14.6894 13.5299C14.4598 12.5349 14.8701 11.5016 15.7197 10.9352L16.4131 10.473C16.5711 10.3676 16.666 10.1903 16.666 10.0003C16.666 9.81039 16.5711 9.63303 16.4131 9.52768L15.7197 9.06545C14.8701 8.49902 14.4598 7.46578 14.6894 6.47078L14.821 5.90057C14.8676 5.69834 14.8068 5.48634 14.6601 5.33958C14.5133 5.19283 14.3013 5.13203 14.0991 5.17869L13.5289 5.31028C12.5339 5.5399 11.5007 5.12961 10.9342 4.27996L11.6276 3.81771L10.9342 4.27996L10.472 3.58661L11.1654 3.12436L10.472 3.58661C10.3666 3.42858 10.1893 3.33366 9.99935 3.33366ZM8.13995 2.66211C8.55441 2.04042 9.25216 1.66699 9.99935 1.66699C10.7465 1.66699 11.4443 2.04042 11.8587 2.66211L12.321 3.35546C12.5029 3.62828 12.8346 3.76002 13.1541 3.6863L13.7243 3.55471C14.4865 3.37882 15.2855 3.60798 15.8386 4.16107C16.3917 4.71416 16.6209 5.51317 16.445 6.27533L16.3134 6.84555C16.2397 7.16504 16.3714 7.49681 16.6442 7.6787L17.3376 8.14093C17.9593 8.55539 18.3327 9.25314 18.3327 10.0003C18.3327 10.7475 17.9593 11.4453 17.3376 11.8597L16.6442 12.322C16.3714 12.5038 16.2397 12.8356 16.3134 13.1551L16.445 13.7253C16.6209 14.4875 16.3917 15.2865 15.8386 15.8396C15.2855 16.3927 14.4865 16.6218 13.7243 16.4459L13.1541 16.3144C12.8346 16.2406 12.5029 16.3724 12.321 16.6452L11.8588 17.3385C11.4443 17.9602 10.7465 18.3337 9.99935 18.3337C9.25216 18.3337 8.55441 17.9602 8.13995 17.3385L7.67772 16.6452C7.49584 16.3724 7.16406 16.2406 6.84457 16.3144L6.27435 16.4459C5.51219 16.6218 4.71319 16.3927 4.16009 15.8396C3.607 15.2865 3.37785 14.4875 3.55373 13.7253L3.68532 13.1551C3.75905 12.8356 3.6273 12.5038 3.35448 12.322L2.66114 11.8597C2.03944 11.4453 1.66602 10.7475 1.66602 10.0003C1.66602 9.25314 2.03944 8.55539 2.66114 8.14093L3.35448 7.6787C3.6273 7.49681 3.75905 7.16504 3.68532 6.84555L3.55373 6.27533C3.37785 5.51317 3.607 4.71416 4.16009 4.16107C4.71319 3.60798 5.51219 3.37882 6.27436 3.55471L6.84457 3.6863C7.16406 3.76003 7.49584 3.62828 7.67772 3.35546L8.3711 3.81771L7.67772 3.35546L8.13995 2.66211ZM6.66602 10.0003C6.66602 8.15938 8.1584 6.66699 9.99935 6.66699C11.8403 6.66699 13.3327 8.15938 13.3327 10.0003C13.3327 11.8413 11.8403 13.3337 9.99935 13.3337C8.1584 13.3337 6.66602 11.8413 6.66602 10.0003ZM9.99935 8.33366C9.07887 8.33366 8.33268 9.07985 8.33268 10.0003C8.33268 10.9208 9.07887 11.667 9.99935 11.667C10.9198 11.667 11.666 10.9208 11.666 10.0003C11.666 9.07985 10.9198 8.33366 9.99935 8.33366Z"
                fill="currentColor"
            />
            <defs>
                <clipPath id="clip0_2111_7658">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'headphones'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.03348 9.04345C2.87572 9.26198 2 10.2787 2 11.5V15C2 16.3807 3.11929 17.5 4.5 17.5H6C6.55228 17.5 7 17.0523 7 16.5V10C7 9.46556 6.58074 9.02903 6.05318 9.00139C6.44949 6.22822 9.01617 4 12.25 4C15.4838 4 18.0505 6.22822 18.4468 9.00139C17.9193 9.02904 17.5 9.46556 17.5 10V16.5C17.5 17.0523 17.9477 17.5 18.5 17.5H18.6051C18.1748 18.9457 16.8355 20 15.25 20H13.5C13.2239 20 13 19.7761 13 19.5V19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19V19.5C11 20.8807 12.1193 22 13.5 22H15.25C17.9784 22 20.2428 20.0133 20.6755 17.4077C21.728 17.113 22.5 16.1467 22.5 15V11.5C22.5 10.2787 21.6243 9.26198 20.4665 9.04345C20.0849 5.04041 16.4916 2 12.25 2C8.00841 2 4.41506 5.04041 4.03348 9.04345ZM19.5 11V15.5H20C20.2761 15.5 20.5 15.2761 20.5 15V11.5C20.5 11.2239 20.2761 11 20 11H19.5ZM5 11H4.5C4.22386 11 4 11.2239 4 11.5V15C4 15.2761 4.22386 15.5 4.5 15.5H5V11Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'megaphone'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M19.9978 10.9996C19.9977 10.2597 19.5951 9.61496 18.9978 9.26911V12.73C19.5951 12.3841 19.9978 11.7394 19.9978 10.9996ZM7.9978 16.9996C7.9978 18.1041 8.89323 18.9996 9.9978 18.9996C10.7193 18.9996 11.3519 18.6166 11.7039 18.0416L7.9978 16.859V16.9996ZM16.9978 5.73688C16.9975 5.06006 16.339 4.57912 15.6941 4.78473L7.99976 7.23883V14.7603L15.6941 17.2154C16.3391 17.421 16.9978 16.9393 16.9978 16.2623V5.73688ZM3.9978 12.7525C3.9978 13.1877 4.2795 13.5734 4.69409 13.7056L5.99976 14.1216V7.87751L4.69409 8.2945C4.27956 8.42675 3.9979 8.81155 3.9978 9.24665V12.7525ZM18.9978 7.12555C20.723 7.56954 21.9976 9.13586 21.9978 10.9996C21.9978 12.8634 20.723 14.4295 18.9978 14.8736V16.2623C18.9978 18.2937 17.021 19.7381 15.0857 19.1207L13.6365 18.6578C13.0066 20.038 11.6165 20.9996 9.9978 20.9996C7.78866 20.9996 5.9978 19.2087 5.9978 16.9996V16.2203L4.08569 15.6109C2.84205 15.214 1.9978 14.058 1.9978 12.7525V9.24665C1.9979 7.94129 2.84216 6.78614 4.08569 6.38922L6.58081 5.59235C6.65576 5.55767 6.73549 5.53145 6.81909 5.51618L15.0857 2.87946C17.0208 2.26206 18.9975 3.70572 18.9978 5.73688V7.12555Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            v-if="icon === 'microphone'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.99946 7C6.99946 4.23858 9.23803 2 11.9995 2C14.7609 2 16.9995 4.23858 16.9995 7V11C16.9995 13.7614 14.7609 16 11.9995 16C9.23803 16 6.99946 13.7614 6.99946 11V7ZM11.9995 4C10.3426 4 8.99946 5.34315 8.99946 7V11C8.99946 12.6569 10.3426 14 11.9995 14C13.6563 14 14.9995 12.6569 14.9995 11V7C14.9995 5.34315 13.6563 4 11.9995 4ZM4.46942 14.1612C4.93271 13.8605 5.55199 13.9924 5.85264 14.4556C6.89225 16.0576 8.79935 18 11.9995 18C15.1996 18 17.1067 16.0576 18.1463 14.4556C18.4469 13.9924 19.0662 13.8605 19.5295 14.1612C19.9928 14.4618 20.1246 15.0811 19.824 15.5444C18.7003 17.2758 16.553 19.5784 12.9995 19.9488V21C12.9995 21.5523 12.5517 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V19.9488C7.44592 19.5784 5.29857 17.2758 4.17494 15.5444C3.8743 15.0811 4.00614 14.4618 4.46942 14.1612Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'link'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2111_7787)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.49414 5.83366C7.0339 5.83366 6.66081 5.46056 6.66081 5.00033C6.66081 4.54009 7.0339 4.16699 7.49414 4.16699H14.9941C15.4544 4.16699 15.8275 4.54009 15.8275 5.00033V12.5003C15.8275 12.9606 15.4544 13.3337 14.9941 13.3337C14.5339 13.3337 14.1608 12.9606 14.1608 12.5003V7.01217L5.79173 15.3812C5.46629 15.7067 4.93866 15.7067 4.61322 15.3812C4.28778 15.0558 4.28778 14.5282 4.61322 14.2027L12.9823 5.83366H7.49414Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2111_7787">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'suitcase'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2195_12859)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.33366 3.33366C7.87342 3.33366 7.50033 3.70675 7.50033 4.16699V5.00033H12.5003V4.16699C12.5003 3.70675 12.1272 3.33366 11.667 3.33366H8.33366ZM14.167 5.00033V4.16699C14.167 2.78628 13.0477 1.66699 11.667 1.66699H8.33366C6.95295 1.66699 5.83366 2.78628 5.83366 4.16699V5.00033H4.16699C2.78628 5.00033 1.66699 6.11961 1.66699 7.50033V15.0003C1.66699 16.381 2.78628 17.5003 4.16699 17.5003H15.8337C17.2144 17.5003 18.3337 16.381 18.3337 15.0003V7.50033C18.3337 6.11961 17.2144 5.00033 15.8337 5.00033H14.167ZM4.16699 6.66699C3.70675 6.66699 3.33366 7.04009 3.33366 7.50033V15.0003C3.33366 15.4606 3.70676 15.8337 4.16699 15.8337H15.8337C16.2939 15.8337 16.667 15.4606 16.667 15.0003V7.50033C16.667 7.04009 16.2939 6.66699 15.8337 6.66699H4.16699Z"
                    fill="currentColor"
                />
                <path
                    d="M12.9171 14.1669C13.9506 14.1669 14.8083 13.4143 14.9722 12.4273C15.0084 12.2093 14.9126 11.9958 14.7563 11.8395L13.1612 10.2443C13.0049 10.088 12.7914 9.99226 12.5733 10.0285C11.5863 10.1923 10.8338 11.0501 10.8338 12.0836C10.8338 13.2342 11.7665 14.1669 12.9171 14.1669Z"
                    fill="currentColor"
                />
                <path
                    d="M5.17166 10.6694C5.01425 10.237 5.23724 9.75876 5.66972 9.60135L8.15762 8.69583C8.5901 8.53842 9.0683 8.76141 9.22571 9.19389L9.5447 10.0703C9.70211 10.5028 9.47912 10.981 9.04664 11.1384L6.55874 12.0439C6.12626 12.2013 5.64806 11.9783 5.49065 11.5459L5.17166 10.6694Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2195_12859">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <!-- ORANGE MULTIPLE MEMBERS ICON -->
        <svg
            v-if="icon === 'multipleMembers'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <rect
                x="1.66602"
                y="1.66699"
                width="13.3333"
                height="13.3333"
                rx="1.66667"
                fill="#FEAF9F"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 15V16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333H16.6667C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667V6.66667C18.3333 5.74619 17.5871 5 16.6667 5H15H13.3333H6.66667C5.74619 5 5 5.74619 5 6.66667V13.3333V15Z"
                fill="#FD421D"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.6657 12.0837C12.8163 12.0837 13.749 11.1509 13.749 10.0003C13.749 8.84973 12.8163 7.91699 11.6657 7.91699C10.5151 7.91699 9.58235 8.84973 9.58235 10.0003C9.58235 11.1509 10.5151 12.0837 11.6657 12.0837ZM8.12539 16.667C7.8277 16.667 7.62777 16.362 7.76472 16.0977C9.67416 12.4123 13.6572 12.4123 15.5667 16.0977C15.7036 16.362 15.5037 16.667 15.206 16.667H8.12539Z"
                fill="white"
            />
        </svg>

        <!-- COMMUNITY / TWO-PEOPLE ICON -->
        <svg
            v-if="icon === 'community'"
            xmlns="http://www.w3.org/2000/svg"
            :width="width || 24"
            :height="height || 24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 4C6.067 4 4.5 5.567 4.5 7.5C4.5 9.433 6.067 11 8 11C9.933 11 11.5 9.433 11.5 7.5C11.5 5.567 9.933 4 8 4ZM2.5 7.5C2.5 4.46243 4.96243 2 8 2C11.0376 2 13.5 4.46243 13.5 7.5C13.5 10.5376 11.0376 13 8 13C4.96243 13 2.5 10.5376 2.5 7.5ZM16 6C14.8954 6 14 6.89543 14 8C14 9.10457 14.8954 10 16 10C17.1046 10 18 9.10457 18 8C18 6.89543 17.1046 6 16 6ZM12 8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8C20 10.2091 18.2091 12 16 12C13.7909 12 12 10.2091 12 8ZM4 16C2.34315 16 1 17.3431 1 19V20C1 20.5523 0.552285 21 0 21C-0.552285 21 -1 20.5523 -1 20V19C-1 16.2386 1.23858 14 4 14H12C14.7614 14 17 16.2386 17 19V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V19C15 17.3431 13.6569 16 12 16H4ZM19 16C18.4477 16 18 15.5523 18 15C18 14.4477 18.4477 14 19 14H20C22.2091 14 24 15.7909 24 18V20C24 20.5523 23.5523 21 23 21C22.4477 21 22 20.5523 22 20V18C22 16.8954 21.1046 16 20 16H19Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- PEOPLE-ADD / REFERRAL ICON -->
        <svg
            v-if="icon === 'people-add' || icon === 'referral'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9999 4C10.0669 4 8.49988 5.567 8.49988 7.5C8.49988 9.433 10.0669 11 11.9999 11C13.9329 11 15.4999 9.433 15.4999 7.5C15.4999 5.567 13.9329 4 11.9999 4ZM6.49988 7.5C6.49988 4.46243 8.96231 2 11.9999 2C15.0374 2 17.4999 4.46243 17.4999 7.5C17.4999 10.5376 15.0374 13 11.9999 13C8.96231 13 6.49988 10.5376 6.49988 7.5ZM7.99988 16C6.34302 16 4.99988 17.3431 4.99988 19V20C4.99988 20.5523 4.55216 21 3.99988 21C3.44759 21 2.99988 20.5523 2.99988 20V19C2.99988 16.2386 5.23845 14 7.99988 14H12.9999C13.5522 14 13.9999 14.4477 13.9999 15C13.9999 15.5523 13.5522 16 12.9999 16H7.99988Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15C17 14.4477 17.4477 14 18 14Z"
                fill="currentColor"
            />
        </svg>

        <!-- PERSON / USER ICON -->
        <svg
            v-if="icon === 'user' || icon === 'person'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0027 3.33334C8.39185 3.33334 7.08602 4.63917 7.08602 6.25C7.08602 7.86084 8.39185 9.16667 10.0027 9.16667C11.6135 9.16667 12.9194 7.86084 12.9194 6.25C12.9194 4.63917 11.6135 3.33334 10.0027 3.33334ZM5.41935 6.25C5.41935 3.7187 7.47138 1.66667 10.0027 1.66667C12.534 1.66667 14.586 3.7187 14.586 6.25C14.586 8.78131 12.534 10.8333 10.0027 10.8333C7.47138 10.8333 5.41935 8.78131 5.41935 6.25ZM6.66935 13.3333C5.28864 13.3333 4.16935 14.4526 4.16935 15.8333V16.6667C4.16935 17.1269 3.79626 17.5 3.33602 17.5C2.87578 17.5 2.50269 17.1269 2.50269 16.6667V15.8333C2.50269 13.5322 4.36817 11.6667 6.66935 11.6667H13.336C15.6372 11.6667 17.5027 13.5322 17.5027 15.8333V16.6667C17.5027 17.1269 17.1296 17.5 16.6694 17.5C16.2091 17.5 15.836 17.1269 15.836 16.6667V15.8333C15.836 14.4526 14.7167 13.3333 13.336 13.3333H6.66935Z"
                fill="currentColor"
            />
        </svg>

        <!-- SWAP ICON -->
        <svg
            v-if="icon === 'swap'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                d="M5 8H14C16 8 18 10 18 12M5 8L8 5M5 8L8 11M19 16H10C8 16 6 14 6 12M19 16L16 13M19 16L16 19"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'hourglass'"
        >
            <g clip-path="url(#clip0_24_5916)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 3.5C3 2.94772 3.44772 2.5 4 2.5H20C20.5523 2.5 21 2.94772 21 3.5C21 4.05228 20.5523 4.5 20 4.5H19V7.42963C19 8.43269 18.4987 9.36939 17.6641 9.92578L13.8028 12.5L17.6641 15.0742C18.0185 15.3105 18.3129 15.6155 18.5342 15.9649C18.834 16.438 19 16.9932 19 17.5704V20.5H20C20.5523 20.5 21 20.9477 21 21.5C21 22.0523 20.5523 22.5 20 22.5H4C3.44772 22.5 3 22.0523 3 21.5C3 20.9477 3.44772 20.5 4 20.5H5V17.5704C5 16.9933 5.16602 16.438 5.46575 15.9649C5.68709 15.6155 5.98154 15.3105 6.3359 15.0742L10.1972 12.5L6.3359 9.92578C5.5013 9.36939 5 8.43269 5 7.42963V4.5H4C3.44772 4.5 3 4.05228 3 3.5ZM7 4.5V7.42963C7 7.76399 7.1671 8.07622 7.4453 8.26168L12 11.2981L16.5547 8.26168C16.8329 8.07622 17 7.76399 17 7.42963V4.5H7ZM12 13.7018L7.4453 16.7383C7.32707 16.8171 7.22908 16.9186 7.15529 17.0351C7.05521 17.1931 7 17.378 7 17.5704V20.5H17V17.5704C17 17.378 16.9448 17.1931 16.8447 17.0351C16.7709 16.9186 16.6729 16.8171 16.5547 16.7383L12 13.7018Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_24_5916">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>

        <!-- SVG bank-financial -->
        <svg
            v-if="icon === 'bank-financial'"
            :width="width"
            :height="height"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.42703 1.22674C8.08216 0.809837 8.9194 0.809836 9.57453 1.22674L14.2606 4.20877C15.386 4.92492 14.8787 6.66698 13.5447 6.66698H3.45682C2.12289 6.66698 1.6156 4.92492 2.74099 4.20877L7.42703 1.22674ZM8.8587 2.35162C8.64032 2.21265 8.36124 2.21265 8.14287 2.35162L3.45682 5.33365L13.5447 5.33365L8.8587 2.35162ZM4.50078 7.33365C4.86897 7.33365 5.16745 7.63213 5.16745 8.00032V11.3336C5.16745 11.7018 4.86897 12.0003 4.50078 12.0003C4.13259 12.0003 3.83412 11.7018 3.83412 11.3336V8.00032C3.83412 7.63213 4.13259 7.33365 4.50078 7.33365ZM8.50078 7.33365C8.86897 7.33365 9.16745 7.63213 9.16745 8.00032V11.3336C9.16745 11.7018 8.86897 12.0003 8.50078 12.0003C8.13259 12.0003 7.83412 11.7018 7.83412 11.3336V8.00032C7.83412 7.63213 8.1326 7.33365 8.50078 7.33365ZM12.5008 7.33365C12.869 7.33365 13.1674 7.63213 13.1674 8.00032V11.3336C13.1674 11.7018 12.869 12.0003 12.5008 12.0003C12.1326 12.0003 11.8341 11.7018 11.8341 11.3336V8.00032C11.8341 7.63213 12.1326 7.33365 12.5008 7.33365ZM2.75907 13.3337C2.75907 12.9655 3.05754 12.667 3.42573 12.667H13.5758C13.944 12.667 14.2425 12.9655 14.2425 13.3337C14.2425 13.7018 13.944 14.0003 13.5758 14.0003H3.42573C3.05754 14.0003 2.75907 13.7018 2.75907 13.3337Z"
                fill="currentColor"
            />
            <defs>
                <clipPath id="clip0_148_64386">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
        <svg
            v-if="icon === 'bank-error'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M8.71663 12.6666L8.78499 12.6706C9.12092 12.7048 9.38314 12.9884 9.3833 13.3333C9.3833 13.6784 9.12103 13.9625 8.78499 13.9967L8.71663 14H2.92562C2.55745 14 2.25895 13.7015 2.25895 13.3333C2.25912 12.9653 2.55756 12.6667 2.92562 12.6666H8.71663ZM3.33382 11.3333V7.99998C3.33399 7.63202 3.63251 7.33344 4.00049 7.33332C4.36857 7.33332 4.66698 7.63194 4.66715 7.99998V11.3333C4.66715 11.7015 4.36868 12 4.00049 12C3.63241 11.9999 3.33382 11.7014 3.33382 11.3333ZM7.33382 11.3333V7.99998C7.33399 7.63202 7.63251 7.33345 8.00049 7.33332C8.36857 7.33332 8.66698 7.63194 8.66715 7.99998V11.3333C8.66715 11.7015 8.36868 12 8.00049 12C7.63241 11.9999 7.33382 11.7014 7.33382 11.3333ZM11.3338 9.33332V7.99998C11.334 7.63201 11.6325 7.33344 12.0005 7.33332C12.3687 7.33334 12.6672 7.63244 12.6672 8.00063V9.33332C12.6671 9.70151 12.3687 10 12.0005 9.99998C11.6324 9.9999 11.3338 9.70145 11.3338 9.33332ZM7.05192 1.15363C7.68612 0.811623 8.46051 0.835694 9.0747 1.22655L13.7603 4.20897L13.8612 4.27863C14.8535 5.03183 14.337 6.66659 13.0448 6.66665H2.95687C1.62303 6.66665 1.11565 4.92522 2.24072 4.20897L6.92692 1.22655L7.05192 1.15363ZM8.35856 2.35155C8.16743 2.22996 7.92976 2.21469 7.72705 2.30597L7.64306 2.35155L2.95687 5.33332H13.0448L8.35856 2.35155Z"
                fill="currentColor"
            />
            <path
                d="M13.5801 11.4847C13.842 11.2711 14.228 11.2862 14.4721 11.5302C14.7162 11.7743 14.7312 12.1603 14.5176 12.4222L14.4721 12.473L13.6101 13.3349L14.4721 14.1969L14.5176 14.2477C14.7312 14.5095 14.7162 14.8955 14.4721 15.1396C14.228 15.3837 13.842 15.3988 13.5801 15.1852L13.5294 15.1396L12.6674 14.2776L11.8054 15.1396C11.5451 15.4 11.1231 15.4 10.8627 15.1396C10.6024 14.8793 10.6024 14.4573 10.8627 14.1969L11.7247 13.3349L10.8627 12.473L10.8171 12.4222C10.6036 12.1603 10.6186 11.7743 10.8627 11.5302C11.1068 11.2862 11.4928 11.2711 11.7546 11.4847L11.8054 11.5302L12.6674 12.3922L13.5294 11.5302L13.5801 11.4847Z"
                fill="#EF4444"
            />
        </svg>

        <svg
            v-if="icon === 'account-type'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.668 5.8335C16.668 5.37326 16.2949 5.00016 15.8346 5.00016H4.16797C3.70773 5.00016 3.33464 5.37326 3.33464 5.8335V14.1668C3.33464 14.6271 3.70773 15.0002 4.16797 15.0002H15.8346C16.2949 15.0002 16.668 14.6271 16.668 14.1668V5.8335ZM14.168 10.6252C14.6282 10.6252 15.0013 10.9983 15.0013 11.4585C15.0013 11.9187 14.6282 12.2918 14.168 12.2918H12.5013C12.0411 12.2918 11.668 11.9187 11.668 11.4585C11.668 10.9983 12.0411 10.6252 12.5013 10.6252H14.168ZM14.168 7.7085C14.6282 7.7085 15.0013 8.08159 15.0013 8.54183C15.0013 9.00207 14.6282 9.37516 14.168 9.37516H12.5013C12.0411 9.37516 11.668 9.00207 11.668 8.54183C11.668 8.08159 12.0411 7.7085 12.5013 7.7085H14.168ZM18.3346 14.1668C18.3346 15.5475 17.2153 16.6668 15.8346 16.6668H4.16797C2.78726 16.6668 1.66797 15.5475 1.66797 14.1668V5.8335C1.66797 4.45278 2.78726 3.3335 4.16797 3.3335H15.8346C17.2153 3.3335 18.3346 4.45278 18.3346 5.8335V14.1668Z"
                fill="#64748B"
            />
            <path
                d="M7.52893 12.0832C9.34085 12.0832 10.9384 13.0959 11.6012 14.6125L11.6411 14.7134C11.8201 15.2192 11.6921 15.726 11.3977 16.0863C11.0983 16.4528 10.6362 16.6665 10.1494 16.6665H4.90849C4.42167 16.6665 3.95957 16.4527 3.66012 16.0863C3.34621 15.702 3.22139 15.1511 3.45666 14.6125L3.59176 14.3341C4.31999 12.9732 5.83012 12.0832 7.52893 12.0832ZM7.52893 13.7498C6.45847 13.7498 5.57913 14.2787 5.13228 14.9998H9.92558C9.47876 14.2787 8.59939 13.7499 7.52893 13.7498ZM8.36226 9.1665C8.36226 8.70631 7.98911 8.33323 7.52893 8.33317C7.06869 8.33317 6.6956 8.70627 6.6956 9.1665C6.6956 9.62674 7.06869 9.99984 7.52893 9.99984C7.98911 9.99977 8.36226 9.6267 8.36226 9.1665ZM10.0289 9.1665C10.0289 10.5472 8.90959 11.6664 7.52893 11.6665C6.14822 11.6665 5.02893 10.5472 5.02893 9.1665C5.02893 7.78579 6.14822 6.6665 7.52893 6.6665C8.90959 6.66657 10.0289 7.78583 10.0289 9.1665Z"
                fill="#64748B"
            />
        </svg>

        <svg
            v-if="icon === 'company'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_148_64444)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.4987 5C2.4987 3.61929 3.61799 2.5 4.9987 2.5H9.9987C11.3794 2.5 12.4987 3.61929 12.4987 5V5.83333H14.9987C16.3794 5.83333 17.4987 6.95262 17.4987 8.33333V15H18.332C18.7923 15 19.1654 15.3731 19.1654 15.8333C19.1654 16.2936 18.7923 16.6667 18.332 16.6667H1.66536C1.20513 16.6667 0.832031 16.2936 0.832031 15.8333C0.832031 15.3731 1.20513 15 1.66536 15H2.4987V5ZM4.16536 15H10.832V5C10.832 4.53976 10.4589 4.16667 9.9987 4.16667H4.9987C4.53846 4.16667 4.16536 4.53976 4.16536 5V15ZM12.4987 15H15.832V8.33333C15.832 7.8731 15.4589 7.5 14.9987 7.5H12.4987V15ZM5.83203 7.5C5.83203 7.03976 6.20513 6.66667 6.66536 6.66667H8.33203C8.79227 6.66667 9.16536 7.03976 9.16536 7.5C9.16536 7.96024 8.79227 8.33333 8.33203 8.33333H6.66536C6.20513 8.33333 5.83203 7.96024 5.83203 7.5ZM5.83203 10.8333C5.83203 10.3731 6.20513 10 6.66536 10H8.33203C8.79227 10 9.16536 10.3731 9.16536 10.8333C9.16536 11.2936 8.79227 11.6667 8.33203 11.6667H6.66536C6.20513 11.6667 5.83203 11.2936 5.83203 10.8333Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_148_64444">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'card-limit'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_148_64469)">
                <path
                    d="M16.668 5.8335C16.668 5.37339 16.295 5.00016 15.8346 5.00016H4.16797C3.70773 5.00016 3.33464 5.37326 3.33464 5.8335V7.50016H16.668V5.8335ZM18.3346 8.3335C18.3346 8.79373 17.9615 9.16683 17.5013 9.16683H3.33464V14.1668C3.33464 14.6272 3.70782 15.0002 4.16797 15.0002H14.168L14.2534 15.0042C14.6735 15.047 15.0013 15.4021 15.0013 15.8335C15.0013 16.2649 14.6735 16.62 14.2534 16.6628L14.168 16.6668H4.16797C2.78717 16.6668 1.66797 15.5475 1.66797 14.1668V5.8335C1.66797 4.45278 2.78726 3.3335 4.16797 3.3335H15.8346C17.2152 3.3335 18.3346 4.45265 18.3346 5.8335V8.3335Z"
                    fill="#64748B"
                />
                <path
                    d="M17.603 14.402C18.1107 14.4537 18.5072 14.8825 18.5072 15.4038C18.507 15.9598 18.0557 16.4105 17.4997 16.4105C16.9784 16.4103 16.5494 16.0141 16.4979 15.5063L16.493 15.4038L16.4979 15.3005C16.5495 14.7928 16.9785 14.3965 17.4997 14.3963L17.603 14.402ZM16.6663 13.3294V11.2502C16.6663 10.79 17.0396 10.417 17.4997 10.4168C17.9599 10.4168 18.333 10.7899 18.333 11.2502V13.3294C18.333 13.7897 17.9599 14.1628 17.4997 14.1628C17.0396 14.1626 16.6663 13.7896 16.6663 13.3294Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_148_64469">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            xmlns="http://www.w3.org/2000/svg"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            v-if="icon === 'people' || icon === 'users'"
            :class="svgClass"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5007 4.16659C12.5007 3.70635 12.8737 3.33325 13.334 3.33325C15.4051 3.33325 17.084 5.01218 17.084 7.08325C17.084 9.15432 15.4051 10.8333 13.334 10.8333C12.8737 10.8333 12.5007 10.4602 12.5007 9.99992C12.5007 9.53968 12.8737 9.16659 13.334 9.16659C14.4846 9.16659 15.4173 8.23385 15.4173 7.08325C15.4173 5.93266 14.4846 4.99992 13.334 4.99992C12.8737 4.99992 12.5007 4.62682 12.5007 4.16659Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50065 4.99992C6.35006 4.99992 5.41732 5.93266 5.41732 7.08325C5.41732 8.23385 6.35006 9.16659 7.50065 9.16659C8.65124 9.16659 9.58398 8.23385 9.58398 7.08325C9.58398 5.93266 8.65124 4.99992 7.50065 4.99992ZM3.75065 7.08325C3.75065 5.01218 5.42958 3.33325 7.50065 3.33325C9.57172 3.33325 11.2507 5.01218 11.2507 7.08325C11.2507 9.15432 9.57172 10.8333 7.50065 10.8333C5.42958 10.8333 3.75065 9.15432 3.75065 7.08325Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.00065 13.3333C3.61994 13.3333 2.50065 14.4525 2.50065 15.8333V16.6666C2.50065 17.1268 2.12756 17.4999 1.66732 17.4999C1.20708 17.4999 0.833984 17.1268 0.833984 16.6666V15.8333C0.833984 13.5321 2.69946 11.6666 5.00065 11.6666H10.0007C12.3018 11.6666 14.1673 13.5321 14.1673 15.8333V16.6666C14.1673 17.1268 13.7942 17.4999 13.334 17.4999C12.8737 17.4999 12.5007 17.1268 12.5007 16.6666V15.8333C12.5007 14.4525 11.3814 13.3333 10.0007 13.3333H5.00065Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.9193 12.4999C14.9193 12.0397 15.2924 11.6666 15.7526 11.6666H15.8353C18.1365 11.6666 20.002 13.5321 20.002 15.8333V16.6666C20.002 17.1268 19.6289 17.4999 19.1686 17.4999C18.7084 17.4999 18.3353 17.1268 18.3353 16.6666V15.8333C18.3353 14.4525 17.216 13.3333 15.8353 13.3333H15.7526C15.2924 13.3333 14.9193 12.9602 14.9193 12.4999Z"
                fill="currentColor"
            />

            <defs>
                <clipPath id="clip0_1841_63280">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'cards-reverse'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.3346 5.8335C18.3346 4.45278 17.2153 3.3335 15.8346 3.3335L7.5013 3.3335C6.12059 3.3335 5.0013 4.45278 5.0013 5.8335V6.66683H4.16797C2.78726 6.66683 1.66797 7.78612 1.66797 9.16683L1.66797 14.1668C1.66797 15.5475 2.78726 16.6668 4.16797 16.6668H12.5013C13.882 16.6668 15.0013 15.5475 15.0013 14.1668V13.3335H15.8346C17.2153 13.3335 18.3346 12.2142 18.3346 10.8335V5.8335ZM13.3346 13.3335V14.1668C13.3346 14.6271 12.9615 15.0002 12.5013 15.0002L4.16797 15.0002C3.70773 15.0002 3.33464 14.6271 3.33464 14.1668L3.33464 9.16683C3.33464 8.70659 3.70773 8.3335 4.16797 8.3335H5.0013L5.0013 10.8335C5.0013 12.2142 6.12059 13.3335 7.5013 13.3335L13.3346 13.3335ZM6.66797 10.8335C6.66797 11.2937 7.04107 11.6668 7.5013 11.6668L15.8346 11.6668C16.2949 11.6668 16.668 11.2937 16.668 10.8335V5.8335C16.668 5.37326 16.2949 5.00016 15.8346 5.00016L7.5013 5.00016C7.04107 5.00016 6.66797 5.37326 6.66797 5.8335L6.66797 10.8335ZM10.8346 7.50016C10.8346 7.03993 10.4615 6.66683 10.0013 6.66683H9.16797C8.70773 6.66683 8.33464 7.03993 8.33464 7.50016C8.33464 7.9604 8.70773 8.3335 9.16797 8.3335H10.0013C10.4615 8.3335 10.8346 7.9604 10.8346 7.50016Z"
                fill="#64748B"
            />
        </svg>
        <svg
            v-if="icon === 'business' || icon === 'company'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.4987 5C2.4987 3.61929 3.61799 2.5 4.9987 2.5H9.9987C11.3794 2.5 12.4987 3.61929 12.4987 5V5.83333H14.9987C16.3794 5.83333 17.4987 6.95262 17.4987 8.33333V15H18.332C18.7923 15 19.1654 15.3731 19.1654 15.8333C19.1654 16.2936 18.7923 16.6667 18.332 16.6667H1.66536C1.20513 16.6667 0.832031 16.2936 0.832031 15.8333C0.832031 15.3731 1.20513 15 1.66536 15H2.4987V5ZM4.16536 15H10.832V5C10.832 4.53976 10.4589 4.16667 9.9987 4.16667H4.9987C4.53846 4.16667 4.16536 4.53976 4.16536 5V15ZM12.4987 15H15.832V8.33333C15.832 7.8731 15.4589 7.5 14.9987 7.5H12.4987V15ZM5.83203 7.5C5.83203 7.03976 6.20513 6.66667 6.66536 6.66667H8.33203C8.79227 6.66667 9.16536 7.03976 9.16536 7.5C9.16536 7.96024 8.79227 8.33333 8.33203 8.33333H6.66536C6.20513 8.33333 5.83203 7.96024 5.83203 7.5ZM5.83203 10.8333C5.83203 10.3731 6.20513 10 6.66536 10H8.33203C8.79227 10 9.16536 10.3731 9.16536 10.8333C9.16536 11.2936 8.79227 11.6667 8.33203 11.6667H6.66536C6.20513 11.6667 5.83203 11.2936 5.83203 10.8333Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'chevron-left-small'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9107 6.07611C12.2362 6.40155 12.2362 6.92918 11.9107 7.25462L9.16667 9.9987L11.9107 12.7428C12.2362 13.0682 12.2362 13.5959 11.9107 13.9213C11.5853 14.2467 11.0577 14.2467 10.7322 13.9213L7.98816 11.1772C7.33728 10.5263 7.33728 9.47106 7.98816 8.82019L10.7322 6.07611C11.0577 5.75067 11.5853 5.75067 11.9107 6.07611Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'chevron-right-small'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.74408 6.07611C8.06951 5.75067 8.59715 5.75067 8.92259 6.07611L11.6667 8.82019C12.3175 9.47106 12.3175 10.5263 11.6667 11.1772L8.92259 13.9213C8.59715 14.2467 8.06951 14.2467 7.74408 13.9213C7.41864 13.5959 7.41864 13.0682 7.74408 12.7428L10.4882 9.9987L7.74408 7.25462C7.41864 6.92918 7.41864 6.40155 7.74408 6.07611Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'paperclip'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.50033 5.83317C7.50033 3.53198 9.36581 1.6665 11.667 1.6665C13.9682 1.6665 15.8337 3.53198 15.8337 5.83317V12.4998C15.8337 15.7215 13.222 18.3332 10.0003 18.3332C6.77866 18.3332 4.16699 15.7215 4.16699 12.4998V9.1665C4.16699 8.70627 4.54009 8.33317 5.00033 8.33317C5.46056 8.33317 5.83366 8.70627 5.83366 9.1665V12.4998C5.83366 14.801 7.69914 16.6665 10.0003 16.6665C12.3015 16.6665 14.167 14.801 14.167 12.4998V5.83317C14.167 4.45246 13.0477 3.33317 11.667 3.33317C10.2863 3.33317 9.16699 4.45246 9.16699 5.83317V12.4998C9.16699 12.9601 9.54009 13.3332 10.0003 13.3332C10.4606 13.3332 10.8337 12.9601 10.8337 12.4998V5.83317C10.8337 5.37293 11.2068 4.99984 11.667 4.99984C12.1272 4.99984 12.5003 5.37293 12.5003 5.83317V12.4998C12.5003 13.8806 11.381 14.9998 10.0003 14.9998C8.61961 14.9998 7.50033 13.8806 7.50033 12.4998V5.83317Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'travel-goals'"
            :width="width"
            :height="height"
            viewBox="0 0 21 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 0C14.764 0 18.7481 3.33046 19.7549 7.78906C19.8764 8.32771 19.5377 8.86275 18.999 8.98438C18.4604 9.10587 17.9254 8.7681 17.8037 8.22949C17.2683 5.85816 15.6783 3.88733 13.5537 2.83203C14.2344 4.19648 14.7024 5.96541 14.8975 7.91211C14.9525 8.46158 14.5514 8.95168 14.002 9.00684C13.4526 9.06188 12.9625 8.66159 12.9072 8.1123C12.7153 6.19729 12.2432 4.58359 11.6387 3.48242C11.0042 2.32688 10.3888 2 10 2C9.77315 2 9.48195 2.09945 9.13281 2.43164C8.77842 2.76891 8.41294 3.30403 8.08496 4.04199C7.52351 5.30527 7.12806 7.03348 7.02637 9H10C10.5523 9 11 9.44771 11 10C11 10.5523 10.5523 11 10 11H7.02637C7.12806 12.9665 7.52351 14.6947 8.08496 15.958C8.41294 16.696 8.77842 17.2311 9.13281 17.5684C9.48195 17.9005 9.77315 18 10 18C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM15.3086 13.2695C15.3032 13.2648 15.2899 13.2528 15.2686 13.2363C15.2251 13.2029 15.1524 13.1521 15.0547 13.0996C14.8591 12.9946 14.5768 12.8907 14.2227 12.8906C13.9303 12.8906 13.6396 13.0048 13.4189 13.2363C13.2041 13.4619 13 13.8592 13 14.5156C13 15.2969 13.5978 16.1327 14.5059 16.8711C14.9314 17.2171 15.369 17.495 15.7139 17.6836C15.8231 17.7433 15.9202 17.7903 16 17.8281C16.0798 17.7903 16.1769 17.7433 16.2861 17.6836C16.631 17.495 17.0686 17.2171 17.4941 16.8711C18.4022 16.1327 19 15.2969 19 14.5156C19 13.8592 18.7959 13.4619 18.5811 13.2363C18.3604 13.0048 18.0697 12.8906 17.7773 12.8906C17.4232 12.8907 17.1409 12.9946 16.9453 13.0996C16.8476 13.1521 16.7749 13.2029 16.7314 13.2363C16.7101 13.2528 16.6968 13.2648 16.6914 13.2695C16.6887 13.2719 16.6878 13.2721 16.6895 13.2705L16.6904 13.2686L16.626 13.3271C16.2613 13.6204 15.7387 13.6204 15.374 13.3271L15.3086 13.2695ZM2.06445 11C2.40263 13.7111 4.09575 15.9992 6.44629 17.167C6.38161 17.0373 6.31782 16.9055 6.25781 16.7705C5.56803 15.2185 5.1266 13.204 5.02344 11H2.06445ZM6.44629 2.83203C4.09555 3.99972 2.40265 6.28879 2.06445 9H5.02344C5.1266 6.79597 5.56803 4.7815 6.25781 3.22949C6.31794 3.09422 6.38147 2.96197 6.44629 2.83203ZM21 14.5156C21 16.2499 19.7644 17.6017 18.7559 18.4219C18.2232 18.855 17.6814 19.1999 17.2451 19.4385C17.0273 19.5576 16.8259 19.656 16.6562 19.7275C16.5724 19.7629 16.485 19.7966 16.4004 19.8232C16.3487 19.8395 16.1871 19.8906 16 19.8906C15.8129 19.8906 15.6513 19.8395 15.5996 19.8232C15.515 19.7966 15.4276 19.7629 15.3438 19.7275C15.1741 19.656 14.9727 19.5576 14.7549 19.4385C14.3186 19.1999 13.7768 18.855 13.2441 18.4219C12.2356 17.6017 11 16.2499 11 14.5156C11 13.4221 11.3522 12.5068 11.9707 11.8574C12.5833 11.2142 13.4041 10.8906 14.2227 10.8906C14.9786 10.8907 15.5846 11.114 16 11.3369C16.4154 11.114 17.0214 10.8907 17.7773 10.8906C18.5959 10.8906 19.4167 11.2142 20.0293 11.8574C20.6478 12.5068 21 13.4221 21 14.5156ZM16.6943 13.2666L16.6973 13.2637L16.6904 13.2686L16.6943 13.2666Z"
                fill="currentColor"
            />
        </svg>
        <svg
            v-if="icon === 'compass'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.668 9.99935C16.668 6.31745 13.6832 3.33268 10.0013 3.33268C6.3194 3.33268 3.33464 6.31745 3.33464 9.99935C3.33464 13.6812 6.3194 16.666 10.0013 16.666C13.6832 16.666 16.668 13.6812 16.668 9.99935ZM12.1693 6.43571C13.0312 6.32367 13.7685 7.13081 13.5299 8.00553L12.5973 11.4259C12.442 11.9953 11.9972 12.4401 11.4279 12.5954L8.00749 13.528C7.07436 13.7825 6.21817 12.9263 6.47266 11.9932L7.40527 8.57275C7.56056 8.00344 8.0054 7.5586 8.57471 7.40332L11.9951 6.4707L12.1693 6.43571ZM9.01335 9.01139L8.27197 11.7279L10.9893 10.9873L11.7298 8.27002L9.01335 9.01139ZM18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602C14.6037 1.66602 18.3346 5.39698 18.3346 9.99935Z"
                fill="white"
            />
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 23 21"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'flight-departure'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.22961 2.9879C7.14609 2.97454 7.09495 2.98157 7.06322 2.99023L7.04754 2.9945L6.52413 3.11912C6.44722 3.14124 6.42176 3.1642 6.41723 3.1684C6.41347 3.17186 6.39519 3.1887 6.37571 3.24836C6.35397 3.31494 6.35823 3.34539 6.36 3.35542C6.36194 3.36646 6.37009 3.40321 6.42054 3.46942L6.42602 3.47661L10.501 8.92664C10.7 9.19283 10.7538 9.54053 10.6445 9.85441C10.5351 10.1683 10.277 10.4073 9.95562 10.4923L6.45562 11.4173C6.14251 11.5 5.80871 11.426 5.55992 11.2187L3.16386 9.22197C3.14298 9.22153 3.11941 9.22297 3.09239 9.22724L2.54755 9.36938L2.54914 9.37184L4.83094 13.1832C4.95484 13.3857 5.10988 13.5157 5.3155 13.5996C5.51749 13.6821 5.71405 13.6957 5.94013 13.6348L19.9338 9.86154C20.2165 9.78104 20.4048 9.63281 20.5472 9.38693C20.6855 9.14799 20.7152 8.92246 20.6375 8.64621C20.5572 8.36102 20.4087 8.17149 20.1616 8.02839C19.9226 7.89006 19.6971 7.86042 19.4209 7.93811L19.4113 7.9408L15.6665 8.95406C15.0336 9.1253 14.357 8.97551 13.8556 8.55317L7.2707 3.00672L7.26074 2.99787C7.25859 2.99596 7.25733 2.99513 7.25733 2.99513C7.25733 2.99513 7.24847 2.99092 7.22961 2.9879ZM6.55498 1.05587C6.88411 0.969026 7.21842 0.960672 7.5456 1.01302C7.92703 1.07405 8.2803 1.23229 8.57784 1.49279L15.1441 7.02349L18.8846 6.01136C19.6732 5.79093 20.4541 5.88677 21.1636 6.29754C21.8665 6.70443 22.343 7.32324 22.5628 8.10472C22.7851 8.89513 22.6897 9.67793 22.278 10.389C21.8711 11.0918 21.2523 11.5683 20.4709 11.7881L20.4605 11.791L6.46045 15.566C5.81986 15.7384 5.17439 15.7022 4.55971 15.4513C3.94957 15.2023 3.4634 14.7831 3.12091 14.2204L3.11709 14.2141L0.849734 10.4269C0.498805 9.87362 0.442592 9.24093 0.682449 8.6333C0.926513 8.015 1.41174 7.59355 2.05188 7.43175L2.65065 7.27555L2.67899 7.26988C2.95461 7.21476 3.23647 7.20566 3.51857 7.2502C3.87762 7.30689 4.1902 7.46613 4.44804 7.6887L6.4437 9.35175L8.01174 8.93734L4.8266 4.67746C4.36903 4.07448 4.23675 3.35567 4.4745 2.62756C4.71816 1.88135 5.27325 1.38458 6.01513 1.18485L6.02925 1.18104L6.55498 1.05587Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.25021 19.2505C1.25021 18.6982 1.69793 18.2505 2.25021 18.2505H15.7502C16.3025 18.2505 16.7502 18.6982 16.7502 19.2505C16.7502 19.8028 16.3025 20.2505 15.7502 20.2505H2.25021C1.69793 20.2505 1.25021 19.8028 1.25021 19.2505Z"
                fill="currentColor"
            />
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 21 22"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'flight-arrival'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.25 20.25C5.25 19.6977 5.69772 19.25 6.25 19.25H19.75C20.3023 19.25 20.75 19.6977 20.75 20.25C20.75 20.8022 20.3023 21.25 19.75 21.25H6.25C5.69772 21.25 5.25 20.8022 5.25 20.25Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.51176 2.26115C8.50565 2.26229 8.4745 2.26826 8.41451 2.31654C8.35601 2.36362 8.3467 2.38975 8.34655 2.39015C8.34556 2.39257 8.34339 2.39836 8.3419 2.41068C8.34032 2.42362 8.33905 2.44762 8.34341 2.48541L8.34478 2.49725L9.04471 9.27226C9.07877 9.60195 8.94726 9.9271 8.69358 10.1404C8.43989 10.3537 8.097 10.4275 7.77804 10.3373L4.32804 9.36234C4.01284 9.27326 3.76124 9.03546 3.65454 8.72578L2.62954 5.75078C2.62934 5.75018 2.62913 5.74958 2.62893 5.74898C2.6208 5.7448 2.61104 5.7406 2.59912 5.73653L2.05409 5.59435C2.03469 5.5897 2.02281 5.5886 2.0175 5.58835C2.01407 5.59027 2.00822 5.59386 2 5.60003V10.025C2 10.2614 2.06468 10.4474 2.19543 10.619C2.32981 10.7954 2.49942 10.9172 2.73495 10.9914L16.8153 14.9858C17.1982 15.0872 17.4111 15.012 17.6066 14.8302C17.9033 14.5543 18 14.2979 18 14.025C18 13.7964 17.9361 13.6146 17.8012 13.4429C17.6504 13.2509 17.4751 13.1287 17.2584 13.0567L13.4758 11.9791C12.8492 11.8006 12.3488 11.3281 12.1348 10.7127L9.30856 2.58734C9.29319 2.54682 9.27016 2.50941 9.23039 2.46964C9.2056 2.44485 9.19381 2.44167 9.18745 2.43995L9.17526 2.43662L8.65028 2.28655C8.64021 2.28368 8.63019 2.28065 8.62022 2.27745C8.54822 2.25441 8.51775 2.26003 8.51176 2.26115ZM9.21296 0.367288C8.48105 0.13866 7.75851 0.277185 7.16049 0.758519C6.55492 1.24593 6.26862 1.93409 6.35583 2.70801L6.90384 8.01195L5.37513 7.57992L4.52591 5.11512C4.42288 4.78576 4.23724 4.49067 3.96743 4.25684C3.73005 4.05111 3.45727 3.90568 3.16235 3.8172C3.15077 3.81373 3.13912 3.81047 3.12742 3.80741L2.55242 3.65741L2.54254 3.65489C1.92748 3.50112 1.31603 3.61301 0.8 4.00003C0.281527 4.38889 0 4.95194 0 5.60003V10.025C0 10.6886 0.201989 11.3027 0.604568 11.8311C1.0018 12.3524 1.52953 12.7131 2.15591 12.9058L2.17708 12.9121L16.2771 16.9121L16.2909 16.9159C17.2707 17.1788 18.215 16.9955 18.9684 16.2949C19.6217 15.6875 20 14.9189 20 14.025C20 13.3536 19.7889 12.7355 19.3738 12.2072C18.9776 11.703 18.4653 11.343 17.8548 11.1476C17.8446 11.1443 17.8343 11.1412 17.824 11.1383L14.0238 10.0557L11.1945 1.92151L11.1898 1.90829C11.0718 1.58386 10.8867 1.29754 10.6446 1.05542C10.3884 0.799244 10.0775 0.610927 9.71984 0.512114L9.21296 0.367288Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'mail'"
            :width="width"
            :height="height"
            viewBox="0 0 32 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.21658 5.83325H23.786C24.4889 5.83323 25.0952 5.83321 25.5947 5.87401C26.1218 5.91708 26.6461 6.01217 27.1506 6.26923C27.9032 6.65272 28.5152 7.26464 28.8987 8.01729C29.1557 8.5218 29.2508 9.04609 29.2939 9.57322C29.3347 10.0726 29.3347 10.679 29.3346 11.3818V21.618C29.3347 22.3209 29.3347 22.9272 29.2939 23.4266C29.2508 23.9537 29.1557 24.478 28.8987 24.9825C28.5152 25.7352 27.9032 26.3471 27.1506 26.7306C26.6461 26.9877 26.1218 27.0828 25.5947 27.1258C25.0952 27.1666 24.4889 27.1666 23.786 27.1666H8.21661C7.51373 27.1666 6.90737 27.1666 6.40793 27.1258C5.88081 27.0828 5.35652 26.9877 4.85201 26.7306C4.09936 26.3471 3.48744 25.7352 3.10395 24.9825C2.84689 24.478 2.7518 23.9537 2.70873 23.4266C2.66793 22.9272 2.66795 22.3208 2.66797 21.618V11.3819C2.66795 10.679 2.66793 10.0726 2.70873 9.57322C2.7518 9.04609 2.84689 8.5218 3.10395 8.01729C3.48744 7.26464 4.09936 6.65272 4.85201 6.26923C5.35652 6.01217 5.88081 5.91708 6.40793 5.87401C6.90736 5.83321 7.51371 5.83323 8.21658 5.83325ZM6.72921 8.52425L15.157 15.4197C15.6481 15.8216 16.3545 15.8216 16.8456 15.4197L25.2734 8.52425C24.9089 8.50078 24.4347 8.49992 23.7346 8.49992H8.26797C7.56786 8.49992 7.09366 8.50078 6.72921 8.52425ZM26.667 10.8295L18.5343 17.4836C17.0608 18.6892 14.9418 18.6892 13.4684 17.4836L5.3356 10.8295C5.33473 11.0104 5.33464 11.2104 5.33464 11.4333V21.5666C5.33464 22.3353 5.33567 22.8317 5.36654 23.2095C5.39614 23.5717 5.44637 23.706 5.47996 23.7719C5.60779 24.0228 5.81177 24.2268 6.06265 24.3546C6.12858 24.3882 6.26287 24.4384 6.62509 24.468C7.00287 24.4989 7.49923 24.4999 8.26797 24.4999H23.7346C24.5034 24.4999 24.9997 24.4989 25.3775 24.468C25.7397 24.4384 25.874 24.3882 25.94 24.3546C26.1908 24.2268 26.3948 24.0228 26.5226 23.7719C26.5562 23.706 26.6065 23.5717 26.6361 23.2095C26.6669 22.8317 26.668 22.3353 26.668 21.5666V11.4333C26.668 11.2104 26.6679 11.0104 26.667 10.8295Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'email-forward'"
        >
            <path
                d="M16.6665 9.16732V6.83415C16.6665 6.6948 16.6654 6.5696 16.6649 6.45655L11.5827 10.6151C10.6618 11.3686 9.33791 11.3686 8.417 10.6151L3.33399 6.45655C3.33344 6.5696 3.33317 6.6948 3.33317 6.83415V13.1672C3.33317 13.6476 3.33423 13.9581 3.35352 14.1942C3.37202 14.4205 3.40333 14.5045 3.42432 14.5457C3.50419 14.7024 3.63145 14.8296 3.78809 14.9095C3.82929 14.9305 3.91333 14.9618 4.13965 14.9803C4.37577 14.9996 4.68621 15.0007 5.16667 15.0007H6.24984C6.71008 15.0007 7.08317 15.3738 7.08317 15.834C7.08317 16.2942 6.71008 16.6673 6.24984 16.6673H5.16667C4.71371 16.6673 4.32347 16.6682 4.00375 16.6421C3.67437 16.6152 3.3465 16.5553 3.03125 16.3947C2.56107 16.1551 2.17878 15.7728 1.93913 15.3026C1.7785 14.9873 1.71866 14.6595 1.69174 14.3301C1.66561 14.0104 1.66651 13.6201 1.66651 13.1672V6.83415C1.66651 6.38119 1.66561 5.99095 1.69174 5.67123C1.71866 5.34185 1.7785 5.01398 1.93913 4.69873C2.17878 4.22855 2.56107 3.84626 3.03125 3.60661C3.3465 3.44599 3.67437 3.38614 4.00375 3.35922C4.32347 3.33309 4.71371 3.33399 5.16667 3.33399H14.833C15.286 3.33399 15.6762 3.33309 15.9959 3.35922C16.3253 3.38614 16.6532 3.44599 16.9684 3.60661C17.4386 3.84626 17.8209 4.22855 18.0605 4.69873C18.2212 5.01398 18.281 5.34185 18.3079 5.67123C18.3341 5.99095 18.3332 6.38119 18.3332 6.83415V9.16732C18.3332 9.62756 17.9601 10.0007 17.4998 10.0007C17.0396 10.0007 16.6665 9.62756 16.6665 9.16732ZM5.16667 5.00065C4.72956 5.00065 4.43326 5.00231 4.20557 5.01693L9.4725 9.3252C9.77945 9.5763 10.2202 9.5763 10.5272 9.3252L15.7933 5.01693C15.5657 5.00236 15.2696 5.00065 14.833 5.00065H5.16667Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M16.4224 18.0898C16.0969 18.4153 15.5694 18.4153 15.244 18.0898C14.9185 17.7644 14.9185 17.2369 15.244 16.9115L16.3215 15.834H12.4998C12.0396 15.834 11.6665 16.2071 11.6665 16.6673V17.5007C11.6665 17.9609 11.2934 18.334 10.8332 18.334C10.3729 18.334 9.99984 17.9609 9.99984 17.5007V16.6673C9.99984 15.2866 11.1191 14.1673 12.4998 14.1673H16.3215L15.244 13.0898C14.9185 12.7644 14.9185 12.2369 15.244 11.9115C15.5694 11.586 16.0969 11.586 16.4224 11.9115L18.9224 14.4115C19.2478 14.7369 19.2478 15.2644 18.9224 15.5898L16.4224 18.0898Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            v-if="icon === 'calendar-check'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_161_4352)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H18C19.6569 4 21 5.34315 21 7V12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12V10H5V18C5 18.5523 5.44772 19 6 19H11C11.5523 19 12 19.4477 12 20C12 20.5523 11.5523 21 11 21H6C4.34315 21 3 19.6569 3 18V7C3 5.34315 4.34315 4 6 4H7V3C7 2.44772 7.44772 2 8 2ZM6 6C5.44772 6 5 6.44772 5 7V8H19V7C19 6.44772 18.5523 6 18 6H6ZM21.6247 15.2191C22.056 15.5641 22.1259 16.1934 21.7809 16.6247L17.7809 21.6247C17.6032 21.8468 17.3393 21.9827 17.0553 21.9985C16.7713 22.0142 16.494 21.9082 16.2929 21.7071L14.2929 19.7071C13.9024 19.3166 13.9024 18.6834 14.2929 18.2929C14.6834 17.9024 15.3166 17.9024 15.7071 18.2929L16.9171 19.5029L20.2191 15.3753C20.5641 14.944 21.1934 14.8741 21.6247 15.2191Z"
                    fill="currentColor"
                />
            </g>
        </svg>

        <svg
            width="17"
            height="15"
            viewBox="0 0 17 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'check-lg'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.3254 0.160836C16.6969 0.432589 16.7777 0.954001 16.5059 1.32544L6.75102 14.6588C6.61713 14.8418 6.41445 14.9623 6.18974 14.9926C5.96502 15.0229 5.73766 14.9603 5.56012 14.8192L0.315021 10.6526C-0.0453478 10.3663 -0.105413 9.84208 0.180861 9.48171C0.467135 9.12134 0.991342 9.06128 1.35171 9.34755L5.91788 12.9749L15.1608 0.341338C15.4326 -0.0301035 15.954 -0.110917 16.3254 0.160836Z"
                fill="currentColor"
            />
        </svg>

        <!-- SPLIT ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'split'"
        >
            <path
                d="M16 3H21V8M21 3L14 10M8 21H3V16M3 21L10 14"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>

        <!-- ATTACHMENT / PAPERCLIP ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'attachment'"
        >
            <path
                d="M21.44 11.05L12.25 20.24C11.1242 21.3658 9.59723 21.9983 8.005 21.9983C6.41277 21.9983 4.88584 21.3658 3.76 20.24C2.63416 19.1142 2.00166 17.5872 2.00166 15.995C2.00166 14.4028 2.63416 12.8758 3.76 11.75L12.33 3.18C13.0806 2.42975 14.0991 2.00129 15.16 2.00129C16.2209 2.00129 17.2394 2.42975 17.99 3.18C18.7403 3.93063 19.1687 4.94913 19.1687 6.01C19.1687 7.07087 18.7403 8.08937 17.99 8.84L9.41 17.41C9.03472 17.7853 8.52573 17.9961 7.995 17.9961C7.46427 17.9961 6.95528 17.7853 6.58 17.41C6.20472 17.0347 5.99389 16.5257 5.99389 15.995C5.99389 15.4643 6.20472 14.9553 6.58 14.58L15.07 6.1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>

        <!-- DOCUMENT ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'document'"
        >
            <path
                d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
            <path
                d="M14 2V8H20M16 13H8M16 17H8M10 9H8"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="pathClass"
            />
        </svg>

        <!-- SPENDING / RECEIPT ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'spending'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4 4C4 2.89543 4.89543 2 6 2H18C19.1046 2 20 2.89543 20 4V21C20 21.3746 19.7907 21.7178 19.4576 21.8892C19.1245 22.0606 18.7236 22.0315 18.4188 21.8137L16.5 20.4427L14.5812 21.8137C14.2335 22.0621 13.7665 22.0621 13.4188 21.8137L11.5 20.4427L9.58124 21.8137C9.23349 22.0621 8.76651 22.0621 8.41876 21.8137L6.5 20.4427L4.58124 21.8137C4.27642 22.0315 3.87549 22.0606 3.54242 21.8892C3.20935 21.7178 3 21.3746 3 21V4C3 2.89543 3.89543 2 5 2H6ZM6 4H18V19.1315L16.5812 18.1863C16.2335 17.9379 15.7665 17.9379 15.4188 18.1863L13.5 19.5573L11.5812 18.1863C11.2335 17.9379 10.7665 17.9379 10.4188 18.1863L8.5 19.5573L6.58124 18.1863C6.23349 17.9379 5.76651 17.9379 5.41876 18.1863L5 18.4852V4H6ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9H16C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7H8ZM7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'card-open'"
        >
            <path
                d="M16.6667 5.83337C16.6667 5.37327 16.2938 5.00004 15.8334 5.00004H4.16675C3.70651 5.00004 3.33341 5.37314 3.33341 5.83337V7.50004H16.6667V5.83337ZM3.33341 9.16671V14.1667C3.33341 14.627 3.7066 15 4.16675 15H15.8334C16.2938 15 16.6667 14.627 16.6667 14.1667V9.16671H3.33341ZM18.3334 5.83337C18.3334 4.45266 17.214 3.33337 15.8334 3.33337H4.16675C2.78595 3.33337 1.66675 4.45253 1.66675 5.83337V14.1667C1.66675 15.5473 2.78604 16.6667 4.16675 16.6667H15.8334C17.214 16.6667 18.3334 15.5475 18.3334 14.1667V5.83337Z"
                fill="#475569"
            />
        </svg>

        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'card-closed'"
        >
            <path
                d="M16.6667 5.83337C16.6667 5.37327 16.2938 5.00004 15.8334 5.00004H4.16675C3.70651 5.00004 3.33341 5.37314 3.33341 5.83337V7.50004H16.6667V5.83337ZM18.3334 8.33337C18.3334 8.79361 17.9603 9.16671 17.5001 9.16671H3.33341V14.1667C3.33341 14.627 3.7066 15 4.16675 15H10.0001C10.4603 15 10.8334 15.3731 10.8334 15.8334C10.8334 16.2936 10.4603 16.6667 10.0001 16.6667H4.16675C2.78595 16.6667 1.66675 15.5473 1.66675 14.1667V5.83337C1.66675 4.45266 2.78604 3.33337 4.16675 3.33337H15.8334C17.214 3.33337 18.3334 4.45253 18.3334 5.83337V8.33337Z"
                fill="#475569"
            />
            <path
                d="M17.3276 12.3275C17.653 12.0021 18.1805 12.0021 18.5059 12.3275C18.8314 12.6529 18.8314 13.1805 18.5059 13.5059L17.0118 15L18.5059 16.4942C18.8314 16.8196 18.8314 17.3471 18.5059 17.6726C18.1805 17.998 17.653 17.998 17.3276 17.6726L15.8334 16.1784L14.3393 17.6726C14.0138 17.998 13.4863 17.998 13.1609 17.6726C12.8354 17.3471 12.8354 16.8196 13.1609 16.4942L14.655 15L13.1609 13.5059C12.8354 13.1805 12.8354 12.6529 13.1609 12.3275C13.4863 12.0021 14.0138 12.0021 14.3393 12.3275L15.8334 13.8216L17.3276 12.3275Z"
                fill="#475569"
            />
        </svg>

        <svg
            v-if="icon === 'security'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2060_132)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.1873 1.89848C9.71398 1.71743 10.286 1.71743 10.8127 1.89848L15.8127 3.61723C16.8222 3.96425 17.5 4.91396 17.5 5.98145V9.92726C17.5 12.2662 16.5426 13.9518 15.1563 15.2643C13.8459 16.5048 12.1293 17.4305 10.5266 18.2947C10.4828 18.3183 10.4392 18.3418 10.3957 18.3653C10.1487 18.4985 9.85129 18.4985 9.60434 18.3653C9.5608 18.3418 9.51716 18.3183 9.47344 18.2947C7.8707 17.4305 6.15411 16.5048 4.84375 15.2643C3.45742 13.9518 2.5 12.2662 2.5 9.92726V5.98145C2.5 4.91396 3.1778 3.96425 4.1873 3.61723L9.1873 1.89848ZM10.2709 3.47462C10.0953 3.41427 9.90466 3.41428 9.7291 3.47462L4.7291 5.19337C4.3926 5.30905 4.16667 5.62562 4.16667 5.98145V9.92726C4.16667 11.732 4.87591 12.9996 5.98958 14.054C7.05303 15.0608 8.46016 15.8518 10 16.6849C11.5398 15.8518 12.947 15.0608 14.0104 14.054C15.1241 12.9996 15.8333 11.732 15.8333 9.92726V5.98145C15.8333 5.62562 15.6074 5.30905 15.2709 5.19337L10.2709 3.47462ZM12.6726 7.53605C12.998 7.86149 12.998 8.38913 12.6726 8.71456L9.75593 11.6312C9.43049 11.9567 8.90285 11.9567 8.57741 11.6312L7.32741 10.3812C7.00197 10.0558 7.00197 9.52816 7.32741 9.20272C7.65285 8.87728 8.18049 8.87728 8.50592 9.20272L9.16667 9.86347L11.4941 7.53605C11.8195 7.21062 12.3472 7.21062 12.6726 7.53605Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2060_132">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <svg
            v-if="icon === 'basket'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.1285 3.07123C15.6412 2.86616 16.2232 3.11608 16.4283 3.62884L18.1763 7.99994H19.9996C20.1607 7.99994 20.313 8.03866 20.4478 8.10638C21.3541 8.415 21.9515 9.35336 21.7691 10.3574L20.2828 18.537C20.0233 19.9633 18.7803 20.9999 17.3306 20.9999H6.66947C5.21976 20.9999 3.97685 19.9633 3.71732 18.537L2.23002 10.3574C2.04772 9.35362 2.64532 8.41519 3.55131 8.10638C3.68617 8.03855 3.83831 7.99999 3.99955 7.99994H5.82377L7.57182 3.62884C7.77693 3.11606 8.35884 2.86611 8.87162 3.07123C9.38417 3.27639 9.63318 3.85838 9.42826 4.37103L7.97709 7.99994H16.023L14.5718 4.37103C14.3668 3.85827 14.6157 3.27632 15.1285 3.07123ZM5.6851 18.1786C5.77155 18.6541 6.18619 18.9999 6.66947 18.9999H17.3306C17.8139 18.9999 18.2285 18.6541 18.315 18.1786L19.8013 9.99994H4.19779L5.6851 18.1786Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'dining'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C10.2761 4 8.62279 4.68482 7.40381 5.90381C6.42307 6.88454 5.7881 8.14641 5.57736 9.5H7.62438C8.11581 7.90298 9.06939 6.47974 10.3732 5.41538C11.0932 4.82769 11.8989 4.36653 12.7561 4.04411C12.5064 4.01486 12.254 4 12 4ZM17.1452 3.73407C15.6742 2.61544 13.8688 2 12 2C9.74566 2 7.58365 2.89553 5.98959 4.48959C4.63306 5.84613 3.78239 7.61397 3.559 9.5H3C2.44784 9.5 2.00017 9.94752 2 10.4997C1.9994 12.4149 2.5488 14.2901 3.58289 15.9021C4.49941 17.3309 5.76248 18.4998 7.25 19.3027V19.5C7.25 19.9641 7.43437 20.4092 7.76256 20.7374C8.09075 21.0656 8.53587 21.25 9 21.25H15C15.4641 21.25 15.9092 21.0656 16.2374 20.7374C16.5656 20.4092 16.75 19.9641 16.75 19.5V19.3027C18.2375 18.4998 19.5006 17.3309 20.4171 15.9021C21.4512 14.2901 22.0006 12.4149 22 10.4997C21.9998 9.94752 21.5522 9.5 21 9.5H20.441C20.2176 7.61397 19.3669 5.84613 18.0104 4.48959C17.749 4.2282 17.4724 3.98559 17.1825 3.76264C17.1703 3.75283 17.1579 3.74331 17.1452 3.73407ZM15.7494 5.5C14.2511 5.49977 12.7987 6.01719 11.638 6.9647C10.8041 7.64544 10.1575 8.51814 9.74842 9.5H11.9986C12.5425 8.48138 13.2892 7.58191 14.195 6.85834C14.8358 6.34648 15.5449 5.93178 16.2992 5.62484C16.2564 5.58712 16.2132 5.55001 16.1695 5.5135C16.0298 5.50459 15.8895 5.50008 15.7494 5.5ZM17.6409 7.27032C16.8433 7.50895 16.0969 7.89891 15.4432 8.42102C15.0451 8.73901 14.6872 9.10142 14.3758 9.5H18.4226C18.3002 8.71341 18.0345 7.95779 17.6409 7.27032ZM12.6479 11.5C12.6319 11.5004 12.6159 11.5004 12.5999 11.5H8.42079C8.40764 11.5003 8.39445 11.5003 8.38122 11.5H4.06238C4.21052 12.6792 4.62013 13.8149 5.26631 14.8223C6.09359 16.1119 7.27381 17.1369 8.66667 17.7753C9.02211 17.9382 9.25 18.2934 9.25 18.6844V19.25H14.75V18.6844C14.75 18.2934 14.9779 17.9382 15.3333 17.7753C16.7262 17.1369 17.9064 16.1119 18.7337 14.8223C19.3799 13.8149 19.7895 12.6792 19.9376 11.5H12.6479Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'tag'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 4C4.44772 4 4 4.44772 4 5V11.1716C4 11.4368 4.10536 11.6911 4.29289 11.8787L12.0429 19.6287C12.4334 20.0192 13.0666 20.0192 13.4571 19.6287L19.6287 13.4571C20.0192 13.0666 20.0192 12.4334 19.6287 12.0429L11.8787 4.29289C11.6911 4.10536 11.4368 4 11.1716 4H5ZM2 5C2 3.34315 3.34315 2 5 2H11.1716C11.9672 2 12.7303 2.31607 13.2929 2.87868L21.0429 10.6287C22.2145 11.8003 22.2145 13.6997 21.0429 14.8713L14.8713 21.0429C13.6997 22.2145 11.8003 22.2145 10.6287 21.0429L2.87868 13.2929C2.31607 12.7303 2 11.9672 2 11.1716V5ZM6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'gym'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.04148 6.5C4.27952 5.08114 5.5135 4 7 4C8.65685 4 10 5.34315 10 7V11H14V7C14 5.34315 15.3431 4 17 4C18.4865 4 19.7205 5.08114 19.9585 6.5H20C21.6569 6.5 23 7.84315 23 9.5V11C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13V14.5C23 16.1569 21.6569 17.5 20 17.5H19.9585C19.7205 18.9189 18.4865 20 17 20C15.3431 20 14 18.6569 14 17V13H10V17C10 18.6569 8.65685 20 7 20C5.5135 20 4.27952 18.9189 4.04148 17.5H4C2.34315 17.5 1 16.1569 1 14.5V13C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11V9.5C1 7.84315 2.34315 6.5 4 6.5H4.04148ZM4 15.5V8.5C3.44772 8.5 3 8.94772 3 9.5V14.5C3 15.0523 3.44772 15.5 4 15.5ZM8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17V7ZM16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6C16.4477 6 16 6.44772 16 7V17ZM20 15.5C20.5523 15.5 21 15.0523 21 14.5V9.5C21 8.94772 20.5523 8.5 20 8.5V15.5Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'film'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5C5.44772 5 5 5.44772 5 6V7H7V5H6ZM9 5V11H15V5H9ZM17 5V7H19V6C19 5.44772 18.5523 5 18 5H17ZM19 9H17V11H19V9ZM19 13H17V15.4444H19V13ZM19 17.4444H17V19H18C18.5523 19 19 18.5523 19 18V17.4444ZM15 19V13H9V19H15ZM7 19V17H5V18C5 18.5523 5.44772 19 6 19H7ZM5 15H7V13H5V15ZM5 11H7V9H5V11Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'gas'"
            :width="width"
            :height="height"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13 6C13 5.44772 12.5523 5 12 5H6C5.44772 5 5 5.44772 5 6V19H13V6ZM11 9C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H7C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9H11ZM15 9H16C17.6569 9 19 10.3431 19 12V15.5C19 15.7761 19.2239 16 19.5 16C19.7761 16 20 15.7761 20 15.5V8.82812C19.9999 8.56302 19.8945 8.30856 19.707 8.12109L18.293 6.70703C17.9024 6.31651 17.9024 5.68349 18.293 5.29297C18.6835 4.90244 19.3165 4.90244 19.707 5.29297L21.1211 6.70703C21.6836 7.26957 21.9999 8.03258 22 8.82812V15.5C22 16.8807 20.8807 18 19.5 18C18.1193 18 17 16.8807 17 15.5V12C17 11.4477 16.5523 11 16 11H15V19C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H3C2.44772 21 2 20.5523 2 20C2 19.4477 2.44772 19 3 19V6C3 4.34315 4.34315 3 6 3H12C13.6569 3 15 4.34315 15 6V9Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="icon === 'footnote'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2283_22406)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.49902 5C2.49902 3.61929 3.61831 2.5 4.99902 2.5H14.999C16.3797 2.5 17.499 3.61929 17.499 5V15C17.499 16.3807 16.3797 17.5 14.999 17.5H4.99902C3.61831 17.5 2.49902 16.3807 2.49902 15V5ZM4.99902 4.16667C4.53879 4.16667 4.16569 4.53976 4.16569 5V5.83333H15.8324V5C15.8324 4.53976 15.4593 4.16667 14.999 4.16667H4.99902ZM15.8324 7.5H4.16569V15C4.16569 15.4602 4.53879 15.8333 4.99902 15.8333H14.999C15.4593 15.8333 15.8324 15.4602 15.8324 15V7.5ZM5.77075 9.46667C5.81842 9.38651 5.87724 9.31216 5.94651 9.24618C6.00133 9.19383 6.06119 9.1482 6.1248 9.10963C6.20994 9.0578 6.3031 9.01784 6.40198 8.99204C6.49123 8.96863 6.58212 8.95756 6.67232 8.95822C6.76142 8.9587 6.85107 8.97063 6.93905 8.99461C7.02392 9.01763 7.10449 9.05111 7.17929 9.09358C7.25708 9.13755 7.32971 9.19183 7.39493 9.2558C7.46995 9.3292 7.5323 9.41256 7.58108 9.50248C7.61621 9.56699 7.64473 9.63562 7.66571 9.70747C7.69233 9.79819 7.70602 9.89087 7.70744 9.98306C7.70938 10.0952 7.69321 10.2085 7.65775 10.3186C7.63646 10.385 7.60868 10.4484 7.57517 10.5083C7.53292 10.5841 7.48093 10.655 7.41976 10.7191C7.34514 10.7975 7.25981 10.8625 7.16747 10.9131C7.09667 10.9521 7.02085 10.9831 6.94122 11.0049C6.85266 11.0292 6.76238 11.0413 6.67266 11.0419C6.58148 11.0425 6.4896 11.0313 6.39942 11.0074C6.30634 10.9828 6.21835 10.9457 6.13739 10.898C6.05898 10.8519 5.98606 10.7953 5.92098 10.7287C5.86536 10.6719 5.81708 10.6095 5.77655 10.543C5.72107 10.4523 5.67907 10.3525 5.65333 10.2464C5.63208 10.1592 5.62251 10.0707 5.62404 9.9829C5.62509 9.91534 5.63273 9.84752 5.64722 9.7804C5.67134 9.66803 5.71359 9.56238 5.77075 9.46667ZM9.10411 9.46662C9.15178 9.38648 9.21059 9.31214 9.27985 9.24617C9.33463 9.19386 9.39444 9.14826 9.45799 9.10972C9.5432 9.05782 9.63645 9.01782 9.73543 8.99201C9.82465 8.96862 9.91549 8.95757 10.0057 8.95822C10.0948 8.9587 10.1845 8.97064 10.2725 8.99463C10.3573 9.01764 10.4378 9.05111 10.5126 9.09356C10.5904 9.13753 10.663 9.1918 10.7282 9.25577C10.8033 9.32919 10.8657 9.41258 10.9144 9.50253C10.9496 9.56703 10.9781 9.63564 10.999 9.70747C11.0257 9.79817 11.0394 9.89084 11.0408 9.983C11.0427 10.0952 11.0265 10.2085 10.9911 10.3186C10.9698 10.385 10.942 10.4484 10.9086 10.5082C10.8663 10.584 10.8143 10.655 10.7531 10.7191C10.6784 10.7975 10.5931 10.8625 10.5008 10.9131C10.43 10.9521 10.3542 10.9831 10.2746 11.0048C10.186 11.0292 10.0957 11.0413 10.006 11.0419C9.91484 11.0425 9.823 11.0313 9.73284 11.0074C9.63968 10.9828 9.55162 10.9457 9.47059 10.8979C9.39225 10.8519 9.31938 10.7953 9.25434 10.7287C9.19871 10.6719 9.15043 10.6095 9.10989 10.543C9.0544 10.4523 9.01239 10.3525 8.98665 10.2463C8.96542 10.1592 8.95585 10.0707 8.95738 9.9829C8.95843 9.91534 8.96607 9.84752 8.98056 9.7804C9.00468 9.66801 9.04693 9.56234 9.10411 9.46662ZM12.4375 9.46651C12.4851 9.38645 12.5439 9.31218 12.6131 9.24627C12.6679 9.19389 12.7278 9.14823 12.7914 9.10965C12.8766 9.05779 12.9698 9.01782 13.0687 8.99202C13.158 8.96862 13.2488 8.95756 13.339 8.95822C13.4281 8.9587 13.5178 8.97063 13.6057 8.99461C13.6906 9.01763 13.7711 9.0511 13.8459 9.09356C13.9237 9.13753 13.9963 9.1918 14.0616 9.25577C14.1366 9.32919 14.199 9.41258 14.2478 9.50253C14.2829 9.56703 14.3114 9.63564 14.3324 9.70747C14.359 9.79817 14.3727 9.89084 14.3741 9.983C14.376 10.0952 14.3599 10.2085 14.3244 10.3186C14.3031 10.385 14.2754 10.4484 14.2419 10.5082C14.1996 10.584 14.1476 10.655 14.0864 10.7191C14.0118 10.7975 13.9265 10.8625 13.8341 10.9131C13.7634 10.952 13.6877 10.983 13.6083 11.0048C13.5195 11.0292 13.4291 11.0414 13.3392 11.0419C13.2481 11.0425 13.1563 11.0313 13.0662 11.0074C12.973 10.9828 12.885 10.9457 12.804 10.8979C12.7256 10.8519 12.6527 10.7953 12.5876 10.7286C12.532 10.6719 12.4838 10.6096 12.4433 10.5432C12.3878 10.4524 12.3457 10.3525 12.32 10.2462C12.2987 10.1591 12.2892 10.0707 12.2907 9.9829C12.2918 9.91535 12.2994 9.84752 12.3139 9.7804C12.338 9.66796 12.3803 9.56226 12.4375 9.46651ZM7.28592 13.411C7.28437 13.4233 7.28247 13.4355 7.28021 13.4476L7.0824 13.3334M5.77071 12.8001C5.81837 12.7199 5.87717 12.6456 5.94641 12.5796C6.00129 12.5272 6.06122 12.4815 6.1249 12.4429C6.21001 12.3911 6.30312 12.3512 6.40195 12.3254C6.49124 12.302 6.58218 12.2909 6.67243 12.2916C6.76139 12.292 6.85091 12.3039 6.93876 12.3279C7.02385 12.3509 7.10462 12.3845 7.17958 12.4271C7.25719 12.471 7.32966 12.5251 7.39476 12.589C7.46984 12.6624 7.53224 12.7458 7.58104 12.8357C7.6162 12.9003 7.64474 12.969 7.66573 13.0409C7.69234 13.1316 7.70603 13.2243 7.70744 13.3164C7.70937 13.4286 7.69321 13.5419 7.65775 13.6519C7.63646 13.7183 7.60868 13.7818 7.57518 13.8416C7.53293 13.9174 7.48094 13.9883 7.41979 14.0524C7.34516 14.1308 7.25982 14.1958 7.16747 14.2464C7.09667 14.2854 7.02085 14.3164 6.94122 14.3382C6.85266 14.3626 6.76238 14.3747 6.67266 14.3752C6.58148 14.3759 6.4896 14.3646 6.39942 14.3407C6.30634 14.3162 6.21835 14.2791 6.13739 14.2313C6.05902 14.1853 5.98612 14.1287 5.92105 14.0621C5.86539 14.0053 5.81707 13.9428 5.77651 13.8763C5.72104 13.7856 5.67904 13.6858 5.65331 13.5796C5.63208 13.4925 5.62251 13.404 5.62404 13.3162C5.62509 13.2487 5.63273 13.1809 5.64722 13.1137C5.67134 13.0014 5.71357 12.8958 5.77071 12.8001ZM10.6192 13.4112C10.6177 13.4234 10.6158 13.4355 10.6135 13.4476L10.4157 13.3334M9.10405 12.8001C9.15171 12.7199 9.21052 12.6456 9.27978 12.5796C9.33461 12.5272 9.39449 12.4816 9.45811 12.443C9.54327 12.3911 9.63646 12.3512 9.73537 12.3254C9.82464 12.3019 9.91555 12.2909 10.0058 12.2916C10.0948 12.292 10.1843 12.304 10.2722 12.3279C10.3572 12.3509 10.4379 12.3845 10.5129 12.427C10.5905 12.471 10.663 12.5251 10.7281 12.589C10.8032 12.6624 10.8656 12.7458 10.9144 12.8358C10.9495 12.9003 10.9781 12.9689 10.999 13.0408C11.0257 13.1315 11.0394 13.2242 11.0408 13.3164C11.0427 13.4286 11.0265 13.5419 10.9911 13.652C10.9698 13.7183 10.942 13.7817 10.9085 13.8415C10.8663 13.9173 10.8143 13.9883 10.7531 14.0524C10.6785 14.1308 10.5932 14.1958 10.5008 14.2464C10.43 14.2854 10.3542 14.3164 10.2746 14.3382C10.186 14.3625 10.0957 14.3747 10.006 14.3752C9.91484 14.3759 9.823 14.3646 9.73284 14.3407C9.63968 14.3162 9.55162 14.279 9.47059 14.2312C9.39228 14.1852 9.31944 14.1287 9.25442 14.0621C9.19874 14.0053 9.15041 13.9428 9.10985 13.8763C9.05437 13.7856 9.01237 13.6858 8.98664 13.5796C8.96541 13.4925 8.95585 13.404 8.95738 13.3162C8.95843 13.2487 8.96607 13.1809 8.98056 13.1137C9.00467 13.0014 9.0469 12.8958 9.10405 12.8001Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_2283_22406">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'guest'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2283_22411)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0029 3.33317C8.3921 3.33317 7.08626 4.63901 7.08626 6.24984C7.08626 7.86067 8.3921 9.1665 10.0029 9.1665C11.6138 9.1665 12.9196 7.86067 12.9196 6.24984C12.9196 4.63901 11.6138 3.33317 10.0029 3.33317ZM5.4196 6.24984C5.4196 3.71853 7.47162 1.6665 10.0029 1.6665C12.5342 1.6665 14.5863 3.71853 14.5863 6.24984C14.5863 8.78114 12.5342 10.8332 10.0029 10.8332C7.47162 10.8332 5.4196 8.78114 5.4196 6.24984ZM6.6696 13.3332C5.28888 13.3332 4.1696 14.4525 4.1696 15.8332V16.6665C4.1696 17.1267 3.7965 17.4998 3.33626 17.4998C2.87603 17.4998 2.50293 17.1267 2.50293 16.6665V15.8332C2.50293 13.532 4.36841 11.6665 6.6696 11.6665H13.3363C15.6374 11.6665 17.5029 13.532 17.5029 15.8332V16.6665C17.5029 17.1267 17.1298 17.4998 16.6696 17.4998C16.2094 17.4998 15.8363 17.1267 15.8363 16.6665V15.8332C15.8363 14.4525 14.717 13.3332 13.3363 13.3332H6.6696Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_2283_22411">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'passcode'"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2283_22416)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.96788 2.5H14.0321C14.4714 2.49999 14.8504 2.49997 15.1625 2.52548C15.492 2.55239 15.8197 2.61182 16.135 2.77249C16.6054 3.01217 16.9878 3.39462 17.2275 3.86503C17.3882 4.18034 17.4476 4.50802 17.4745 4.83748C17.5 5.14962 17.5 5.52858 17.5 5.96786V14.0321C17.5 14.4714 17.5 14.8504 17.4745 15.1625C17.4476 15.492 17.3882 15.8197 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.8197 17.3882 15.492 17.4476 15.1625 17.4745C14.8504 17.5 14.4714 17.5 14.0321 17.5H5.96786C5.52858 17.5 5.14962 17.5 4.83748 17.4745C4.50802 17.4476 4.18034 17.3882 3.86503 17.2275C3.39462 16.9878 3.01217 16.6054 2.77249 16.135C2.61182 15.8197 2.55239 15.492 2.52548 15.1625C2.49997 14.8504 2.49999 14.4714 2.5 14.0321V5.96788C2.49999 5.52859 2.49997 5.14962 2.52548 4.83748C2.55239 4.50802 2.61182 4.18034 2.77249 3.86503C3.01217 3.39462 3.39462 3.01217 3.86503 2.77249C4.18034 2.61182 4.50802 2.55239 4.83748 2.52548C5.14962 2.49997 5.52859 2.49999 5.96788 2.5ZM4.9732 4.18661C4.74681 4.2051 4.66288 4.2365 4.62168 4.2575C4.46487 4.33739 4.33739 4.46487 4.2575 4.62168C4.2365 4.66288 4.2051 4.74681 4.18661 4.9732C4.16732 5.20931 4.16667 5.51954 4.16667 6V14C4.16667 14.4805 4.16732 14.7907 4.18661 15.0268C4.2051 15.2532 4.2365 15.3371 4.2575 15.3783C4.33739 15.5351 4.46487 15.6626 4.62168 15.7425C4.66288 15.7635 4.74681 15.7949 4.9732 15.8134C5.20931 15.8327 5.51954 15.8333 6 15.8333H14C14.4805 15.8333 14.7907 15.8327 15.0268 15.8134C15.2532 15.7949 15.3371 15.7635 15.3783 15.7425C15.5351 15.6626 15.6626 15.5351 15.7425 15.3783C15.7635 15.3371 15.7949 15.2532 15.8134 15.0268C15.8327 14.7907 15.8333 14.4805 15.8333 14V6C15.8333 5.51954 15.8327 5.20931 15.8134 4.9732C15.7949 4.74681 15.7635 4.66288 15.7425 4.62168C15.6626 4.46487 15.5351 4.33739 15.3783 4.2575C15.3371 4.2365 15.2532 4.2051 15.0268 4.18661C14.7907 4.16732 14.4805 4.16667 14 4.16667H6C5.51954 4.16667 5.20931 4.16732 4.9732 4.18661ZM13.3333 6.66667C13.7936 6.66667 14.1667 7.03976 14.1667 7.5V12.5C14.1667 12.9602 13.7936 13.3333 13.3333 13.3333C12.8731 13.3333 12.5 12.9602 12.5 12.5V7.5C12.5 7.03976 12.8731 6.66667 13.3333 6.66667Z"
                    fill="#64748B"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.70834 10C7.70834 10.5753 7.24197 11.0417 6.66667 11.0417C6.09137 11.0417 5.625 10.5753 5.625 10C5.625 9.42471 6.09137 8.95833 6.66667 8.95833C7.24197 8.95833 7.70834 9.42471 7.70834 10ZM11.0417 10C11.0417 10.5753 10.5753 11.0417 10 11.0417C9.42471 11.0417 8.95834 10.5753 8.95834 10C8.95834 9.42471 9.42471 8.95833 10 8.95833C10.5753 8.95833 11.0417 9.42471 11.0417 10Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_2283_22416">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg
            v-if="icon === 'note'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_2283_22421)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V12.643C17.5 13.306 17.2366 13.9419 16.7678 14.4107L14.4107 16.7678C13.9419 17.2366 13.306 17.5 12.643 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5ZM13.3333 15.4882L15.4882 13.3333H14.1667C13.7064 13.3333 13.3333 13.7064 13.3333 14.1667V15.4882ZM15.8333 11.6667H14.1667C12.786 11.6667 11.6667 12.786 11.6667 14.1667V15.8333H5C4.53976 15.8333 4.16667 15.4602 4.16667 15V5C4.16667 4.53976 4.53976 4.16667 5 4.16667H15C15.4602 4.16667 15.8333 4.53976 15.8333 5V11.6667ZM6.66667 7.5C6.66667 7.03976 7.03976 6.66667 7.5 6.66667H12.5C12.9602 6.66667 13.3333 7.03976 13.3333 7.5C13.3333 7.96024 12.9602 8.33333 12.5 8.33333H7.5C7.03976 8.33333 6.66667 7.96024 6.66667 7.5ZM6.66667 10.8333C6.66667 10.3731 7.03976 10 7.5 10H9.16667C9.6269 10 10 10.3731 10 10.8333C10 11.2936 9.6269 11.6667 9.16667 11.6667H7.5C7.03976 11.6667 6.66667 11.2936 6.66667 10.8333Z"
                    fill="#64748B"
                />
            </g>
            <defs>
                <clipPath id="clip0_2283_22421">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="icon === 'award-bookings'"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 2C7.44772 2 7 2.44772 7 3V4H13V3C13 2.44772 12.5523 2 12 2H8ZM15 4V3C15 1.34315 13.6569 0 12 0H8C6.34315 0 5 1.34315 5 3V4H3C1.34315 4 0 5.34315 0 7V16C0 17.6569 1.34315 19 3 19H17C18.6569 19 20 17.6569 20 16V7C20 5.34315 18.6569 4 17 4H15ZM3 6C2.44772 6 2 6.44772 2 7V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V7C18 6.44772 17.5523 6 17 6H3Z"
                fill="currentColor"
            />
            <path
                d="M13.5001 14.9999C14.7403 14.9999 15.7696 14.0968 15.9662 12.9124C16.0097 12.6508 15.8948 12.3945 15.7072 12.207L13.793 10.2928C13.6055 10.1053 13.3493 9.99033 13.0876 10.0338C11.9032 10.2304 11.0001 11.2597 11.0001 12.4999C11.0001 13.8806 12.1194 14.9999 13.5001 14.9999Z"
                fill="currentColor"
            />
            <path
                d="M4.2056 10.8029C4.01671 10.284 4.28429 9.71012 4.80327 9.52123L7.78875 8.4346C8.30773 8.24571 8.88157 8.5133 9.07047 9.03228L9.45325 10.084C9.64214 10.6029 9.37456 11.1768 8.85558 11.3657L5.8701 12.4523C5.35112 12.6412 4.77728 12.3736 4.58838 11.8546L4.2056 10.8029Z"
                fill="currentColor"
            />
        </svg>
        <!-- Diamond/Luxury Icon -->
        <svg
            v-if="icon === 'luxury' || icon === 'diamond'"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            :class="svgClass"
        >
            <path
                d="M15.7181 3C16.4723 3.00003 17.1992 3.28439 17.7533 3.7959L22.1488 7.85352L22.2621 7.96387C23.4018 9.13097 23.402 11.0114 22.2347 12.1787L14.1215 20.293C12.9865 21.4279 11.1683 21.4634 9.9906 20.3994L9.8783 20.293L1.76502 12.1787C0.560321 10.974 0.599223 9.00925 1.85095 7.85352L6.24744 3.7959L6.46228 3.61426C6.98284 3.21719 7.62178 3.00007 8.28162 3H15.7181ZM8.28162 5C8.06162 5.00007 7.84868 5.07262 7.67517 5.20508L7.60388 5.26562L3.2074 9.32324C2.79047 9.70852 2.77764 10.3632 3.17908 10.7646L11.2933 18.8789L11.3685 18.9473C11.7613 19.2678 12.3412 19.2451 12.7074 18.8789L20.8207 10.7646C21.1971 10.3882 21.2093 9.7893 20.8656 9.39844L20.7924 9.32324L16.3959 5.26562C16.2112 5.09515 15.9695 5.00003 15.7181 5H8.28162ZM8.79334 7.29297C9.18388 6.90264 9.81694 6.90251 10.2074 7.29297C10.5977 7.68344 10.5977 8.31656 10.2074 8.70703L8.91443 10L10.2074 11.293L10.2758 11.3691C10.5959 11.7618 10.5733 12.341 10.2074 12.707C9.84117 13.0733 9.26131 13.096 8.86853 12.7754L8.79334 12.707L6.79334 10.707C6.40281 10.3165 6.40281 9.68349 6.79334 9.29297L8.79334 7.29297Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <svg
            v-if="icon === 'travel_portal'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 2C16.764 2 20.7481 5.33046 21.7549 9.78906C21.8764 10.3277 21.5377 10.8627 20.999 10.9844C20.4604 11.1059 19.9254 10.7681 19.8037 10.2295C19.2683 7.85816 17.6783 5.88733 15.5537 4.83203C16.2344 6.19648 16.7024 7.96541 16.8975 9.91211C16.9525 10.4616 16.5514 10.9517 16.002 11.0068C15.4526 11.0619 14.9625 10.6616 14.9072 10.1123C14.7153 8.19729 14.2432 6.58359 13.6387 5.48242C13.0042 4.32688 12.3888 4 12 4C11.7731 4 11.482 4.09945 11.1328 4.43164C10.7784 4.76891 10.4129 5.30403 10.085 6.04199C9.52351 7.30527 9.12806 9.03348 9.02637 11H11.5C12.0523 11 12.5 11.4477 12.5 12C12.5 12.5523 12.0523 13 11.5 13H9.02637C9.12806 14.9665 9.52351 16.6947 10.085 17.958C10.4129 18.696 10.7784 19.2311 11.1328 19.5684C11.482 19.9005 11.7731 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM4.06445 13C4.40263 15.7111 6.09575 17.9992 8.44629 19.167C8.38161 19.0373 8.31782 18.9055 8.25781 18.7705C7.56803 17.2185 7.1266 15.204 7.02344 13H4.06445ZM8.44629 4.83203C6.09555 5.99972 4.40265 8.28879 4.06445 11H7.02344C7.1266 8.79597 7.56803 6.7815 8.25781 5.22949C8.31794 5.09422 8.38147 4.96197 8.44629 4.83203Z"
                fill="currentColor"
            />
            <path
                d="M16.0099 15.3544L17.2549 19.9948C17.3198 20.2366 17.6445 20.2795 17.7699 20.0628L18.9585 18.0098C18.9709 17.9885 18.9885 17.9709 19.0098 17.9585L21.0628 16.7699C21.2795 16.6445 21.2366 16.3198 20.9948 16.2549L16.3544 15.0099C16.1452 14.9538 15.9538 15.1452 16.0099 15.3544Z"
                fill="currentColor"
            />
            <path
                d="M16.4365 14.0088L16.6133 14.0439L21.2539 15.2891C22.3555 15.5846 22.5505 17.0643 21.5635 17.6357L20.584 18.2021L22.2002 19.7861C22.5943 20.1727 22.6003 20.8058 22.2139 21.2002C21.8273 21.5943 21.1942 21.6003 20.7998 21.2139L19.1787 19.625L18.6357 20.5635C18.0643 21.5505 16.5846 21.3555 16.2891 20.2539L15.0439 15.6133C14.8045 14.7198 15.5563 13.8971 16.4365 14.0088ZM17.7715 18.0625L18.0928 17.5088L18.1758 17.3848C18.2663 17.2671 18.3795 17.1676 18.5088 17.0928L19.0625 16.7715L17.2979 16.2979L17.7715 18.0625Z"
                fill="currentColor"
            />
        </svg>

        <!-- CHART -->
        <svg
            v-if="icon === 'chart'"
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                d="M13.0501 4.16667V15.8333H15.8252V4.16667H13.0501ZM4.16667 15.8333H6.94173V13.3333H4.16667V15.8333ZM8.6084 15.8333H11.3835V8.75H8.6084V15.8333ZM17.4919 15.8333C17.4919 16.7537 16.7456 17.4999 15.8252 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V13.3333C2.5 12.4129 3.24619 11.6667 4.16667 11.6667H6.94173V8.75C6.94173 7.82953 7.68792 7.08333 8.6084 7.08333H11.3835V4.16667C11.3835 3.24619 12.1297 2.5 13.0501 2.5H15.8252C16.7456 2.50012 17.4919 3.24626 17.4919 4.16667V15.8333Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- GRID ADD ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'grid-add'"
        >
            <path
                d="M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C8.42047 2.5 9.16667 3.24619 9.16667 4.16667V7.5C9.16667 8.42047 8.42047 9.16667 7.5 9.16667H4.16667C3.24619 9.16667 2.5 8.42047 2.5 7.5V4.16667Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M10.8333 4.16667C10.8333 3.24619 11.5795 2.5 12.5 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V7.5C17.5 8.42047 16.7538 9.16667 15.8333 9.16667H12.5C11.5795 9.16667 10.8333 8.42047 10.8333 7.5V4.16667Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M2.5 12.5C2.5 11.5795 3.24619 10.8333 4.16667 10.8333H7.5C8.42047 10.8333 9.16667 11.5795 9.16667 12.5V15.8333C9.16667 16.7538 8.42047 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M14.1667 11.6667C14.1667 11.2064 14.5398 10.8333 15 10.8333C15.4602 10.8333 15.8333 11.2064 15.8333 11.6667V13.3333H17.5C17.9602 13.3333 18.3333 13.7064 18.3333 14.1667C18.3333 14.6269 17.9602 15 17.5 15H15.8333V16.6667C15.8333 17.1269 15.4602 17.5 15 17.5C14.5398 17.5 14.1667 17.1269 14.1667 16.6667V15H12.5C12.0398 15 11.6667 14.6269 11.6667 14.1667C11.6667 13.7064 12.0398 13.3333 12.5 13.3333H14.1667V11.6667Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>

        <!-- DRAG HANDLE ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'drag-handle'"
        >
            <circle cx="7.5" cy="4.5" r="1.5" fill="currentColor" :class="pathClass" />
            <circle cx="12.5" cy="4.5" r="1.5" fill="currentColor" :class="pathClass" />
            <circle cx="7.5" cy="10" r="1.5" fill="currentColor" :class="pathClass" />
            <circle cx="12.5" cy="10" r="1.5" fill="currentColor" :class="pathClass" />
            <circle cx="7.5" cy="15.5" r="1.5" fill="currentColor" :class="pathClass" />
            <circle cx="12.5" cy="15.5" r="1.5" fill="currentColor" :class="pathClass" />
        </svg>

        <!-- PEOPLES ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'peoples'"
        >
            <g clip-path="url(#clip0_peoples)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.5002 4.16732C12.5002 3.70708 12.8733 3.33398 13.3335 3.33398C15.4046 3.33398 17.0835 5.01292 17.0835 7.08398C17.0835 9.15505 15.4046 10.834 13.3335 10.834C12.8733 10.834 12.5002 10.4609 12.5002 10.0007C12.5002 9.54041 12.8733 9.16732 13.3335 9.16732C14.4841 9.16732 15.4168 8.23458 15.4168 7.08398C15.4168 5.93339 14.4841 5.00065 13.3335 5.00065C12.8733 5.00065 12.5002 4.62756 12.5002 4.16732Z"
                    fill="currentColor"
                    :class="pathClass"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.50016 5.00065C6.34957 5.00065 5.41683 5.93339 5.41683 7.08398C5.41683 8.23458 6.34957 9.16732 7.50016 9.16732C8.65076 9.16732 9.5835 8.23458 9.5835 7.08398C9.5835 5.93339 8.65076 5.00065 7.50016 5.00065ZM3.75016 7.08398C3.75016 5.01292 5.4291 3.33398 7.50016 3.33398C9.57123 3.33398 11.2502 5.01292 11.2502 7.08398C11.2502 9.15505 9.57123 10.834 7.50016 10.834C5.4291 10.834 3.75016 9.15505 3.75016 7.08398Z"
                    fill="currentColor"
                    :class="pathClass"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.00016 13.334C3.61945 13.334 2.50016 14.4533 2.50016 15.834V16.6673C2.50016 17.1276 2.12707 17.5007 1.66683 17.5007C1.20659 17.5007 0.833496 17.1276 0.833496 16.6673V15.834C0.833496 13.5328 2.69898 11.6673 5.00016 11.6673H10.0002C12.3013 11.6673 14.1668 13.5328 14.1668 15.834V16.6673C14.1668 17.1276 13.7937 17.5007 13.3335 17.5007C12.8733 17.5007 12.5002 17.1276 12.5002 16.6673V15.834C12.5002 14.4533 11.3809 13.334 10.0002 13.334H5.00016Z"
                    fill="currentColor"
                    :class="pathClass"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.9188 12.5007C14.9188 12.0404 15.2919 11.6673 15.7521 11.6673H15.8348C18.136 11.6673 20.0015 13.5328 20.0015 15.834V16.6673C20.0015 17.1276 19.6284 17.5007 19.1681 17.5007C18.7079 17.5007 18.3348 17.1276 18.3348 16.6673V15.834C18.3348 14.4533 17.2155 13.334 15.8348 13.334H15.7521C15.2919 13.334 14.9188 12.9609 14.9188 12.5007Z"
                    fill="currentColor"
                    :class="pathClass"
                />
            </g>
            <defs>
                <clipPath id="clip0_peoples">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <!-- POINTS UPDATE TYPE ICON -->
        <svg
            :width="width"
            :height="height"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
            v-if="icon === 'points-update-type'"
        >
            <path
                d="M9.16667 1.66602C10.8471 1.66602 12.4047 1.90759 13.5718 2.32438C14.1516 2.53145 14.6797 2.79789 15.0789 3.13493C15.4743 3.46879 15.8333 3.95461 15.8333 4.58268V8.12435C15.8333 8.75242 15.4743 9.23824 15.0789 9.5721C14.6797 9.90914 14.1516 10.1756 13.5718 10.3826C12.4047 10.7994 10.8471 11.041 9.16667 11.041C7.48621 11.041 5.92862 10.7994 4.76156 10.3826C4.55544 10.309 4.35627 10.2267 4.16667 10.1377V11.6514C4.17206 11.6674 4.20097 11.7317 4.32943 11.8402C4.52054 12.0015 4.84655 12.1846 5.32227 12.3545C6.26644 12.6917 7.62557 12.916 9.16667 12.916C9.6269 12.916 10 13.2891 10 13.7493C10 14.2096 9.6269 14.5827 9.16667 14.5827C7.48621 14.5827 5.92862 14.3411 4.76156 13.9243C4.55544 13.8507 4.35627 13.7684 4.16667 13.6794V15.4014C4.17206 15.4174 4.20097 15.4817 4.32943 15.5902C4.52054 15.7515 4.84655 15.9346 5.32227 16.1045C6.26644 16.4417 7.62557 16.666 9.16667 16.666C9.6269 16.666 10 17.0391 10 17.4993C10 17.9596 9.6269 18.3327 9.16667 18.3327C7.48621 18.3327 5.92862 18.0911 4.76156 17.6743C4.18175 17.4672 3.65362 17.2008 3.25439 16.8638C2.85901 16.5299 2.5 16.0441 2.5 15.416V4.58268C2.5 3.95461 2.85901 3.46879 3.25439 3.13493C3.65362 2.79789 4.18175 2.53145 4.76156 2.32438C5.92862 1.90759 7.48621 1.66602 9.16667 1.66602ZM14.1667 6.59603C13.9771 6.68508 13.7779 6.76737 13.5718 6.84098C12.4047 7.25778 10.8471 7.49935 9.16667 7.49935C7.48621 7.49935 5.92862 7.25778 4.76156 6.84098C4.55544 6.76737 4.35627 6.68508 4.16667 6.59603V8.1097C4.17206 8.1257 4.20097 8.19004 4.32943 8.2985C4.52054 8.45987 4.84655 8.64293 5.32227 8.81283C6.26644 9.15 7.62557 9.37435 9.16667 9.37435C10.7078 9.37435 12.0669 9.15 13.0111 8.81283C13.4868 8.64293 13.8128 8.45987 14.0039 8.2985C14.1324 8.19004 14.1613 8.1257 14.1667 8.1097V6.59603ZM9.16667 3.33268C7.62557 3.33268 6.26644 3.55703 5.32227 3.89421C4.84655 4.0641 4.52054 4.24716 4.32943 4.40853C4.22562 4.49618 4.1865 4.55495 4.17236 4.58268C4.1865 4.61041 4.22562 4.66918 4.32943 4.75684C4.52054 4.91821 4.84655 5.10126 5.32227 5.27116C6.26644 5.60834 7.62557 5.83268 9.16667 5.83268C10.7078 5.83268 12.0669 5.60834 13.0111 5.27116C13.4868 5.10126 13.8128 4.91821 14.0039 4.75684C14.1073 4.66953 14.1459 4.61055 14.1602 4.58268C14.1459 4.55482 14.1073 4.49584 14.0039 4.40853C13.8128 4.24716 13.4868 4.0641 13.0111 3.89421C12.0669 3.55703 10.7078 3.33268 9.16667 3.33268Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M11.6667 14.166V12.2553C11.6667 11.8841 12.1155 11.6982 12.378 11.9606L14.7054 14.2881C14.9679 14.5505 14.782 14.9993 14.4107 14.9993H12.5C12.0398 14.9993 11.6667 14.6263 11.6667 14.166Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M18.3333 17.4993V19.4101C18.3333 19.7813 17.8845 19.9672 17.622 19.7047L15.2946 17.3773C15.0321 17.1148 15.218 16.666 15.5893 16.666H17.5C17.9602 16.666 18.3333 17.0391 18.3333 17.4993Z"
                fill="currentColor"
                :class="pathClass"
            />
            <path
                d="M11.8669 15.8652C12.2817 15.7464 12.7136 15.9636 12.8703 16.356L12.9533 16.605C13.2655 17.4326 14.0655 18.0202 15.0008 18.0202C15.5587 18.0202 16.078 17.8121 16.4722 17.4692C16.8194 17.1673 17.3461 17.2042 17.6481 17.5514C17.9501 17.8987 17.9131 18.4254 17.5659 18.7274C16.8795 19.3244 15.975 19.6868 15.0008 19.6868C13.2399 19.6868 11.757 18.5065 11.2956 16.8955C11.1689 16.4531 11.4245 15.992 11.8669 15.8652ZM15.0008 11.9785C16.7618 11.9785 18.2446 13.1589 18.7061 14.7699C18.8327 15.2122 18.5771 15.6733 18.1348 15.8001C17.6923 15.9268 17.2304 15.6713 17.1037 15.2288C16.8416 14.3138 15.9984 13.6452 15.0008 13.6452C14.3816 13.6452 13.81 13.9011 13.4049 14.3125C13.0821 14.6405 12.5545 14.6443 12.2266 14.3215C11.8987 13.9986 11.8948 13.471 12.2176 13.1431C12.9251 12.4245 13.9201 11.9785 15.0008 11.9785Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
    </div>
</template>
<script setup>
defineProps({
    icon: {
        type: String,
        required: true,
    },
    svgClass: {
        type: String,
        default: 'fill-none',
    },
    pathClass: {
        type: String,
        default: 'fill-current',
    },
    width: {
        type: [Number, String],
        default: 20,
    },
    height: {
        type: [Number, String],
        default: 20,
    },
    size: {
        type: String,
        default: 'medium',
    },
    containerClass: {
        type: String,
        default: 'flex items-center justify-center',
    },
});
</script>
